webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "base", function() { return base; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(111);





var base = function base(Language) {
  var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(Language)[0];
  return {
    data: function data() {
      return {
        resData: ""
      };
    },
    mounted: function mounted() {},

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, function () {
      return this.translate(this.LANGUAGE, Language[key]);
    }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(["USER", "LANGUAGE", "PAGEMAXINDEX"])),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      getAjaxData: function getAjaxData(ajax, params, field) {
        var _this = this;

        this.$http(ajax, {
          //       this.getAjaxData(URL_FINDUSER,{"user_id":"1"},"msg")
          params: params
        }).then(function (res) {
          _this.resData = res.data;
        });
      }
    }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(["SAVEUSER", "SAVELANGUAGE", "SAVEPAGEMAXINDEX"])),
    watch: {}
  };
};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return URL_ROLELOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return URL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return URL_USERLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return URL_ROLELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return URL_FUNCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return URL_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return URL_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return URL_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return URL_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return URL_AUDITLOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return URL_PROFITREPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return URL_OPENDEAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return URL_TIMEDIFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return URL_BBOOKREPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return URL_CLIENT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return URL_CLOSED_TARDES_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return URL_SECURITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return URL_SYMBOL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return URL_GROUP_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return URL_MT4_CLOSED_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return URL_MT4_DEPOSIT_WITHDRAWL_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return URL_CREDIT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return URL_SUMMARY_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return URL_SEREGATED_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return URL_EQUITY_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return URL_PROFITLOSS_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URL_ACCOUNT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return URL_EQUITY_MULTI_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return URL_MANAGER_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return URL_ANALYZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return URL_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return URL_SYMBOL_PROFIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return URL_PROFIT_TOP_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return URL_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return URL_FLOATING_PL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return URL_OPEN_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return URL_HANDLE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return URL_GET_MONOTOR_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return URL_CHECK_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return URL_MANAGER_OPERATE_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return URL_LOGIN_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return URL_ADDORUPDATE_POSITION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return URL_DELETE_POSITION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return URL_GET_POSITION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return URL_ADDORUPDATE_LEVERAGE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return URL_DELETE_LEVERAGE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return URL_GET_LEVERAGE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return URL_ADDORUPDATE_DIVIDENDS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return URL_DELETE_DIVIDENDS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return URL_GET_DIVIDENDS_CONFIG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(49);


var URL_ROLELOGIN = createUrl('user/login'); // 登录
var URL_LIST = createUrl('user/list'); // 获取权限列表
var URL_USERLIST = createUrl('user/userlist'); // 获取用户列表
var URL_ROLELIST = createUrl('role/rolelist'); // 获取角色列表
var URL_FUNCS = createUrl('role/funcs'); // 获取功能列表
var URL_USER = createUrl('user/user'); // 添加用户/删除用户/修改用户
var URL_ROLE = createUrl('role/role'); // 添加角色/删除角色/修改角色
var URL_LOGOUT = createUrl('user/logout'); // 登出
var URL_PASSWORD = createUrl('user/password'); // 修改密码
var URL_AUDITLOG = createUrl('log/auditlog');
var URL_PROFITREPORT = createUrl('report/dayTrade');
var URL_OPENDEAL = createUrl('report/position');
var URL_TIMEDIFF = createUrl('report/timeDiff');
var URL_BBOOKREPORT = createUrl('report/bbook');
var URL_CLIENT_REPORT = createUrl('report/client');

var URL_CLOSED_TARDES_REPORT = createUrl('mt4/tradeWorth');
var URL_SECURITY = createUrl('mt4/securities');
var URL_SYMBOL_LIST = createUrl('mt4/symbolList');
var URL_GROUP_LIST = createUrl('mt4/groupList');
var URL_MT4_CLOSED_REPORT = createUrl('mt4/closedOrder');
var URL_MT4_DEPOSIT_WITHDRAWL_REPORT = createUrl('mt4/depositWithdrawl');
var URL_CREDIT_REPORT = createUrl('mt4/credit');
var URL_SUMMARY_REPORT = createUrl('mt4/summary');
var URL_SEREGATED_REPORT = createUrl('mt4/seregated');
var URL_EQUITY_REPORT = createUrl('mt4/equity');
var URL_PROFITLOSS_REPORT = createUrl('mt4/profitloss');
var URL_ACCOUNT_REPORT = createUrl('mt4/account');
var URL_EQUITY_MULTI_REPORT = createUrl('mt4/multiEquity');
var URL_MANAGER_CHECK = createUrl('mt4/check');
var URL_ANALYZE = createUrl('mt4/analyze');
var URL_DOWNLOAD = createUrl('mt4/download');
var URL_SYMBOL_PROFIT = createUrl('mt4/symbolProfit');
var URL_PROFIT_TOP_LIST = createUrl('mt4/profitTopList');
var URL_SEARCH = createUrl('mt4/search');
var URL_FLOATING_PL = createUrl('mt4/floatingPL');
var URL_OPEN_TRADES = createUrl('mt4/positionStatistics');

var URL_HANDLE_ACCOUNT = createUrl('report/handleAccount');
var URL_GET_MONOTOR_ACCOUNT = createUrl('report/monitorAccount');
var URL_CHECK_TRADES = createUrl('report/checkTrades');
var URL_MANAGER_OPERATE_LOG = createUrl('report/operateRecord');
var URL_LOGIN_RECORD = createUrl('report/loginRecord');

var URL_ADDORUPDATE_POSITION_CONFIG = createUrl('position/addOrUpdateConfig');
var URL_DELETE_POSITION_CONFIG = createUrl('position/deleteConfig');
var URL_GET_POSITION_CONFIG = createUrl('position/getConfig');

var URL_ADDORUPDATE_LEVERAGE_CONFIG = createUrl('leverage/addOrUpdateConfig');
var URL_DELETE_LEVERAGE_CONFIG = createUrl('leverage/deleteConfig');
var URL_GET_LEVERAGE_CONFIG = createUrl('leverage/getConfig');

var URL_ADDORUPDATE_DIVIDENDS_CONFIG = createUrl('dividends/addOrUpdateConfig');
var URL_DELETE_DIVIDENDS_CONFIG = createUrl('dividends/deleteConfig');
var URL_GET_DIVIDENDS_CONFIG = createUrl('dividends/getConfig');

function createUrl(childRoute) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["b" /* server */] + childRoute;
}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reuseTable_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_133d1458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reuseTable_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-133d1458"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reuseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_133d1458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reuseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = format;
/* unused harmony export getDayStr */
/* harmony export (immutable) */ __webpack_exports__["k"] = getToDay;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCurrentMT4Time;
/* harmony export (immutable) */ __webpack_exports__["l"] = getWeekStartAndEnd;
/* harmony export (immutable) */ __webpack_exports__["j"] = getMonthStartAndEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = disableDate;
/* harmony export (immutable) */ __webpack_exports__["n"] = onPick;
/* harmony export (immutable) */ __webpack_exports__["d"] = enableMondayAndFriday;
/* harmony export (immutable) */ __webpack_exports__["e"] = enableMondayAndFridayOnPick;
/* harmony export (immutable) */ __webpack_exports__["b"] = enableFirstAndLastDayOfMonth;
/* harmony export (immutable) */ __webpack_exports__["c"] = enableFirstAndLastDayOfMonthOnPick;
/* harmony export (immutable) */ __webpack_exports__["f"] = enableUntilToday;
/* harmony export (immutable) */ __webpack_exports__["g"] = enableUntilTodayOnPick;
/* harmony export (immutable) */ __webpack_exports__["m"] = makeSound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function format(time) {
    return time ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('YYYY-MM-DD HH:mm:ss') : '';
}

//获取当前日期yy-mm-dd
//date 为时间对象
function getDayStr(date) {
    var year = "";
    var month = "";
    var day = "";
    var now = date;
    year = "" + now.getFullYear();
    if (now.getMonth() + 1 < 10) {
        month = "0" + (now.getMonth() + 1);
    } else {
        month = "" + (now.getMonth() + 1);
    }
    if (now.getDate() < 10) {
        day = "0" + now.getDate();
    } else {
        day = "" + now.getDate();
    }
    return year + "-" + month + "-" + day + " 00:00:00";
}
var timeZone = -(new Date().getTimezoneOffset() / 60);
/**
 * 
 */
function getToDay(diff) {
    var startStop = new Array();
    // 一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    // 获取当前MT4时间
    var currentDate = getCurrentMT4Time(diff);
    // 获取明天MT4时间
    var tomorrow = new Date(currentDate.getTime() + millisecond);

    startStop.push(getDayStr(currentDate));
    startStop.push(getDayStr(tomorrow));
    return startStop;
}

function getCurrentMT4Time(diff) {
    // 获取当前时间 
    var date = new Date().getTime();
    // 获取当前MT4时间
    return new Date(date - (timeZone - diff) * 36e5);
}

/** 
 * 获得相对当前周AddWeekCount个周的起止日期 
 * AddWeekCount为0代表当前周   为-1代表上一个周   为1代表下一个周以此类推
 * **/
function getWeekStartAndEnd(AddWeekCount, diff) {
    //起止日期数组   
    var startStop = new Array();
    //一天的毫秒数   
    var millisecond = 1000 * 60 * 60 * 24;
    //获取当前时间   
    var currentDate = new Date();
    //相对于当前日期AddWeekCount个周的日期
    currentDate = new Date(currentDate.getTime() + millisecond * 7 * AddWeekCount - (timeZone - diff) * 36e5);
    //返回date是一周中的某一天
    var week = currentDate.getDay();
    //减去的天数   
    var minusDay = week != 0 ? week : 7;
    //获得当前周的第一天   
    var currentWeekFirstDay = new Date(currentDate.getTime() - millisecond * minusDay);
    //获得下周的第一天
    var currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + millisecond * 7);
    //添加至数组   
    startStop.push(getDayStr(currentWeekFirstDay));
    startStop.push(getDayStr(currentWeekLastDay));

    return startStop;
}
/** 
 * 获得相对当月AddMonthCount个月的起止日期 
 * AddMonthCount为0 代表当月 为-1代表上一个月  为1代表下一个月 以此类推
 * ***/
function getMonthStartAndEnd(AddMonthCount, diff) {
    //起止日期数组   
    var startStop = new Array();
    //获取当前时间   
    var currentDate = new Date();
    var month = currentDate.getMonth() + AddMonthCount;
    if (month < 0) {
        var n = parseInt(-month / 12);
        month += n * 12;
        currentDate.setFullYear(currentDate.getFullYear() - n);
    }
    currentDate = new Date(currentDate.setMonth(month));
    currentDate = new Date(currentDate.getTime() - (timeZone - diff) * 36e5);
    //获得当前月份0-11   
    var currentMonth = currentDate.getMonth();
    //获得当前年份4位年   
    var currentYear = currentDate.getFullYear();
    //获得本月的第一天   
    var currentMonthFirstDay = new Date(currentYear, currentMonth, 1);
    //获得下个月的第一天   
    var currentMonthLastDay = new Date(currentYear, currentMonth + 1, 1);
    //添加至数组   
    startStop.push(getDayStr(currentMonthFirstDay));
    startStop.push(getDayStr(currentMonthLastDay));
    //返回   
    return startStop;
}

function disableDate(time) {
    return time.getTime() > new Date();
}

function onPick(property) {
    var minDate = property.minDate;
    if (!property.maxDate && property.minDate) {
        var minAfter = this.$moment(minDate).add(1, 'month');
        var now = this.$moment();
        var max = now.isAfter(minAfter) ? minAfter : now;
        var minBefore = this.$moment(minDate).subtract(1, 'month');
        this.disabledDate = function (time) {
            return time.getTime() > new Date(max) || time.getTime() < new Date(minBefore);
        };
    }
}
/**
 * el-date-picker控件只可选周一和周五
 * 如果目前时间还没到周六，最多只能选上周一和周五
 * @param {*} time 
 * @returns 
 */
function enableMondayAndFriday(time) {
    var now = new Date();
    var weekday = now.getDay() + 1;
    var seconds = weekday > 6 ? 1 : (weekday + 1) * 24 * 36e5;
    now.setTime(now.getTime() - seconds);
    return time.getTime() > now || [0, 2, 3, 4, 6].includes(time.getDay());
}

/**
 * el-date-picker控件只可选周一和周五的onPick函数，限制第二选择只能选择当前选择周的周一或周五
 * @param {*} property 
 */
function enableMondayAndFridayOnPick(property) {
    var minDate = property.minDate;
    if (!property.maxDate && minDate) {
        var isMonday = minDate.getDay() === 1;
        var difference = isMonday ? 4 : -4;
        var required = this.$moment(minDate).add(difference, 'd');
        var max = isMonday ? new Date(required) : minDate;
        var min = isMonday ? minDate : new Date(required);
        this.disabledDate = function (time) {
            return time.getTime() < min || time.getTime() > max || time.getTime() > min && time.getTime() < max;
        };
    }
}

/**
 * el-date-picker控件只能选择每月1号，最多只能选上月1号
 * @param {*} time 
 * @returns 
 */
function enableFirstAndLastDayOfMonth(time) {
    var now = new Date();
    var monthDay = now.getDate();
    var seconds = monthDay * 24 * 36e5;
    now.setTime(now.getTime() - seconds);
    return time.getTime() > now || time.getDate() !== 1;
}

/**
 * el-date-picker控件只能选每月1号的onPick函数，限制第二选择只能选当前选择月的月头和月尾
 * @param {*} property 
 */
function enableFirstAndLastDayOfMonthOnPick(property) {
    var minDate = property.minDate;
    if (!property.maxDate && minDate) {
        var daysOneMonth = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0).getDate();
        var required = this.$moment(minDate).add(daysOneMonth - 1, 'd');
        var max = new Date(required);
        this.disabledDate = function (time) {
            return time.getTime() < minDate || time.getTime() > max || time.getTime() > minDate && time.getTime() < max;
        };
    }
}

/**
 * el-date-picker控件只能选择截止到今日且除周六日的日期
 * @param {*} time 
 * @returns 
 */
function enableUntilToday(time) {
    var now = new Date();
    now.setTime(now.getTime() - 24 * 36e5);
    return time.getTime() > now || [0, 6].includes(time.getDay());
}

/**
 * el-date-picker控件只能选择截止到今日且除周六日的日期的onPick函数，限制第二选择和第一选择一样
 * @param {*} property 
 */
function enableUntilTodayOnPick(property) {
    var minDate = property.minDate;
    if (!property.maxDate && minDate) {
        this.disabledDate = function (time) {
            return time.getTime() < minDate || time.getTime() > minDate;
        };
    }
}

function makeSound() {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    var audioCtx = new AudioContext();
    var oscillator = audioCtx.createOscillator();
    var gainNode = audioCtx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    gainNode.gain.value = 1;
    oscillator.type = 'sine';
    oscillator.frequency.value = 1000;
    oscillator.start(audioCtx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 3);
    oscillator.stop(audioCtx.currentTime + 3);
}

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return server; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
var server = "https://pj-dealingreport-api-dev.agile168.com/";
var days = 7;

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputModel_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b57218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputModel_vue__ = __webpack_require__(711);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13b57218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputModel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b57218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputModel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





//import MultiLanguage from 'vue-multilanguage'





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */], { fieldsBagName: 'fieldBags' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_8_moment___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */];

// 引入翻译
__webpack_require__(897);
__webpack_require__(175); //  兼容ie9

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (vm);

/***/ }),
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(111);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["USER", "LANGUAGE", "PAGEMAXINDEX"])),
  mounted: function mounted() {
    this.SAVELANGUAGE(localStorage.language || "cn");
    this.SAVEPAGEMAXINDEX(localStorage.pageMaxIndex || 0);
    this.SAVEUSER(sessionStorage.user);
    if (!this.USER || this.USER == 'undefined') {
      // this.$router.push("/login")
      this.$router.push(this.$route.query.link ? '/login?link=' + this.$route.query.link : '/login');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["SAVELANGUAGE", "SAVEUSER", "SAVEPAGEMAXINDEX"]))
});

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_login__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_mainView__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_userMaintenance_userMaintenance__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_roleMaintenance_roleMaintenance__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_auditLog_auditLog__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_unenabled__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_changePassword_changePassword__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_userMaintenance_userEdit__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_userMaintenance_addUser__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_roleMaintenance_addRole__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_roleMaintenance_roleEdit__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__manager_report__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__record__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__report__ = __webpack_require__(785);




















// V3.1.0版本里面新增功能：push和replace方法会返回一个promise, 你可能在控制台看到未捕获的异常
// 虽然不影响运行，但是看起来不太美观,下面代碼是解決方案:

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return originalPush.call(this, location).catch(err => err)
// }

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        redirect: '/login'
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__views_login__["a" /* default */]
    }, {
        path: '/unenabled',
        component: __WEBPACK_IMPORTED_MODULE_8__views_unenabled__["a" /* default */]
    }, {
        path: '/mainView',
        component: __WEBPACK_IMPORTED_MODULE_4__views_mainView__["a" /* default */],
        children: [{ path: '/userMaintenance', component: __WEBPACK_IMPORTED_MODULE_5__views_userMaintenance_userMaintenance__["a" /* default */] }, { path: '/roleMaintenance', component: __WEBPACK_IMPORTED_MODULE_6__views_roleMaintenance_roleMaintenance__["a" /* default */] }, { path: '/changePassword', component: __WEBPACK_IMPORTED_MODULE_9__views_changePassword_changePassword__["a" /* default */] }, { path: '/auditLog', component: __WEBPACK_IMPORTED_MODULE_7__views_auditLog_auditLog__["a" /* default */] }, { path: '/userEdit', component: __WEBPACK_IMPORTED_MODULE_10__views_userMaintenance_userEdit__["a" /* default */] }, { path: '/addUser', component: __WEBPACK_IMPORTED_MODULE_11__views_userMaintenance_addUser__["a" /* default */] }, { path: '/addRole', component: __WEBPACK_IMPORTED_MODULE_12__views_roleMaintenance_addRole__["a" /* default */] }, { path: '/roleEdit', component: __WEBPACK_IMPORTED_MODULE_13__views_roleMaintenance_roleEdit__["a" /* default */] }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__manager_report__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__record__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__report__["a" /* default */]))
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.meta.showInCrumb && !sessionStorage.getItem('token')) {
        next({ path: '/managerAuth', query: { nextUrl: to.fullPath } });
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uiv__ = __webpack_require__(55);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ loginLan: "login" })],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2_uiv__["d" /* Modal */]
  },
  data: function data() {
    return {
      formValue: { // admin password
        name: "",
        password: ""
      },
      modalShow: false,
      lang: localStorage.language ? localStorage.language : 'cn',
      errTips: ''
    };
  },

  computed: {},
  methods: {
    loginFn: function loginFn() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_api_api_js__["O" /* URL_ROLELOGIN */], { username: this.formValue.name, password: this.formValue.password }).then(function (res) {
        if (res.data.code === 200 && res.data.msg === 'OK') {
          _this.SAVEUSER(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ name: res.data.data.login, isSuper: res.data.data.isSuper }));
          _this.$router.push({ path: '/mainView' });
        } else {
          _this.modalShow = true;
          if (res.data.msg == 'disabled user') _this.errTips = _this.loginLan.tips.disabledUser;else _this.errTips = _this.loginLan.tips.loginErr;
        }
      }).catch(function (e) {
        alert(e);
      });
    },
    changeLanguage: function changeLanguage(language) {
      this.SAVELANGUAGE(language);
      localStorage.language = language;
    }
  },
  watch: {},
  created: function created() {
    sessionStorage.curSideBar = '';
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_aHeader__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_crumbs__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_api_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    aheader: __WEBPACK_IMPORTED_MODULE_1_components_aHeader__["a" /* default */],
    crumbs: __WEBPACK_IMPORTED_MODULE_2_components_crumbs__["a" /* default */]
  },
  mixins: [__webpack_require__(2).base({ mainViewLan: 'mainView' })],
  data: function data() {
    return {
      fnListKeys: [], // 存储当前role对应的fuction
      allList: false, // 如果当前role有所有的function则为true
      currentSideBar: '',
      responseFnlist: [],
      managerLogin: ''
    };
  },

  computed: {
    fnList: function fnList() {
      // 目前页面上所有的侧边导航
      var sider = this.mainViewLan.sidebarList;
      return [{ text: sider.dayTradeReport, id: 'FN_REPORT1', link: '/dayTradeReport', icon: 'fa fa-list', childrenLink: [] }, { text: sider.positionReport, id: 'FN_REPORT2', link: '/positionReport', icon: 'fa fa fa-th', childrenLink: [] }, { text: sider.bBookReport, id: 'FN_REPORT3', link: '/bBookReport', icon: 'fa fa-th-list', childrenLink: [] }, { text: sider.clientReport, id: 'FN_CLIENT_REPORT', link: '/clientReport', icon: 'fa fa-table', childrenLink: [] }, { text: sider.closedTradesReport, id: 'FN_CLOSED_TRADES_REPORT', link: '/closedTradesReport', icon: 'fa fa-money', childrenLink: [] }, { text: sider.monitorAccounts, id: 'FN_MONITOR_ACCOUNTS', link: '/monitorAccountsReport', icon: 'fa fa-eye', childrenLink: [] }, { text: sider.managerOperateRecord, id: 'FN_MANAGER_OPERATE_LOG', link: '/managerOperateRecord', icon: 'fa fa-book', childrenLink: [] }, { text: sider.loginRecord, id: 'FN_LOGIN_RECORD', link: '/loginRecord', icon: 'fa fa-book', childrenLink: [] }, { text: sider.autoPositionReportConfig, id: 'FN_POSITION_REPORT_CONFIG', link: '/autoPositionReport', icon: 'fa fa-book', childrenLink: [] }, { text: sider.autoUpdateLeverage, id: 'FN_UPDATE_LEVERAGE_CONFIG', link: '/autoUpdateLeverage', icon: 'fa fa-book', childrenLink: [] }, { text: sider.chargeDividends, id: 'FN_CHARGE_DIVIDENDS_CONFIG', link: '/chargeDividends', icon: 'fa fa-book', childrenLink: [] }, { text: sider.floatingPL, id: 'FN_FLOATING_PL', link: '/floatingPLReport', icon: 'fa fa-university', childrenLink: [] }, { text: sider.openTradeStat, id: 'FN_OPEN_TRADES', link: '/openTradesReport', icon: 'fa fa-plus', childrenLink: [] }, { text: sider.accountAnalyze, id: 'FN_ACCOUNT_ANALYZE', link: '/accountAnalyzeReport', icon: 'fa fa-users', childrenLink: [] }, { text: sider.symbolProfit, id: 'FN_SYMBOL_PROFIT', link: '/symbolProfitReport', icon: 'fa fa-bar-chart', childrenLink: [] }, { text: sider.profitTopList, id: 'FN_PROFIT_TOP_LIST', link: '/profitTopList', icon: 'fa fa-trophy', childrenLink: [] }, { text: sider.downloadReport, id: 'FN_DOWNLOAD_REPORT', link: '/downloadReport', icon: 'fa fa-download', childrenLink: [] }, { text: sider.mt4ClosedTradesReport, id: 'FN_MT4_CLOSED_TRADES_REPORT', link: '/mt4ClosedTradesReport', icon: 'fa fa-area-chart', childrenLink: [] }, { text: sider.mt4DepositWithdrawlReport, id: 'FN_MT4_DEPOSIT_WITHDRAWL_REPORT', link: '/mt4DepositWithdrawlReport', icon: 'fa fa-line-chart', childrenLink: [] }, { text: sider.mt4CreditReport, id: 'FN_MT4_CREDIT_REPORT', link: '/mt4CreditReport', icon: 'fa fa-credit-card', childrenLink: [] }, { text: sider.mt4SummaryReport, id: 'FN_MT4_SUMMARY_REPORT', link: '/mt4SummaryReport', icon: 'fa fa-pie-chart', childrenLink: [] }, { text: sider.mt4SeregatedReport, id: 'FN_MT4_SEREGATED_REPORT', link: '/mt4SeregatedReport', icon: 'fa fa-exchange', childrenLink: [] }, { text: sider.mt4EquityReport, id: 'FN_MT4_EQUITY_REPORT', link: '/mt4EquityReport', icon: 'fa fa-usd', childrenLink: [] }, { text: sider.mt4EquityMultiReport, id: 'FN_MT4_EQUITY_MULTI_REPORT', link: '/mt4EquityMultiReport', icon: 'fa fa-usd', childrenLink: [] }, { text: sider.mt4ProfitLossReport, id: 'FN_MT4_PROFIT_AND_LOSS_REPORT', link: '/mt4ProfitLossReport', icon: 'fa fa-balance-scale', childrenLink: [] }, { text: sider.mt4AccountReport, id: 'FN_MT4_ACCOUNT_REPORT', link: '/mt4AccountReport', icon: 'fa fa-user', childrenLink: [] }, { text: sider.userMaintenance, id: 'FN_USER_MAINTENANCE', link: '/userMaintenance', icon: 'fa fa-user-circle-o', childrenLink: ['/userEdit', '/addUser'] }, { text: sider.roleMaintenance, id: 'FN_ROLE_MAINTENANCE', link: '/roleMaintenance', icon: 'fa fa-user-circle', childrenLink: ['/addRole', '/roleEdit'] }, { text: sider.auditLog, id: 'FN_AUDIT_LOG', link: '/auditLog', icon: 'fa fa-pencil-square-o', childrenLink: [] }, { text: sider.changePassword, id: 'FN_CHANGE_PASSWORD', link: '/changePassword', icon: 'fa fa-cog', childrenLink: [] }];
    },
    user: function user() {
      // 当前登录的user
      return JSON.parse(sessionStorage.user);
    },
    activeItem: function activeItem() {
      // crumbs所需要的当前活动的侧边导航信息
      var obj = {
        ct: '',
        cicon: ''
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.fnList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.id == this.currentSideBar) {
            obj.ct = item.text;
            obj.cicon = item.icon;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return obj;
    },
    viewReadOnly: function viewReadOnly() {
      // 当前页面是否只读
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.responseFnlist), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (this.currentSideBar === item.functionID) return item.readOnly;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    managerAccount: function managerAccount() {
      return this.managerLogin;
    },
    desc: function desc() {
      var current = this.mainViewLan.currentManLogin;
      var exit = this.mainViewLan.exit;
      return { current: current, exit: exit };
    }
  },
  methods: {
    getFunctionList: function getFunctionList() {
      var _this = this;

      // 获取fnList
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["z" /* URL_LIST */]).then(function (res) {
        _this.responseFnlist = res.data.data;
        if (_this.user.isSuper == true) {
          // 如果 后台返回空数组表示改角色拥有全部function
          _this.allList = true;
          _this.fnListKeys = [];
          if (_this.$route.path !== '/mainView') _this.handleChangeUrl(_this.$route.path); // 判断是否是授权页面
          if (!sessionStorage.curSideBar) {
            // 如果sessionStorage.curSideBar 为空时，则默认保存，第一个被授权的，侧边导航为，当前选中的导航
            _this.saveSideBar(_this.fnList[0].id, _this.fnList[0].link);
          } else {
            // 否则就选中 sessionStorage.curSideBar 里面保存的导航
            _this.currentSideBar = sessionStorage.curSideBar;
          }
        } else if (_this.user.isSuper == false) {
          // 否则 遍历该数组去掉重复项
          _this.allList = false;
          var obj = {};
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              if (!obj[item.functionID]) {
                _this.fnListKeys.push(item.functionID);
                obj[item.functionID] = 1;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (_this.$route.path !== '/mainView') _this.handleChangeUrl(_this.$route.path); // 判断是否是授权页面
          if (!sessionStorage.curSideBar) {
            // 如果sessionStorage.curSideBar 为空时，则默认保存，第一个被授权的，侧边导航为，当前选中的导航
            var enableFnList = _this.fnList.filter(function (v) {
              return _this.fnListKeys.includes(v.id);
            });
            _this.saveSideBar(enableFnList[0].id, enableFnList[0].link);
          } else {
            // 否则就选中 sessionStorage.curSideBar 里面保存的导航
            _this.currentSideBar = sessionStorage.curSideBar;
          }
        }
      });
    },
    saveSideBar: function saveSideBar(item) {
      var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // 保存当前侧边导航，并跳转到新的路由地址
      sessionStorage.curSideBar = item;
      this.currentSideBar = item;
      link && this.$router.push(link);
    },
    handleChangeUrl: function handleChangeUrl(link) {
      // 处理在浏览器地址栏输入url时,判断是否是授权页面
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.fnList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var fn = _step4.value;

          if (link === fn.link && (this.fnListKeys.includes(fn.id) || this.allList)) return this.saveSideBar(fn.id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.fnList), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _fn = _step5.value;

          if (_fn.childrenLink.includes(link) && (this.fnListKeys.includes(_fn.id) || this.allList)) return this.saveSideBar(_fn.id);
        }
        //this.$router.push("/unenabled");
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    logoutFn: function logoutFn() {
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["B" /* URL_LOGOUT */]);
      this.$router.push('/login');
    },
    getManLogin: function getManLogin() {
      var jwt = sessionStorage.getItem('token');
      if (!jwt) return jwt;
      var str = decodeURIComponent(escape(window.atob(jwt.split('.')[1])));
      return JSON.parse(str).login.toString();
    },
    exit: function exit() {
      sessionStorage.removeItem('token');
      this.$router.push({
        path: '/managerAuth',
        query: { nextUrl: this.$route.fullPath }
      });
    },
    getMT4Timezone: function getMT4Timezone() {
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["V" /* URL_TIMEDIFF */]).then(function (res) {
        sessionStorage.setItem('MT4TimeZone', res.data.data.diff);
      });
    }
  },
  watch: {
    $route: function $route(newRoute) {
      this.managerLogin = newRoute.meta.showInCrumb ? this.getManLogin() : '';
    }
  },
  created: function created() {
    if (this.user && this.user !== 'undefined') {
      if (!sessionStorage.getItem('MT4TimeZone')) this.getMT4Timezone();
      this.getFunctionList();
      this.managerLogin = this.$route.meta.showInCrumb ? this.getManLogin() : '';
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uiv__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ headerLan: "header" })],
  data: function data() {
    return {};
  },

  computed: {
    languageImage: function languageImage() {
      return "/static/images/flags/" + this.LANGUAGE + ".png";
    },
    userName: function userName() {
      return JSON.parse(sessionStorage.user).name;
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0_uiv__["c" /* Dropdown */]
  },
  methods: {
    changeLanguage: function changeLanguage(language) {
      this.SAVELANGUAGE(language);
      localStorage.language = language;
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    activeItem: {
      type: Object,
      default: null
    },
    desc: {
      type: Object,
      default: null
    },
    login: {
      type: String,
      default: null
    }
  },
  methods: {
    logout: function logout() {
      this.$emit("exit");
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_dataTable__ = __webpack_require__(236);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ tableModelLan: "tableModel" })],
  data: function data() {
    return {
      tbodyData: [],
      confirmDelete: false,
      deleteDataKeys: [],
      btnGroup: {
        refresh: 'refresh',
        add: 'addUser',
        delete: 'deleteUser',
        confirmDelete: 'confirmDelete'
      },
      seekKey: {
        active: this.$route.query.seekKey ? this.$route.query.seekKey : 'userId',
        list: ['userId', 'userName'],
        seekVal: this.$route.query.seekVal ? this.$route.query.seekVal : ''
      },
      page: {
        active: this.$route.query.pageIndex ? parseInt(this.$route.query.pageIndex) : 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: {
        list: ['5', '10', '25', '50'],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },

  computed: {
    theadText: function theadText() {
      return this.tableModelLan.userThead;
    }
  },
  components: {
    dTable: __WEBPACK_IMPORTED_MODULE_3_components_dataTable__["a" /* default */]
  },
  created: function created() {
    this.getDataList();
  },

  methods: {
    getDataList: function getDataList() {
      var _this = this;

      // 获取数据列表
      var args = '?pageNum=' + (this.page.active - 1) + '&pageSize=' + this.selPage.limit + '&seekVal=' + this.seekKey.seekVal + '&seekKey=' + this.seekKey.active;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["X" /* URL_USERLIST */] + args).then(function (res) {
        if (res.data.code === 200 && Array.isArray(res.data.data.list) && res.data.msg === 'OK') {
          var data = res.data.data;
          _this.page.pageLeng = data.count;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              item.role = item.role.join('; ');
              if (item.lastLogin) item.lastLogin = _this.$moment(item.lastLogin).format("YYYY-MM-DD HH:mm:ss");
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.tbodyData = data.list.concat([]);
        }
      }).catch(function (e) {
        return alert(e);
      });
    },
    handleChangeSeekKey: function handleChangeSeekKey(item) {
      // 改变搜索的key
      this.seekKey.active = item;
    },
    handleChangeSeekVal: function handleChangeSeekVal(seekVal) {
      // 改变搜索的value
      this.seekKey.seekVal = seekVal;
    },
    handleSeek: function handleSeek() {
      // 处理搜索的方法
      this.getDataList();
    },
    toDelete: function toDelete() {
      // 去删除
      this.confirmDelete = true;
    },
    toConfirmDelete: function toConfirmDelete() {
      var _this2 = this;

      // 去确认删除
      if (this.deleteDataKeys.length > 0 && confirm(this.tableModelLan.confirmDeleteTips)) {
        var pAll = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.deleteDataKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var deleteItem = _step2.value;

            pAll.push(this.$http.delete(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["W" /* URL_USER */], { data: { login: deleteItem } }));
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pAll).then(function () {
          _this2.page.active = 1;
          _this2.page.offset = 0;
          _this2.getDataList();
          _this2.deleteDataKeys = [];
          _this2.confirmDelete = false;
        });
      } else if (this.deleteDataKeys.length === 0) this.confirmDelete = false;
    },
    hanldeDelete: function hanldeDelete(index) {
      // 处理点击删除图标按钮
      this.deleteDataKeys.push(this.tbodyData[index].login);
    },
    hanldeChecked: function hanldeChecked(index) {
      // 处理点击打钩图标按钮
      var code = this.deleteDataKeys.indexOf(this.tbodyData[index].login);
      this.deleteDataKeys.splice(code, 1);
    },
    toEdit: function toEdit(login) {
      // 去到修改页面
      var url = '/userEdit?login=' + login + '&pageIndex=' + this.page.active + '&seekKey=' + this.seekKey.active + '&seekVal=' + this.seekKey.seekVal;
      this.$router.push(url);
    },
    toAdd: function toAdd() {
      // 去到添加用户页面
      var url = '/addUser?pageIndex=' + this.page.active + '&seekKey=' + this.seekKey.active + '&seekVal=' + this.seekKey.seekVal;
      this.$router.push(url);
    },
    selPageFn: function selPageFn(index, item) {
      // 选择一页显示的条目数量
      this.SAVEPAGEMAXINDEX(index);
      this.selPage.active = index;
      this.selPage.limit = this.selPage.list[this.selPage.active];
      this.page.offset = 0;
      this.page.active = 1;
      this.getDataList();
    },
    pagingFn: function pagingFn(index) {
      // 翻页回调函数
      this.page.active = index;
      this.getDataList();
    },
    refresh: function refresh() {
      // 重新获取全部数据
      this.page.active = 1;
      this.page.offset = 0;
      this.seekKey.seekVal = '';
      this.getDataList();
    }
  }
});

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataTable_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa774a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataTable_vue__ = __webpack_require__(690);
function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73aa774a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa774a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uiv__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ tableModelLan: "tableModel" })],
  props: {
    viewReadOnly: {
      type: Boolean,
      default: false
    },
    viewKey: {
      type: String,
      default: ''
    },
    btnGroup: {
      type: Object,
      default: {}
    },
    seekKey: {
      type: Object,
      default: {}
    },
    theadText: {
      type: Array,
      default: []
    },
    tbodyData: {
      type: Array,
      default: []
    },
    confirmDelete: {
      type: Boolean,
      default: false
    },
    page: {
      type: Object,
      default: {}
    },
    selPage: {
      type: Object,
      default: {}
    },
    deleteDataKeys: {
      type: Array,
      default: null
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0_uiv__["c" /* Dropdown */],
    BtnGroup: __WEBPACK_IMPORTED_MODULE_0_uiv__["b" /* BtnGroup */],
    Btn: __WEBPACK_IMPORTED_MODULE_0_uiv__["a" /* Btn */],
    Pagination: __WEBPACK_IMPORTED_MODULE_0_uiv__["e" /* Pagination */]
  },
  data: function data() {
    return {};
  },

  computed: {
    seekVal: {
      get: function get() {
        return this.seekKey.seekVal;
      },
      set: function set(val) {
        this.$emit('handleChangeSeekVal', val);
      }
    }
  },
  methods: {
    handleSeek: function handleSeek() {
      this.$parent.page.active = 1;
      this.$emit('handleSeek');
    },
    emitSelPage: function emitSelPage(index, item) {
      // 选择一页显示的条目数量
      this.$emit("selPage", index, item);
    },
    callpageFn: function callpageFn(index) {
      // 翻页回调
      this.$emit('pagingFn', index);
    },
    formatData: function formatData(arr) {
      var _this = this;

      // 专门处理角色管理页面的表格,可以显示“只读”的翻译
      var newArr = [];
      arr.filter(function (v) {
        if (v.indexOf('_readOnly') !== -1) {
          var a = v.split('_readOnly')[0];
          v = a + ("(" + _this.tableModelLan.readOnly + ")");
        }
        newArr.push(v);
      });
      return newArr.join('; ');
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_dataTable__ = __webpack_require__(236);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ tableModelLan: "tableModel" })],
  data: function data() {
    return {
      tbodyData: [],
      confirmDelete: false,
      deleteDataKeys: [],
      btnGroup: {
        refresh: 'refresh',
        add: 'addRole',
        delete: 'deleteRole',
        confirmDelete: 'confirmDelete'
      },
      seekKey: {
        active: this.$route.query.seekKey ? this.$route.query.seekKey : 'roleId',
        list: ['roleId', 'roleName'],
        seekVal: this.$route.query.seekVal ? this.$route.query.seekVal : ''
      },
      page: {
        active: this.$route.query.pageIndex ? parseInt(this.$route.query.pageIndex) : 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: {
        list: ['5', '10', '25', '50'],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },

  computed: {
    theadText: function theadText() {
      return this.tableModelLan.roleThead;
    }
  },
  components: {
    dTable: __WEBPACK_IMPORTED_MODULE_3_components_dataTable__["a" /* default */]
  },
  created: function created() {
    this.getDataList();
  },

  methods: {
    getDataList: function getDataList() {
      var _this = this;

      // 获取数据列表
      var args = '?pageNum=' + (this.page.active - 1) + '&pageSize=' + this.selPage.limit + '&seekVal=' + this.seekKey.seekVal + '&seekKey=' + this.seekKey.active;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["N" /* URL_ROLELIST */] + args).then(function (res) {
        if (res.data.code === 200 && Array.isArray(res.data.data.list) && res.data.msg === 'OK') {
          var data = res.data.data;
          _this.page.pageLeng = data.count;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              var fnList = [];
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(item.functions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var fn = _step2.value;

                  if (fn.readOnly) fnList.push(fn.name + '_readOnly'); // (${this.tableModelLan.readOnly})
                  else fnList.push(fn.name);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              item.functions = fnList.join('; ');
              item.lastUpdate = _this.$moment(item.lastUpdate).format("YYYY-MM-DD HH:mm:ss");
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.tbodyData = data.list.concat([]);
        }
      }).catch(function (e) {
        return alert(e);
      });
    },
    handleChangeSeekKey: function handleChangeSeekKey(item) {
      // 改变搜索的key
      this.seekKey.active = item;
    },
    handleChangeSeekVal: function handleChangeSeekVal(seekVal) {
      // 改变搜索的value
      this.seekKey.seekVal = seekVal;
    },
    handleSeek: function handleSeek() {
      // 处理搜索的方法
      this.getDataList();
    },
    toDelete: function toDelete() {
      // 去删除
      this.confirmDelete = true;
    },
    toConfirmDelete: function toConfirmDelete() {
      var _this2 = this;

      // 去确认删除
      if (this.deleteDataKeys.length > 0 && confirm(this.tableModelLan.confirmDeleteTips)) {
        var pAll = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.deleteDataKeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var deleteItem = _step3.value;

            pAll.push(this.$http.delete(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["M" /* URL_ROLE */], { data: { roleId: deleteItem } }));
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pAll).then(function (res) {
          res.map(function (v) {
            if (v.data.code === 400) return alert(v.data.msg);
            _this2.page.active = 1;
            _this2.page.offset = 0;
            _this2.getDataList();
            _this2.deleteDataKeys = [];
            _this2.confirmDelete = false;
          });
        }).catch(function (e) {
          return alert(e);
        });
      } else if (this.deleteDataKeys.length === 0) this.confirmDelete = false;
    },
    hanldeDelete: function hanldeDelete(index) {
      // 处理点击删除图标按钮
      this.deleteDataKeys.push(this.tbodyData[index].roleId);
    },
    hanldeChecked: function hanldeChecked(index) {
      // 处理点击打钩图标按钮
      var code = this.deleteDataKeys.indexOf(this.tbodyData[index].roleId);
      this.deleteDataKeys.splice(code, 1);
    },
    toEdit: function toEdit(roleId) {
      // 去到修改页面
      var url = '/roleEdit?roleId=' + roleId + '&pageIndex=' + this.page.active + '&seekKey=' + this.seekKey.active + '&seekVal=' + this.seekKey.seekVal;
      this.$router.push(url);
    },
    toAdd: function toAdd() {
      // 去到添加角色页面
      var url = '/addRole?pageIndex=' + this.page.active + '&seekKey=' + this.seekKey.active + '&seekVal=' + this.seekKey.seekVal;
      this.$router.push(url);
    },
    selPageFn: function selPageFn(index, item) {
      // 选择一页显示的条目数量
      this.SAVEPAGEMAXINDEX(index);
      this.selPage.active = index;
      this.selPage.limit = this.selPage.list[this.selPage.active];
      this.page.offset = 0;
      this.page.active = 1;
      this.getDataList();
    },
    pagingFn: function pagingFn(index) {
      // 翻页回调函数
      this.page.active = index;
      this.getDataList();
    },
    refresh: function refresh() {
      // 重新获取全部数据
      this.page.active = 1;
      this.page.offset = 0;
      this.seekKey.seekVal = '';
      this.getDataList();
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_util__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ lan: "auditLog" })],
  data: function data() {
    return {
      type: '-1',
      logDate: [new Date().setTime(new Date().getTime() - 36 * 1e5 * 24 * 30), new Date()],
      modifiedID: '',
      description: '',
      tbodyData: [],
      page: {
        active: 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: {
        list: ['5', '10', '25', '50'],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      },
      tip: ['OLD_VALUE', 'NEW_VALUE']
    };
  },

  computed: {
    tableHead: function tableHead() {
      return this.lan.tableHead;
    },
    pickerOptions: function pickerOptions() {
      var arr = [];
      var dateArr = [{ text: this.lan.lastWeek, day: 7 }, { text: this.lan.lastMonth, day: 30 }, { text: this.lan.lastThreeMonths, day: 90 }];

      var _loop = function _loop(v) {
        arr.push({
          text: v.text,
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 36 * 1e5 * 24 * v.day);
            picker.$emit('pick', [start, end]);
          }
        });
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dateArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;

          _loop(v);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        shortcuts: arr
      };
    }
  },
  components: {
    sllTable: __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__["a" /* default */]
  },
  created: function created() {
    this.requestEngine();
  },

  methods: {
    requestEngine: function requestEngine() {
      var _this = this;

      if (isNaN(new Number(this.modifiedID))) {
        this.$message({ message: this.lan.notNumber, type: 'warning' });
        return;
      }
      var option = { type: this.type, pageNum: this.page.active, pageSize: +this.selPage.limit };
      if (this.logDate) {
        option.start = Object(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["h" /* format */])(this.logDate[0]);
        option.end = Object(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["h" /* format */])(this.logDate[1]);
      }
      if (this.modifiedID) option.modifiedID = this.modifiedID;
      if (this.description) option.description = this.description;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_api_api__["f" /* URL_AUDITLOG */], option).then(function (res) {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
        _this.resolveData();
      }).catch(function (e) {
        alert(e);
      });
    },
    resolveData: function resolveData() {
      var _this2 = this;

      if (Object.prototype.toString.call(this.tbodyData) == "[object Array]") {
        this.tbodyData.forEach(function (item) {
          item.type = _this2.lan.typeMaps[item.TYPE];
          item.LOG_DATE = Object(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["h" /* format */])(item.LOG_DATE);
        });
      }
    }
  },
  watch: {
    lan: function lan() {
      this.resolveData();
    }
  }
});

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__excel__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uiv__ = __webpack_require__(55);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ reuseLan: 'reuse' })],
  props: {
    tableHead: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tbodyData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageEnable: {
      default: true
    },
    changeHeight: {
      default: false
    },
    page: {
      type: Object,
      default: function _default() {}
    },
    selPage: {
      type: Object,
      default: function _default() {}
    },
    tip: {
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ''
    },
    sort: {
      default: false
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    },
    downloadLoading: {
      type: Boolean,
      default: false
    },
    noDataMessage: {
      type: String,
      default: ""
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_3_uiv__["c" /* Dropdown */],
    Btn: __WEBPACK_IMPORTED_MODULE_3_uiv__["a" /* Btn */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3_uiv__["e" /* Pagination */],
    jsonExcel: __WEBPACK_IMPORTED_MODULE_1__excel__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    emitSelPage: function emitSelPage(index, item) {
      // 选择一页显示的条目数量
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.$parent.page.active = 1;
      this.$emit('tableChange');
    },
    emitSort: function emitSort(sortKey, sequence) {
      if (this.sort.list && (this.sort.list == 'All' || this.sort.list.includes(sortKey))) {
        var key = this.sort.active.key;
        var order = this.sort.active.order;
        order = sequence ? sequence : key == sortKey ? order == 'DESC' ? '' : order == 'ASC' ? 'DESC' : 'ASC' : 'ASC';
        this.$parent.sort.active.key = this.sort.active.key = sortKey;
        this.$parent.sort.active.order = this.sort.active.order = order;
        this.$emit('tableChange');
      }
    },
    callpageFn: function callpageFn(index) {
      // 翻页回调
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : '';
      this.$emit('tableChange');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['SAVEPAGEMAXINDEX']))
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: [],
      socket: null,
      excelLoading: false
    };
  },

  props: {
    name: {
      type: String,
      default: '下載'
    },
    keys: {
      default: Array
    },
    ajaxUrl: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: 'get'
    },
    colData: {
      default: false
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    },
    downloadLoading: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      default: false
    }
  },
  methods: {
    getHeadKeyOrName: function getHeadKeyOrName(type) {
      var arr = [];
      this.keys.forEach(function (item) {
        if ((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)) {
          arr.push(item[type]);
        }
      });
      return arr;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      if (this.downloadLoading) {
        this.$parent.$parent.loadText = this.downLoadTran.loadText;
        this.$parent.$parent.loading = true;
      }
      this.excelLoading = true;
      var ajaxPar = this.ajaxType === 'post' ? this.ajaxPar : { params: this.ajaxPar };
      this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
        var getVal = function getVal(obj, arr) {
          if (arr.length > 1) {
            return getVal(obj[arr[0]], arr.slice(1));
          } else {
            return obj[arr[0]];
          }
        };
        _this.data = getVal(res, _this.ajaxGetKey);
        if (typeof _this.data === 'string' && _this.downloadUrl) {
          window.open(_this.downloadUrl + '/' + _this.data);
        }
        if (Array.isArray(_this.data)) {
          _this.export2Excel(_this.resolveData(_this.data), _this.name);
        }
        if (_this.downloadLoading) {
          _this.$parent.$parent.loadText = '';
          _this.$parent.$parent.loading = false;
        }
        _this.excelLoading = false;
      });
    },
    export2Excel: function export2Excel(excelData, excelName) {
      var _this2 = this;

      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require = __webpack_require__(51),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = _this2.getHeadKeyOrName('value');
        var filterVal = _this2.getHeadKeyOrName('key');
        var list = excelData;
        var data = _this2.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, excelName);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    resolveData: function resolveData(data) {
      var arr = [];
      if (Array.isArray(data[0])) {
        // 后台数据格式[[{},{}],[{},{}]...]
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var array = _step.value;

            this.traverse(arr, array);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        // 后台数据格式[{},{},{}...]
        this.traverse(arr, data);
      }
      return arr;
    },
    traverse: function traverse(arr, data) {
      for (var i in data) {
        var v = data[i];
        var obj = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            // 如果头部有flag并且设置了flag为false 或者 有unneed并且设置了unneed为false,则不取值
            if (item.flag !== undefined && !item.flag || item.unneed !== undefined && !item.unneed) continue;
            // 头部键需要转大写的转大写取值
            var tempKey = item.upper === undefined || item.upper ? item.key.toUpperCase() : item.key;
            // 如果头部有changeTime并且为true,则转换时间
            // if(item.changeTime != undefined && item.changeTime){
            //   obj[item.key] = v[tempKey] ? updateTimeByUtc(getTimeDiff(), v[tempKey])  : ''
            //   continue
            // }
            // 下载翻译对象不存在或者对象不存在此键,则直接取后台返回的值,否则取翻译对象中的值
            if (this.downLoadTran === undefined || !this.downLoadTran[tempKey]) {
              obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
              continue;
            }
            var temp = this.downLoadTran[tempKey][v[tempKey]];
            // 翻译对象通过键取值的对象中有part属性,则给此列数据最后一个做翻译,此列其余数据取后台返回的数据
            if (!this.downLoadTran[tempKey].part) {
              obj[item.key] = temp || temp == 0 ? temp : '';
              continue;
            }
            if (i >= data.length - this.downLoadTran[tempKey].index) {
              obj[item.key] = temp || temp == 0 ? temp : '';
              continue;
            }
            obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        arr.push(obj);
      }
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_api_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ changePasswordLan: "changePassword" })],
  props: ['viewReadOnly'],
  data: function data() {
    return {
      oldPwd: '',
      newPwd: ''
    };
  },

  computed: {
    requestData: function requestData() {
      return {
        oldPwd: this.oldPwd,
        newPwd: this.newPwd
      };
    },
    login: function login() {
      return JSON.parse(sessionStorage.user).name;
    }
  },
  methods: {
    saveFn: function saveFn() {
      var _this = this;

      this.$validator.validate().then(function (res) {
        if (res) {
          _this.$http.put(__WEBPACK_IMPORTED_MODULE_0_api_api_js__["I" /* URL_PASSWORD */], _this.requestData).then(function (res) {
            if (res.data.code === 200 && res.data.data === 'success') {
              alert(_this.changePasswordLan.success);
              _this.$router.push('/login');
            } else alert(res.data.msg);
          }).catch(function (e) {
            return alert(e);
          });
        }
      });
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uiv__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_inputModel__ = __webpack_require__(115);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ userModelLan: "userModel" })],
  components: {
    inputModel: __WEBPACK_IMPORTED_MODULE_5_components_inputModel__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4_uiv__["d" /* Modal */]
  },
  data: function data() {
    return {
      login: '',
      name: '',
      password: '',
      enable: '',
      tData: [], // 穿梭框左边数据
      value: [], // 穿梭框右边数据
      responseData: {}, // 后台返回的数据
      showModal: false, // 是否显示模态窗
      modalTips: '',
      showSuccessfulModal: false,
      responseRoleList: []
    };
  },
  created: function created() {
    this.getData();
  },

  computed: {
    selectedRole: function selectedRole() {
      // 已经选中的角色
      var roleList = this.responseRoleList.map(function (v) {
        return v.roleId;
      });
      var arr = [];
      this.value.forEach(function (i) {
        i < roleList.length && i >= 0 && arr.push(roleList[i]);
      });
      return arr;
    },
    transferTitles: function transferTitles() {
      // 穿梭框标题头
      return [this.userModelLan.existingRoleList, this.userModelLan.selectedRoleList];
    },
    requestData: function requestData() {
      // 请求时数据
      var roleIdList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.responseData.role), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          roleIdList.push(item.roleId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var obj = {};
      obj.login = this.responseData.login;
      if (this.name !== this.responseData.name) obj.name = this.name;else delete obj.name;
      if (this.password !== '') obj.password = this.password;else delete obj.password;
      if (this.enable !== this.responseData.enable) obj.enable = this.enable;else delete obj.enable;
      if (this.selectedRole.sort().toString() !== roleIdList.sort().toString()) obj.role = this.selectedRole;else delete obj.role;
      return obj;
    }
  },
  methods: {
    getData: function getData() {
      var _this = this;

      // 获取数据
      var p1 = this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["N" /* URL_ROLELIST */] + '/?type=simplify'); // 获取角色列表
      var p2 = this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["W" /* URL_USER */] + '/' + this.$route.query.login); // 获取某个用户信息
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2]).then(function (res) {
        _this.responseRoleList = res[0].data.data;
        for (var i = 0; i < _this.responseRoleList.length; i++) {
          _this.tData.push({ key: i, label: _this.responseRoleList[i].name });
        }
        var data = res[1].data.data;
        _this.responseData = res[1].data.data;
        _this.login = data.login;
        _this.name = data.name;
        _this.enable = data.enable;

        var map = {};
        _this.tData.forEach(function (obj) {
          return map[obj.label] = obj.key;
        });
        data.role.forEach(function (role) {
          return _this.value.push(map[role.name]);
        });
      });
    },
    hanldeBack: function hanldeBack() {
      // 处理返回的操作
      var url = '/userMaintenance?pageIndex=' + this.$route.query.pageIndex + '&seekKey=' + this.$route.query.seekKey + '&seekVal=' + this.$route.query.seekVal;
      this.$router.push(url);
    },
    handleChangeData: function handleChangeData(val, modelKey) {
      // 处理子组件绑定的数据
      this[modelKey] = val;
    },
    validateAll: function validateAll(success) {
      var _this2 = this;

      // 验证全部
      var p1 = this.$refs.login.$validator.validate();
      var p2 = this.$refs.name.$validator.validate();
      var p3 = this.$refs.password.$validator.validate();
      var p4 = this.$refs.enable.$validator.validate();
      var p5 = this.$validator.validate();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2, p3, p4, p5]).then(function (res) {
        if (!res.every(function (v) {
          return v;
        })) {
          _this2.showModal = true;
          _this2.showSuccessfulModal = false;
          _this2.modalTips = _this2.userModelLan.errTips;
        } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.requestData).length <= 1) {
          _this2.showModal = true;
          _this2.showSuccessfulModal = false;
          _this2.modalTips = _this2.userModelLan.noEdit;
        } else success();
      });
    },
    saveFn: function saveFn() {
      var _this3 = this;

      // 保存
      this.validateAll(function () {
        _this3.$http.put(__WEBPACK_IMPORTED_MODULE_3_api_api_js__["W" /* URL_USER */], _this3.requestData).then(function (res) {
          if (res.data.code === 200 && res.data.data === 'success') {
            _this3.showModal = true;
            _this3.showSuccessfulModal = true;
            _this3.modalTips = _this3.userModelLan.success;
          } else alert(res.data.msg);
        }).catch(function (e) {
          return alert(e);
        });
      });
    },
    handleModalHide: function handleModalHide() {
      // 处理弹窗隐藏
      if (this.showSuccessfulModal) this.$router.push('/userMaintenance');
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    errTips: {
      type: String,
      default: ''
    },
    data: {
      default: null
    },
    modelKey: {
      type: String,
      default: ''
    },
    validateRule: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    radioYes: {
      default: ''
    },
    radioNo: {
      default: ''
    },
    selectData: {
      type: Array,
      default: null
    }
  },
  computed: {
    mData: {
      get: function get() {
        return this.data;
      },
      set: function set(val) {
        this.$emit('changeData', val, this.modelKey);
      }
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uiv__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_inputModel__ = __webpack_require__(115);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ userModelLan: "userModel" })],
  components: {
    inputModel: __WEBPACK_IMPORTED_MODULE_4_components_inputModel__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3_uiv__["d" /* Modal */]
  },
  data: function data() {
    return {
      login: '',
      name: '',
      password: '',
      enable: true,
      tData: [], // 穿梭框左边数据
      value: [], // 穿梭框右边数据
      showModal: false, // 是否显示模态窗
      modalTips: '',
      showSuccessfulModal: false,
      responseRoleList: []
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["N" /* URL_ROLELIST */] + '/?type=simplify').then(function (res) {
      // 获取所有角色列表
      if (res.data.code === 200 && res.data.data && res.data.msg === 'OK') {
        _this.responseRoleList = res.data.data.concat([]);
        for (var i = 0; i < _this.responseRoleList.length; i++) {
          _this.tData.push({
            key: i,
            label: _this.responseRoleList[i].name
          });
        }
      } else alert(res.data.msg);
    }).catch(function (e) {
      return alert(e);
    });
  },

  computed: {
    transferTitles: function transferTitles() {
      // 穿梭框标题头
      return [this.userModelLan.existingRoleList, this.userModelLan.selectedRoleList];
    },
    requestData: function requestData() {
      // 请求时数据
      var res = {
        login: this.login,
        name: this.name,
        password: this.password,
        enable: this.enable,
        role: []
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          res.role.push(this.responseRoleList[item].roleId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    }
  },
  methods: {
    handleChangeData: function handleChangeData(val, modelKey) {
      // 处理子组件绑定的数据
      this[modelKey] = val;
    },
    saveFn: function saveFn() {
      var _this2 = this;

      this.validateAll(function () {
        _this2.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api_js__["W" /* URL_USER */], _this2.requestData).then(function (res) {
          if (res.data.code === 200 && res.data.data === "success") {
            _this2.showModal = true;
            _this2.showSuccessfulModal = true;
            _this2.modalTips = _this2.userModelLan.success;
          } else alert(res.data.msg);
        }).catch(function (e) {
          return alert(e);
        });
      });
    },
    validateAll: function validateAll(success) {
      var _this3 = this;

      // 验证全部
      var p1 = this.$refs.login.$validator.validate();
      var p2 = this.$refs.name.$validator.validate();
      var p3 = this.$refs.password.$validator.validate();
      var p4 = this.$refs.enable.$validator.validate();
      var p5 = this.$validator.validate();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2, p3, p4, p5]).then(function (res) {
        if (res.every(function (v) {
          return v;
        })) success();else {
          _this3.showModal = true;
          _this3.showSuccessfulModal = false;
          _this3.modalTips = _this3.userModelLan.errTips;
        }
      });
    },
    handleModalHide: function handleModalHide() {
      // 处理弹窗隐藏
      if (this.showSuccessfulModal) this.$router.push('/userMaintenance');
    },
    hanldeBack: function hanldeBack() {
      // 处理返回的操作
      var url = '/userMaintenance?pageIndex=' + this.$route.query.pageIndex + '&seekKey=' + this.$route.query.seekKey + '&seekVal=' + this.$route.query.seekVal;
      this.$router.push(url);
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_inputModel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uiv__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_api_js__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ roleModelLan: "roleModel" })],
  components: {
    inputModel: __WEBPACK_IMPORTED_MODULE_2_components_inputModel__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3_uiv__["d" /* Modal */]
  },
  data: function data() {
    return {
      tData: [],
      value: [],
      roleId: '',
      name: '',
      description: '',
      readOnlyArr: [],
      responseFuncList: [],
      showModal: false,
      showSuccessfulModal: false,
      modalTips: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api_js__["s" /* URL_FUNCS */]).then(function (res) {
      if (res.data.code === 200 && res.data.data && res.data.msg === 'OK') {
        _this.responseFuncList = res.data.data;
        for (var i = 0; i < _this.responseFuncList.length; i++) {
          _this.tData.push({
            key: i,
            label: _this.responseFuncList[i].name
          });
        }
      } else alert(res.data.msg);
    }).catch(function (e) {
      return alert(e);
    });
  },

  computed: {
    transferTitles: function transferTitles() {
      // 穿梭框标题头
      return [this.roleModelLan.existingFuncList, this.roleModelLan.selectedFuncList];
    },
    requestData: function requestData() {
      var res = {
        roleId: this.roleId,
        name: this.name,
        description: this.description,
        functions: []
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          res.functions.push({ functionID: this.responseFuncList[item].functionID, name: this.responseFuncList[item].name, readOnly: this.readOnlyArr.includes(this.responseFuncList[item].name) });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    }
  },
  methods: {
    handleChangeData: function handleChangeData(val, modelKey) {
      // 处理子组件绑定的数据
      this[modelKey] = val;
    },
    saveFn: function saveFn() {
      var _this2 = this;

      this.validateAll(function () {
        _this2.$http.post(__WEBPACK_IMPORTED_MODULE_4_api_api_js__["M" /* URL_ROLE */], _this2.requestData).then(function (res) {
          if (res.data.code === 200 && res.data.data === 'success') {
            _this2.showModal = true;
            _this2.showSuccessfulModal = true;
            _this2.modalTips = _this2.roleModelLan.success;
          } else alert(res.data.msg);
        }).catch(function (e) {
          return alert(e);
        });
      });
    },
    validateAll: function validateAll(success) {
      var _this3 = this;

      // 验证全部
      var p1 = this.$refs.roleId.$validator.validate();
      var p2 = this.$refs.name.$validator.validate();
      var p3 = this.$refs.description.$validator.validate();
      var p4 = this.$validator.validate();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2, p3, p4]).then(function (res) {
        if (res.every(function (v) {
          return v;
        })) success();else {
          _this3.showModal = true;
          _this3.showSuccessfulModal = false;
          _this3.modalTips = _this3.roleModelLan.errTips;
        }
      });
    },
    handleModalHide: function handleModalHide() {
      // 处理弹窗隐藏
      if (this.showSuccessfulModal) this.$router.push('/roleMaintenance');
    },
    hanldeBack: function hanldeBack() {
      // 处理返回的操作
      var url = '/roleMaintenance?pageIndex=' + this.$route.query.pageIndex + '&seekKey=' + this.$route.query.seekKey + '&seekVal=' + this.$route.query.seekVal;
      this.$router.push(url);
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_inputModel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uiv__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_api_api_js__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ roleModelLan: "roleModel" })],
  components: {
    inputModel: __WEBPACK_IMPORTED_MODULE_4_components_inputModel__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_5_uiv__["d" /* Modal */]
  },
  data: function data() {
    return {
      tData: [],
      value: [],
      roleId: '',
      name: '',
      description: '',
      readOnlyArr: [],
      responseData: {},
      responseFuncList: [],
      showModal: false,
      showSuccessfulModal: false,
      modalTips: ''
    };
  },
  created: function created() {
    this.getData();
  },

  computed: {
    transferTitles: function transferTitles() {
      // 穿梭框标题头
      return [this.roleModelLan.existingFuncList, this.roleModelLan.selectedFuncList];
    },
    requestData: function requestData() {
      var obj = {};
      obj.roleId = this.responseData.roleId;
      if (this.name !== this.responseData.name) obj.name = this.name;else delete obj.name;
      if (this.description !== this.responseData.description) obj.description = this.description;else delete obj.description;
      // 判断现在选中功能列表与之前的是否一样
      if (this.responseData.functions && this.selectedFunc.length === this.responseData.functions.length) {
        var map = {};
        this.selectedFunc.forEach(function (obj) {
          return map[obj.functionID] = obj;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.responseData.functions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var b = _step.value;

            var a = map[b.functionID];
            if (!a) {
              obj.functions = this.selectedFunc;
              break;
            } else if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(a) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(b)) {
              obj.functions = this.selectedFunc;
              break;
            } else delete obj.functions;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        obj.functions = this.selectedFunc;
      }
      return obj;
    },
    selectedFunc: function selectedFunc() {
      // 已经选中的功能列表
      var arr = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.value), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          arr.push({
            functionID: this.responseFuncList[item].functionID,
            name: this.responseFuncList[item].name,
            readOnly: this.readOnlyArr.includes(this.responseFuncList[item].name)
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return arr;
    }
  },
  methods: {
    handleChangeData: function handleChangeData(val, modelKey) {
      // 处理子组件绑定的数据
      this[modelKey] = val;
    },
    hanldeBack: function hanldeBack() {
      // 处理返回的操作
      var url = '/roleMaintenance?pageIndex=' + this.$route.query.pageIndex + '&seekKey=' + this.$route.query.seekKey + '&seekVal=' + this.$route.query.seekVal;
      this.$router.push(url);
    },
    getData: function getData() {
      var _this = this;

      // 获得数据
      var p1 = this.$http.get(__WEBPACK_IMPORTED_MODULE_6_api_api_js__["s" /* URL_FUNCS */]);
      var p2 = this.$http.get(__WEBPACK_IMPORTED_MODULE_6_api_api_js__["M" /* URL_ROLE */] + '/' + this.$route.query.roleId);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2]).then(function (res) {
        _this.responseFuncList = res[0].data.data;
        for (var i = 0; i < _this.responseFuncList.length; i++) {
          _this.tData.push({ key: i, label: _this.responseFuncList[i].name });
        }
        var data = res[1].data.data;
        _this.responseData = res[1].data.data;
        _this.roleId = data.roleId;
        _this.name = data.name;
        _this.description = data.description;
        var map = {};
        _this.tData.forEach(function (obj) {
          return map[obj.label] = obj.key;
        });
        data.functions.forEach(function (func) {
          _this.value.push(map[func.name]);
          func.readOnly && _this.readOnlyArr.push(func.name);
        });
      });
      // .catch(e => alert(e))
    },
    saveFn: function saveFn() {
      var _this2 = this;

      // 保存数据
      this.validateAll(function () {
        _this2.$http.put(__WEBPACK_IMPORTED_MODULE_6_api_api_js__["M" /* URL_ROLE */], _this2.requestData).then(function (res) {
          if (res.data.code === 200 && res.data.data === 'success') {
            _this2.showModal = true;
            _this2.showSuccessfulModal = true;
            _this2.modalTips = _this2.roleModelLan.success;
          } else alert(res.data.msg);
        }).catch(function (e) {
          return alert(e);
        });
      });
    },
    validateAll: function validateAll(success) {
      var _this3 = this;

      // 验证全部
      var p1 = this.$refs.roleId.$validator.validate();
      var p2 = this.$refs.name.$validator.validate();
      var p3 = this.$refs.description.$validator.validate();
      var p4 = this.$validator.validate();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2, p3, p4]).then(function (res) {
        if (!res.every(function (v) {
          return v;
        })) {
          _this3.showModal = true;
          _this3.showSuccessfulModal = false;
          _this3.modalTips = _this3.roleModelLan.errTips;
        } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.requestData).length <= 1) {
          _this3.showModal = true;
          _this3.showSuccessfulModal = false;
          _this3.modalTips = _this3.roleModelLan.noEdit;
        } else success();
      });
    },
    handleModalHide: function handleModalHide() {
      // 处理弹窗隐藏
      if (this.showSuccessfulModal) this.$router.push('/roleMaintenance');
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var days = 14;

var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      timeType: '0',
      orderTime: [],
      login: null,
      symbol: null,
      ibNum: null,
      ticket: null,
      group: null,
      dealType: '1',
      currency: null,
      office: null,
      region: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: function disabledDate(time) {
        return time.getTime() > new Date();
      },
      onPick: function onPick(property) {
        var minDate = property.minDate;
        if (!property.maxDate && property.minDate) {
          var minAfter = this.$moment(minDate).add(days, 'd');
          var now = this.$moment();
          var max = now.isAfter(minAfter) ? minAfter : now;
          var minBefore = this.$moment(minDate).subtract(days, 'd');
          this.disabledDate = function (time) {
            return time.getTime() > new Date(max) || time.getTime() < new Date(minBefore);
          };
        }
      }
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'closedTradesReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    return this.language.downloadName;
  },
  tableHead: function tableHead() {
    var redColorColumns = ['COMMISSION', 'TAXES', 'COMMISSION_AGENT', 'SWAPS', 'PROFIT', 'PIPES'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  orderTime: function orderTime() {
    var timeTypeSelector = { 0: this.language.openTime };
    if (this.formData.dealType == 1) timeTypeSelector[1] = this.language.closedTime;
    return timeTypeSelector;
  },
  downLoadTran: function downLoadTran() {
    return {
      CMD: this.language.cmdMapping,
      SECURITY: this.language.securityMapping,
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["j" /* URL_CLOSED_TARDES_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().format('YYYY-MM-DD 00:00:00');
  var defaultStart = this.$moment().subtract(days, 'd').format('YYYY-MM-DD 00:00:00');
  this.formData.orderTime.push(defaultStart);
  this.formData.orderTime.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    if (this.formData.dealType == 0) this.formData.timeType = '0';
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["j" /* URL_CLOSED_TARDES_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
        _this.tbodyData.forEach(function (v) {
          v.cmd = [0, 1].includes(v.CMD) ? _this.language.cmdMapping[v.CMD] : '';
          v.security = [0, 1].includes(v.SECURITY) ? _this.language.securityMapping[v.SECURITY] : '';
        });
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      return time.getTime() > new Date();
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

var watch = {
  language: function language() {
    var _this2 = this;

    this.tbodyData.forEach(function (v) {
      v.cmd = _this2.language.cmdMapping[v.CMD];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components,
  watch: watch
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_api__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mixins = [__webpack_require__(2).base({ language: 'floatingPL' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var data = function data() {
  return {
    plData: [],
    dayOfMT4Now: null,
    pageNum: 1,
    pageSize: 10,
    total: 0,
    btnStatus: false,
    dayOfReport: null,
    loadAccInfo: false,
    realtimeDownload: false,
    dailyDownload: false,
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        var oneMonthBefore = new Date();
        oneMonthBefore.setTime(oneMonthBefore.getTime() - 720 * 36e5);
        return time.getTime() > now || oneMonthBefore > time.getTime() || [0, 6].includes(time.getDay());
      }
    }
  };
};

var computed = {
  tableColumns: function tableColumns() {
    var redColorColumns = ['DEPOSIT', 'WITHDRAWAL', 'EQUITY', 'PREVIOUS_FLOATING_PL', 'FLOATING_PL', 'CLOSED_PL', 'CLOSED_SWAPS', 'ADJUSTMENT', 'CLOSED_COMMISSION', 'IB_COMMISSION', 'CL_F_PL'];
    this.language.tableColumns.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableColumns;
  }
};

var created = function created() {
  var userTime = this.$moment();
  var tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3;
  var tzOfUser = userTime.utcOffset() / 60;
  var mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h');
  this.dayOfMT4Now = mt4Time.format('YYYY-MM-DD');
  var mt4Weekday = mt4Time.weekday();
  var subDays = { 0: 2, 1: 3 };
  this.dayOfReport = mt4Time.subtract(subDays[mt4Weekday] || 1, 'd').format('YYYY-MM-DD');
  if ([0, 6].includes(mt4Weekday)) this.btnStatus = true;else this.getFloatingPL();
};

var methods = {
  getFloatingPL: function getFloatingPL() {
    var _this = this;

    this.loadAccInfo = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_0_api_api__["r" /* URL_FLOATING_PL */], { dayOfMT4Now: this.dayOfMT4Now, pageNum: this.pageNum, pageSize: this.pageSize }).then(function (res) {
      var result = res.data.data;
      _this.plData = result;
      _this.loadAccInfo = false;
      var addPageNum = result.length == _this.pageSize ? 1 : 0;
      _this.total = _this.pageSize * (_this.pageNum + addPageNum);
    });
  },
  handlePageChange: function handlePageChange(val) {
    this.pageNum = val;
    this.getFloatingPL();
  },
  handleSizeChange: function handleSizeChange(val) {
    this.pageNum = 1;
    this.pageSize = val;
    this.getFloatingPL();
  },
  download: function download() {
    var _this2 = this;

    this.realtimeDownload = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_0_api_api__["r" /* URL_FLOATING_PL */], { dayOfMT4Now: this.dayOfMT4Now, pageSize: -1 }).then(function (res) {
      _this2.export2Excel(res.data.data, _this2.language.excelName);
      _this2.realtimeDownload = false;
    });
  },
  downloadDaily: function downloadDaily() {
    var _this3 = this;

    if (this.dayOfReport === null) {
      this.$message.warning(this.language.warning);
      return;
    }
    this.dailyDownload = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_0_api_api__["r" /* URL_FLOATING_PL */], { dayOfReport: this.dayOfReport, pageSize: -1 }).then(function (res) {
      _this3.export2Excel(res.data.data, _this3.language.excelName + '_' + _this3.dayOfReport);
      _this3.dailyDownload = false;
    });
  },
  export2Excel: function export2Excel(datas, excelName) {
    var _this4 = this;

    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      var _require = __webpack_require__(51),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = _this4.language.tableColumns.map(function (v) {
        return v.value;
      });
      var filterVal = _this4.language.tableColumns.map(function (v) {
        return v.key;
      });
      var data = datas.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      export_json_to_excel(tHeader, data, excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: mixins,
  data: data,
  computed: computed,
  created: created,
  methods: methods
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_api__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var data = function data() {
  return {
    symbolList: [],
    symbols: [],
    copySymbols: [],
    all: [],
    allAfterFilter: [],
    openTrades: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    loading: false,
    filterKey: 'LOGIN',
    filterVal: null
  };
};

var mixins = [__webpack_require__(2).base({ language: 'openTrades' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  tableHead: function tableHead() {
    var redColorColumns = ['EQUITY', 'CLOSED_PL', 'FLOATING_PL', 'PL'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  }
};

var created = function created() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["T" /* URL_SYMBOL_LIST */]), this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["Q" /* URL_SECURITY */])]).then(function (res) {
    var _res = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(res, 2),
        symbolRes = _res[0],
        securityRes = _res[1];

    _this.symbolList = symbolRes.data.data;
    securityRes.data.data.forEach(function (type) {
      return _this.symbolList.push({ SYMBOL: '*' + type.TYPE });
    });
  });
};

var methods = {
  getOpenTradesBySymbols: function getOpenTradesBySymbols() {
    var _this2 = this;

    if (this.symbols.length == 0) {
      this.$message({ message: this.language.symbolText, type: 'warning' });
      return;
    }
    this.copySymbols = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.symbols));
    this.loading = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_4_api_api__["H" /* URL_OPEN_TRADES */], { symbols: this.symbols.join(',') }).then(function (res) {
      _this2.all = res.data.data;
      _this2.all.forEach(function (row) {
        return row.MARGIN_LEVEL = row.MARGIN_LEVEL + '%';
      });
      _this2.findByKeyword();
      _this2.loading = false;
    });
  },
  handlePageChange: function handlePageChange(val) {
    this.pageNum = val;
    this.openTrades = this.allAfterFilter.slice((val - 1) * this.pageSize, val * this.pageSize);
  },
  handleSizeChange: function handleSizeChange(val) {
    this.pageNum = 1;
    this.pageSize = val;
    this.openTrades = this.allAfterFilter.slice(0, this.pageSize);
  },
  export2Excel: function export2Excel() {
    var _this3 = this;

    var header = this.language.tableHead;
    var newHead = header.slice(0, header.length);
    var expand = this.language.expandHead;
    // 创建加总对象
    var totalObj = { EQUITY: 0, PL: 0, CLOSED_PL: 0, FLOATING_PL: 0
      // 动态添加EXCEL表头
    };this.symbols.forEach(function (e) {
      ;['BUY_VOLUME', 'SELL_VOLUME', 'VOLUME', 'PL'].forEach(function (k) {
        var key = e + '_' + k;
        newHead.push({ key: key, value: e + ' ' + expand[k] });
        totalObj[key] = 0;
      });
    });
    this.allAfterFilter.forEach(function (data) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(totalObj).forEach(function (key) {
        return totalObj[key] += data[key];
      });
    });
    var downloadArray = this.allAfterFilter.slice(0, this.total);
    if (downloadArray.length !== 0) {
      downloadArray.push({});
      downloadArray.push(totalObj);
    }
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      var _require = __webpack_require__(51),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = newHead.map(function (v) {
        return v.value;
      });
      var filterVal = newHead.map(function (v) {
        return v.key;
      });
      var data = downloadArray.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      export_json_to_excel(tHeader, data, _this3.language.excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  findByKeyword: function findByKeyword() {
    var _this4 = this;

    this.allAfterFilter = this.all.filter(function (v) {
      return !_this4.filterVal || ('' + (v[_this4.filterKey] || '')).includes(_this4.filterVal);
    });
    this.total = this.allAfterFilter.length;
    this.handlePageChange(1);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
  return {
    tbodyData: [],
    allData: [],
    tmpData: [],
    loading: false,
    loadText: '',
    status: '-1',
    dateRange: [],
    showBox: false,
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        return time.getTime() > now || time.getDay() === 6;
      }
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'analyze' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  tableHead: function tableHead() {
    var redColorColumns = ['BALANCE'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  start: function start() {
    var _ref = this.dateRange || [],
        _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
        start = _ref2[0];

    return start || this.reuse.startTime;
  },
  end: function end() {
    var _ref3 = this.dateRange || [],
        _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        end = _ref4[1];

    return end || this.reuse.endTime;
  }
};

var created = function created() {
  var weekday = this.$moment().weekday();

  var defaultEnd = this.$moment().subtract(weekday ? 1 : 2, 'd').format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(weekday == 2 ? 4 : 3, 'd').format('YYYY-MM-DD');
  this.dateRange.push(defaultStart);
  this.dateRange.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["e" /* URL_ANALYZE */], { date: this.dateRange }).then(function (res) {
      var useful = res.data.data;
      if (Object.prototype.toString.call(useful.data) === '[object Array]') {
        _this.allData = useful.data;
        _this.allData.forEach(function (v) {
          return v.status = _this.language.status[v.STATUS];
        });
        _this.selectHandle();
      } else {
        _this.$message.error(_this.language[useful]);
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  selectHandle: function selectHandle() {
    var _this2 = this;

    this.page.active = 1;
    this.tmpData = this.status > -1 ? this.allData.filter(function (v) {
      return v.STATUS == _this2.status;
    }) : this.allData;
    this.pageHandle();
  },
  pageHandle: function pageHandle() {
    var pageNum = this.page.active;
    var pageSize = this.selPage.limit;
    this.page.pageLeng = this.tmpData.length;
    this.tbodyData = this.tmpData.slice((pageNum - 1) * pageSize, pageNum * pageSize);
  },
  export2Excel: function export2Excel() {
    var _this3 = this;

    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      var _require = __webpack_require__(51),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = _this3.tableHead.map(function (v) {
        return v.value;
      });
      var filterVal = _this3.tableHead.map(function (v) {
        return v.key;
      });
      var data = _this3.allData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      var excelName = '' + _this3.language.excelName + (_this3.dateRange ? '_' + _this3.dateRange.map(function (v) {
        return v.replace(/-/g, '');
      }).join('-') : '');
      export_json_to_excel(tHeader, data, excelName);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

var watch = {
  language: function language() {
    var _this4 = this;

    this.allData.forEach(function (v) {
      return v.status = _this4.language.status[v.STATUS];
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components,
  watch: watch
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    dailyLoading: false,
    dayOfReport: null,
    btnStatus: false,
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        var oneMonthBefore = new Date();
        oneMonthBefore.setTime(oneMonthBefore.getTime() - 31 * 24 * 36e5);
        return time.getTime() > now || oneMonthBefore > time.getTime() || [0, 6].includes(time.getDay());
      }
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'symbolProfit' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  tableHead: function tableHead() {
    var redColorColumns = ['PREVIOUS_FLOATING_PL', 'PRESENT_FLOATING_PL', 'PRESENT_CLOSED_PL', 'PRESENT_CLOSED_SWAP', 'PRESENT_NO_COMMISSION_PL', 'PRESENT_CLOSED_COMMISSION', 'PRESENT_IB_COMMISSION', 'PRESENT_PL'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  }
};

var created = function created() {
  var userTime = this.$moment();
  var tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3;
  var tzOfUser = userTime.utcOffset() / 60;
  var mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h');
  var mt4Weekday = mt4Time.weekday();
  var subDays = { 0: 2, 1: 3 };
  this.dayOfReport = mt4Time.subtract(subDays[mt4Weekday] || 1, 'd').format('YYYY-MM-DD');
  if ([0, 6].includes(mt4Weekday)) this.btnStatus = true;else this.ajaxHandle();
};

var methods = {
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_1_api_api__["U" /* URL_SYMBOL_PROFIT */]).then(function (res) {
      var useful = res.data.data;
      if (Object.prototype.toString.call(useful.data) === '[object Array]') _this.tbodyData = useful.data;else _this.tbodyData = [];
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  export2Excel: function export2Excel(datas, excelName) {
    var _this2 = this;

    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      var _require = __webpack_require__(51),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = _this2.tableHead.map(function (v) {
        return v.value;
      });
      var filterVal = _this2.tableHead.map(function (v) {
        return v.key;
      });
      var data = datas.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      export_json_to_excel(tHeader, data, excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  export2EndOfDayExcel: function export2EndOfDayExcel() {
    var _this3 = this;

    if (this.dayOfReport === null) {
      this.$message.warning(this.language.warning);
      return;
    }
    var dayOfReport = this.$moment(this.dayOfReport).format('YYYY-MM-DD');
    this.dailyLoading = true;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_1_api_api__["U" /* URL_SYMBOL_PROFIT */], { dayOfReport: dayOfReport }).then(function (res) {
      var useful = res.data.data;
      var datas = [];
      if (Object.prototype.toString.call(useful.data) === '[object Array]') datas = useful.data;
      _this3.export2Excel(datas, dayOfReport + '_' + _this3.language.excelName);
      _this3.dailyLoading = false;
    }).catch(function (e) {
      alert(_this3.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var data = function data() {
    return {
        tbodyData: [],
        loading: false,
        formData: {
            dateRange: [],
            topValue: 30,
            profitType: 'weekly'
        },
        pickerOptions: {
            disabledDate: __WEBPACK_IMPORTED_MODULE_3_common_js_util__["d" /* enableMondayAndFriday */],
            onPick: __WEBPACK_IMPORTED_MODULE_3_common_js_util__["e" /* enableMondayAndFridayOnPick */]
        },
        disabledDateFunc: {
            'weekly': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["d" /* enableMondayAndFriday */],
            'monthly': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["b" /* enableFirstAndLastDayOfMonth */],
            'daily': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["f" /* enableUntilToday */]
        },
        onPickFunc: {
            'weekly': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["e" /* enableMondayAndFridayOnPick */],
            'monthly': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["c" /* enableFirstAndLastDayOfMonthOnPick */],
            'daily': __WEBPACK_IMPORTED_MODULE_3_common_js_util__["g" /* enableUntilTodayOnPick */]
        }
    };
};

var mixins = [__webpack_require__(2).base({ language: 'profitTopList' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        var columns = this.language[this.formData.profitType] || [];
        columns.forEach(function (head) {
            return head.redColor = true;
        });
        var tableHead = this.language.tableHead || [];
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tableHead), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(columns));
    }
};

var created = function created() {
    this.defaultWeeklyDate();
    this.ajaxHandle();
};

var methods = {
    ajaxHandle: function ajaxHandle() {
        var _this = this;

        this.loading = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["L" /* URL_PROFIT_TOP_LIST */], this.formData).then(function (res) {
            var useful = res.data.data;
            if (Object.prototype.toString.call(useful.data) === '[object Array]') {
                _this.tbodyData = useful.data;
                _this.tbodyData.forEach(function (v) {
                    v.LOGIN = '' + (v.LOGIN || '');
                    v.IB_ID = '' + (v.IB_ID || '');
                });
            } else {
                _this.tbodyData = [];
            }
            _this.loading = false;
        }).catch(function (e) {
            alert(_this.reuse.serverError);
        });
    },
    export2Excel: function export2Excel(datas, excelName) {
        var _this2 = this;

        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            var _require = __webpack_require__(51),
                export_json_to_excel = _require.export_json_to_excel;

            var tHeader = _this2.tableHead.map(function (v) {
                return v.value;
            });
            var filterVal = _this2.tableHead.map(function (v) {
                return v.key;
            });
            var data = datas.map(function (v) {
                return filterVal.map(function (j) {
                    return v[j];
                });
            });
            var reportType = _this2.language.profitType[_this2.formData.profitType];
            var reportDate = _this2.formData.dateRange.map(function (v) {
                return _this2.$moment(v).format('YYYY-MM-DD').replace(/-/g, '');
            }).join('-');
            var name = excelName + '_' + reportType + '_' + reportDate;
            export_json_to_excel(tHeader, data, name, { moneyStyle: '#,##0.00;[Red](#,##0.00)' });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    profitTypeChange: function profitTypeChange(profitType) {
        this.pickerOptions.disabledDate = this.disabledDateFunc[profitType];
        this.pickerOptions.onPick = this.onPickFunc[profitType];
        var defaultFunc = { 'weekly': 'defaultWeeklyDate', 'monthly': 'defaultMonthlyDate', 'daily': 'defaultDailyDate' };
        this[defaultFunc[profitType]]();
        this.ajaxHandle();
    },
    blurHandle: function blurHandle(obj) {
        var profitType = this.formData.profitType;

        this.pickerOptions = {
            disabledDate: this.disabledDateFunc[profitType],
            onPick: this.onPickFunc[profitType]
        };
    },
    defaultWeeklyDate: function defaultWeeklyDate() {
        var weekDay = this.$moment().weekday();
        var startDays = [1, 2, 3, 4, 5].includes(weekDay) ? 6 + weekDay : weekDay === 6 ? 5 : 6;
        var endDays = startDays - 4;
        var startDate = this.$moment().subtract(startDays, 'd').format('YYYY-MM-DD');
        var endDate = this.$moment().subtract(endDays, 'd').format('YYYY-MM-DD');
        this.formData.dateRange = [startDate, endDate];
    },
    defaultMonthlyDate: function defaultMonthlyDate() {
        var lastMonth = this.$moment().subtract(1, 'months');
        var startDate = lastMonth.date(1).format('YYYY-MM-DD');
        var endDate = lastMonth.endOf('month').format('YYYY-MM-DD');
        this.formData.dateRange = [startDate, endDate];
    },
    defaultDailyDate: function defaultDailyDate() {
        var weekday = this.$moment().weekday();
        var index = [6, 0, 1].indexOf(weekday) + 1;
        var subCount = index > 0 ? index : 1;
        var yesterday = this.$moment().subtract(subCount, 'd').format('YYYY-MM-DD');
        this.formData.dateRange = [yesterday, yesterday];
    }
};

var components = {
    customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    components: components
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_api__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ lan: 'downloadReport' }), __webpack_require__(2).base({ reuse: 'reuse' })],
  data: function data() {
    return {
      folderName: '',
      all: [],
      tableData: [],
      pageNum: 1,
      pageSize: 5,
      total: 0
    };
  },

  components: {},
  created: function created() {
    this.searchByFolder();
  },

  computed: {
    folders: function folders() {
      return this.folderName.split('/');
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.tableData = this.all.slice(0, val);
    },
    handlePageChange: function handlePageChange(val) {
      this.pageNum = val;
      this.tableData = this.all.slice((val - 1) * this.pageSize, val * this.pageSize);
    },
    comeBack: function comeBack() {
      if (!this.folderName) return;
      var folders = this.folderName.split('/');
      folders.pop();
      this.folderName = folders.length > 1 ? folders.join('/') : folders.join('');
      this.searchByFolder();
    },
    downloadFile: function downloadFile(row) {
      window.open(__WEBPACK_IMPORTED_MODULE_0_api_api__["o" /* URL_DOWNLOAD */] + '/' + encodeURI(row.name) + '?folderName=' + encodeURI(this.folderName));
    },
    openFolder: function openFolder(row) {
      this.folderName = '' + (this.folderName ? this.folderName + '/' : '') + row.name;
      this.searchByFolder();
    },
    searchByFolder: function searchByFolder() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0_api_api__["P" /* URL_SEARCH */], { params: { folderName: this.folderName } }).then(function (res) {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          _this.all = res.data.data.data;
          _this.handlePageChange(1);
        } else _this.tableData = [];
        _this.total = _this.all.length;
      }).catch(function (e) {
        alert(_this.reuse.serverError);
      });
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    securityList: [],
    formData: {
      closeTime: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null,
      security: ['ALL']
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["a" /* disableDate */],
      onPick: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["n" /* onPick */]
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4ClosedTradesReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var closeTime = this.formData.closeTime;
    return this.language.downloadName + '_' + (closeTime ? closeTime.map(function (v) {
      return v.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['COMMISSION', 'TAXES', 'COMMISSION_AGENT', 'SWAPS', 'PROFIT', 'PIPES'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      CMD: this.language.cmdMapping,
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["E" /* URL_MT4_CLOSED_REPORT */],
      downloadUrl: __WEBPACK_IMPORTED_MODULE_2_api_api__["o" /* URL_DOWNLOAD */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var _this = this;

  this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["Q" /* URL_SECURITY */]).then(function (res) {
    if (Object.prototype.toString.call(res.data.data) === '[object Array]') {
      _this.securityList = res.data.data;
    }
    _this.securityList.push({ TYPE: 'ALL' });
    var defaultEnd = _this.$moment().format('YYYY-MM-DD');
    var defaultStart = _this.$moment().subtract(__WEBPACK_IMPORTED_MODULE_3_api_env__["a" /* days */], 'd').format('YYYY-MM-DD');
    _this.formData.closeTime.push(defaultStart);
    _this.formData.closeTime.push(defaultEnd);
    _this.ajaxHandle();
  });
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this2 = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["E" /* URL_MT4_CLOSED_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this2.page.pageLeng = res.data.data.count;
        _this2.tbodyData = res.data.data.data;
        _this2.tbodyData.forEach(function (v) {
          v.cmd = [0, 1].includes(v.CMD) ? _this2.language.cmdMapping[v.CMD] : '';
        });
      } else {
        _this2.tbodyData = [];
        _this2.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this2.$message.error(_this2.reuse.invalidParam);
      _this2.loading = false;
    }).catch(function (e) {
      alert(_this2.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      return time.getTime() > new Date();
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

var watch = {
  language: function language() {
    var _this3 = this;

    this.tbodyData.forEach(function (v) {
      v.cmd = _this3.language.cmdMapping[v.CMD];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components,
  watch: watch
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      closeTime: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null,
      comment: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["a" /* disableDate */],
      onPick: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["n" /* onPick */]
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4DepositWithdrawlReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var closeTime = this.formData.closeTime;
    return this.language.downloadName + '_' + (closeTime ? closeTime.map(function (v) {
      return v.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['PROFIT'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["F" /* URL_MT4_DEPOSIT_WITHDRAWL_REPORT */],
      downloadUrl: __WEBPACK_IMPORTED_MODULE_2_api_api__["o" /* URL_DOWNLOAD */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(__WEBPACK_IMPORTED_MODULE_3_api_env__["a" /* days */], 'd').format('YYYY-MM-DD');
  this.formData.closeTime.push(defaultStart);
  this.formData.closeTime.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["F" /* URL_MT4_DEPOSIT_WITHDRAWL_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      return time.getTime() > new Date();
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      closeTime: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["a" /* disableDate */],
      onPick: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["n" /* onPick */]
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4CreditReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var closeTime = this.formData.closeTime;
    return this.language.downloadName + '_' + (closeTime ? closeTime.map(function (v) {
      return v.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['PROFIT'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["k" /* URL_CREDIT_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(__WEBPACK_IMPORTED_MODULE_3_api_env__["a" /* days */], 'd').format('YYYY-MM-DD');
  this.formData.closeTime.push(defaultStart);
  this.formData.closeTime.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["k" /* URL_CREDIT_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      return time.getTime() > new Date();
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      closeTime: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["a" /* disableDate */],
      onPick: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["n" /* onPick */]
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4SummaryReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var closeTime = this.formData.closeTime;
    return this.language.downloadName + '_' + (closeTime ? closeTime.map(function (v) {
      return v.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['DEPOSIT', 'WITHDRAWL', 'INOUT', 'CREDIT', 'COMMISSION', 'TAXES', 'AGENT', 'SWAPS', 'PROFIT', 'BALANCE'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["S" /* URL_SUMMARY_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(__WEBPACK_IMPORTED_MODULE_3_api_env__["a" /* days */], 'd').format('YYYY-MM-DD');
  this.formData.closeTime.push(defaultStart);
  this.formData.closeTime.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["S" /* URL_SUMMARY_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
        _this.tbodyData.forEach(function (v) {
          v.Value_TIME = v.CLOSE_TIME ? _this.$moment(v.CLOSE_TIME).format('YYYY.MM.DD') : '';
        });
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      return time.getTime() > new Date();
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4SeregatedReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    return this.language.downloadName;
  },
  tableHead: function tableHead() {
    var redColorColumns = ['BALANCE', 'UNREALIZED', 'EQUITY'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["R" /* URL_SEREGATED_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["R" /* URL_SEREGATED_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      date: null,
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        return time.getTime() > now;
      }
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4EquityReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var date = this.formData.date;
    return this.language.downloadName + '_' + (date ? date.replace(/-/g, '') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['PL_BALANCE', 'PL_BALANCE_TMP', 'CLOSED_PL', 'DEPOSIT', 'BALANCE', 'FLOATING_PL', 'CREDIT', 'EQUITY', 'USED_MARGIN', 'MARGIN_FREE'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["q" /* URL_EQUITY_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultStart = this.$moment().subtract(1, 'd').format('YYYY-MM-DD');
  this.formData.date = defaultStart;
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["q" /* URL_EQUITY_REPORT */], this.formData).then(function (res) {
      var useful = res.data.data;
      if (Object.prototype.toString.call(useful.data) === '[object Array]') {
        _this.page.pageLeng = useful.count;
        _this.tbodyData = useful.data;
        useful.miss.forEach(function (m) {
          _this.tbodyData.push({ LOGIN: m });
        });
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      dateRange: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        return time.getTime() > now;
      },

      onPick: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["n" /* onPick */]
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4EquityMultiReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var date = this.formData.dateRange;
    return this.language.downloadName + '_' + (date ? date.map(function (val) {
      return val.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['CLOSED_PL', 'DEPOSIT', 'BALANCE', 'FLOATING_PL', 'CREDIT', 'EQUITY', 'USED_MARGIN', 'MARGIN_FREE'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["p" /* URL_EQUITY_MULTI_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().subtract(1, 'd').format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(3, 'd').format('YYYY-MM-DD');
  this.formData.dateRange.push(defaultStart);
  this.formData.dateRange.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["p" /* URL_EQUITY_MULTI_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  blurHandle: function blurHandle(obj) {
    this.pickerOption.disabledDate = function (time) {
      var now = new Date();
      now.setTime(now.getTime() - 24 * 36e5);
      return time.getTime() > now;
    };
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      dateRange: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    pickerOptions: {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        now.setTime(now.getTime() - 24 * 36e5);
        return time.getTime() > now || time.getDay() == 6;
      }
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4ProfitLossReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    var date = this.formData.dateRange;
    return this.language.downloadName + '_' + (date ? date.map(function (val) {
      return val.replace(/-/g, '');
    }).join('-') : '');
  },
  tableHead: function tableHead() {
    var redColorColumns = ['TOTAL_CLOSE_PL', 'PREVIOUS_FLOATING', 'PRESENT_FLOATING', 'PREVIOUS_EQUITY', 'PRESENT_EQUITY', 'PROFITLOSS'];
    this.language.tableHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["J" /* URL_PROFITLOSS_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  var defaultEnd = this.$moment().subtract(1, 'd').format('YYYY-MM-DD');
  var defaultStart = this.$moment().subtract(3, 'd').format('YYYY-MM-DD');
  this.formData.dateRange.push(defaultStart);
  this.formData.dateRange.push(defaultEnd);
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["J" /* URL_PROFITLOSS_REPORT */], this.formData).then(function (res) {
      var useful = res.data.data;
      if (Object.prototype.toString.call(useful.data) === '[object Array]') {
        _this.page.pageLeng = useful.count;
        _this.tbodyData = useful.data;
        var miss = useful.miss || [];
        miss.forEach(function (m) {
          return _this.tbodyData.push({ LOGIN: m });
        });
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_env__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'mt4AccountReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    return this.language.downloadName;
  },
  tableHead: function tableHead() {
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_2_api_api__["a" /* URL_ACCOUNT_REPORT */],
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.formData, {
        pageSize: -1,
        pageNum: 0
      })
    };
  }
};

var created = function created() {
  this.ajaxHandle();
};

var methods = {
  filterHandle: function filterHandle() {
    this.page.active = 1;
    this.ajaxHandle();
  },
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.formData.pageNum = this.page.active;
    this.formData.pageSize = this.selPage.limit;
    this.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["a" /* URL_ACCOUNT_REPORT */], this.formData).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      if (res.data.msg !== 'OK') _this.$message.error(_this.reuse.invalidParam);
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_api__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
    return {
        tbodyData: [],
        summaryData: [],
        allData: [],
        tmpData: [],
        type: '-1',
        loading: false,
        operateDay: new Date(),
        noRecordReason: '',
        page: {
            active: 1,
            pageLeng: 0,
            offset: 0
        },
        selPage: {
            list: ['5', '10', '25', '50'],
            active: 1,
            limit: 10
        }
    };
};

var mixins = [__webpack_require__(2).base({ language: 'managerOperateRecord' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        var redColorColumns = ['old_profit', 'new_profit'];
        this.language.tableHead.forEach(function (head) {
            if (redColorColumns.includes(head.key)) head.redColor = true;
        });
        return this.language.tableHead;
    },
    summaryHead: function summaryHead() {
        return this.language.summaryHead;
    },
    noDataMessage: function noDataMessage() {
        return this.language.noData[this.noRecordReason];
    }
};

var created = function created() {
    this.ajaxHandle();
};

var methods = {
    filterHandle: function filterHandle() {
        this.page.active = 1;
        this.ajaxHandle();
    },
    ajaxHandle: function ajaxHandle() {
        var _this = this;

        this.loading = true;
        var operateDay = this.$moment(this.operateDay).format('YYYY-MM-DD');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["D" /* URL_MANAGER_OPERATE_LOG */], { params: { operateDay: operateDay } }).then(function (res) {
            var _res$data$data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(res.data.data, 3),
                all = _res$data$data[0],
                summary = _res$data$data[1],
                noRecordReason = _res$data$data[2];

            _this.allData = all || [];
            _this.summaryData = summary || [];
            if (noRecordReason) _this.noRecordReason = noRecordReason;else _this.noRecordReason = '';
            _this.allData.forEach(function (record) {
                return record.TYPE = _this.language.operateTypeMapping[record.type] || '';
            });
            _this.selectHandle();
            _this.loading = false;
        }).catch(function (e) {
            _this.tbodyData = [];
            _this.loading = false;
            alert(_this.reuse.serverError);
        });
    },
    selectHandle: function selectHandle() {
        var _this2 = this;

        this.page.active = 1;
        this.tmpData = this.type > -1 ? this.allData.filter(function (v) {
            return v.type == _this2.type;
        }) : this.allData;
        this.pageHandle();
    },
    pageHandle: function pageHandle() {
        var pageNum = this.page.active;
        var pageSize = this.selPage.limit;
        this.page.pageLeng = this.tmpData.length;
        this.tbodyData = this.tmpData.slice((pageNum - 1) * pageSize, pageNum * pageSize);
    },
    export2Excel: function export2Excel() {
        var _this3 = this;

        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            var _require = __webpack_require__(51),
                export_json_to_multi_excel = _require.export_json_to_multi_excel;

            var sheet1TitleObj = _this3.tableHead.reduce(function (p, c) {
                p[c.key] = c.value;
                return p;
            }, {});
            var sheet2TitleObj = _this3.summaryHead.reduce(function (p, c) {
                p[c.key] = c.value;
                return p;
            }, {});
            var sheet1Data = _this3.formatJson(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sheet1TitleObj), _this3.allData);
            var sheet2Data = _this3.formatJson(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sheet2TitleObj), _this3.summaryData);
            var excelName = _this3.language.downloadName + '_' + _this3.operateDay;
            export_json_to_multi_excel([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(sheet1TitleObj), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(sheet2TitleObj)], [sheet1Data, sheet2Data], _this3.language.sheetNames, excelName);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
        return jsonData.map(function (v) {
            return filterVal.map(function (j) {
                return v[j];
            });
        });
    }
};

var components = {
    customTable: __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__["a" /* default */]
};

var watch = {
    language: function language() {
        var _this4 = this;

        this.allData.forEach(function (v) {
            return v.TYPE = _this4.language.operateTypeMapping[v.type] || '';
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    components: components,
    watch: watch
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
    return {
        tbodyData: [],
        allData: [],
        searchVal: null,
        searchKey: 'ip',
        loading: false,
        validKeys: {
            ip: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
            login: /^[1-9]\d{0,11}$/
        },
        page: {
            active: 1,
            pageLeng: 0,
            offset: 0
        },
        selPage: {
            list: ['5', '10', '25', '50'],
            active: 1,
            limit: 10
        }
    };
};

var mixins = [__webpack_require__(2).base({ language: 'loginRecord' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        return this.language.tableHead;
    }
};

var created = function created() {
    // this.ajaxHandle();
};

var methods = {
    ajaxHandle: function ajaxHandle() {
        var _this = this;

        var searchVal = this.searchVal,
            searchKey = this.searchKey,
            validKeys = this.validKeys;

        var reg = validKeys[searchKey];
        if (!reg.test(searchVal)) {
            this.$message.warning(this.language.validWarning);
            return;
        }
        this.page.active = 1;
        this.loading = true;
        this.$http.get(__WEBPACK_IMPORTED_MODULE_1_api_api__["A" /* URL_LOGIN_RECORD */], { params: { searchKey: searchKey, searchVal: searchVal } }).then(function (res) {
            _this.allData = res.data.data;
            _this.pageHandle();
            _this.loading = false;
        }).catch(function (e) {
            _this.tbodyData = [];
            _this.loading = false;
            alert(_this.reuse.serverError);
        });
    },
    pageHandle: function pageHandle() {
        var pageNum = this.page.active;
        var pageSize = this.selPage.limit;
        this.page.pageLeng = this.allData.length;
        this.tbodyData = this.allData.slice((pageNum - 1) * pageSize, pageNum * pageSize);
    },
    export2Excel: function export2Excel() {
        var _this2 = this;

        var header = this.language.ipTableHead;
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            var _require = __webpack_require__(51),
                export_json_to_excel = _require.export_json_to_excel;

            var tHeader = _this2.tableHead.map(function (v) {
                return v.value;
            });
            var filterVal = _this2.tableHead.map(function (v) {
                return v.key;
            });
            var data = _this2.allData.map(function (v) {
                return filterVal.map(function (j) {
                    return v[j];
                });
            });
            export_json_to_excel(tHeader, data, _this2.language.downloadName);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var components = {
    customTable: __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    components: components
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_multipleSelect__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_util__ = __webpack_require__(43);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__webpack_require__(2).base({ lan: 'dayTradeReport' }), __webpack_require__(2).base({ reuse: 'reuse' })],
    data: function data() {
        return {
            loading: false,
            loadText: '',
            closeTime: [],
            pointVal: 50,
            ownTime: 3,
            profit: '',
            tbodyData: [],
            more: false,
            login: '',
            ibNum: '',
            symbol: '',
            type: '0',
            office: null,
            region: null,
            security: ['ALL'],
            canSelect: true,
            intervalID: '',
            timeDiff: 0,
            securityList: [],
            page: {
                active: 1,
                pageLeng: 0,
                offset: 0
            },
            selPage: {
                list: ['5', '10', '25', '50'],
                active: 1,
                limit: 10
            },
            sort: {
                list: 'All',
                active: { key: 'Close_Time', order: 'DESC' }
            },
            visibleTableHeaders: [],
            initRemember: false,
            userRememberItem: '',
            maxCloseTime: null
        };
    },

    computed: {
        tableHead: function tableHead() {
            var redColorColumns = ['Commission', 'Swaps', 'Profit', 'TOTAL_PL_MONTHLY', 'TOTAL_CLOSE_PL', 'TOTAL_FLOATING_PL', 'TOTAL_PL'];
            this.lan.tableHead.forEach(function (head) {
                if (redColorColumns.includes(head.key)) head.redColor = true;
            });
            return this.lan.tableHead;
        },
        vTableHeader: function vTableHeader() {
            var _this = this;

            return this.lan.tableHead.filter(function (item) {
                return _this.visibleTableHeaders.includes(item.key);
            });
        },
        initPlaceholder: function initPlaceholder() {
            return this.reuse.showMoreColumns;
        },
        name: function name() {
            return this.lan.downloadName;
        },
        jsonExcelAjax: function jsonExcelAjax() {
            return {
                url: __WEBPACK_IMPORTED_MODULE_2_api_api__["K" /* URL_PROFITREPORT */],
                ajaxType: 'get',
                getKey: ['data', 'data', 'data'],
                ajaxPar: {
                    pageSize: -1,
                    pageNum: 0,
                    closeTime: this.closeTime,
                    pointVal: this.pointVal,
                    ownTime: this.ownTime,
                    profit: this.profit,
                    login: this.login,
                    ibNum: this.ibNum,
                    office: this.office,
                    region: this.region,
                    symbol: this.symbol,
                    security: this.security,
                    sortKey: this.sort.active.key,
                    order: this.sort.active.order
                }
            };
        }
    },
    components: {
        reuseTable: __WEBPACK_IMPORTED_MODULE_3_components_reuseTable__["a" /* default */],
        multipleSelect: __WEBPACK_IMPORTED_MODULE_4_components_multipleSelect__["a" /* default */]
    },
    created: function created() {
        var _this2 = this;

        this.userRememberItem = (JSON.parse(sessionStorage.getItem("user")) || {}).name + 'DayTradeReportVisible';
        var visible = localStorage.getItem(this.userRememberItem);
        if (visible) {
            this.initRemember = true;
            this.visibleTableHeaders = JSON.parse(visible);
        } else {
            this.visibleTableHeaders = this.lan.tableHead.map(function (v) {
                return v.key;
            });
        }
        this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["V" /* URL_TIMEDIFF */]).then(function (res) {
            _this2.timeDiff = res.data.data.diff;
            _this2.closeTime = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_util__["k" /* getToDay */])(_this2.timeDiff);
            _this2.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["Q" /* URL_SECURITY */]).then(function (res) {
                if (Object.prototype.toString.call(res.data.data) === '[object Array]') _this2.securityList = res.data.data;
                _this2.securityList.push({ TYPE: 'ALL' });
                _this2.requestEngine();
            });
            _this2.$nextTick(function () {
                this.intervalID = setInterval(this.searchHandle, 6e4);
            });
        }).catch(function (e) {
            alert(_this2.reuse.serverError);
        });
    },
    destroyed: function destroyed() {
        clearInterval(this.intervalID);
    },

    methods: {
        searchHandle: function searchHandle() {
            this.page.active = 1;
            this.requestEngine();
        },
        requestEngine: function requestEngine() {
            var _this3 = this;

            if (!this.closeTime) {
                this.$message({ message: this.reuse.selectTimeText, type: 'warning' });
                return;
            }
            var option = { params: {} };
            option.params.closeTime = this.closeTime;
            option.params.pageNum = this.page.active;
            option.params.pageSize = +this.selPage.limit;
            option.params.security = this.security;

            var paramsArr = ['pointVal', 'ownTime', 'profit', 'login', 'ibNum', 'office', 'region'];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(paramsArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var val = _step.value;

                    if (this[val] && this.tipMessage(this[val])) return;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            paramsArr.push('symbol');
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(paramsArr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _val = _step2.value;

                    if (this[_val]) option.params[_val] = this[_val];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (this.sort.active.order) {
                option.params.sortKey = this.sort.active.key;
                option.params.order = this.sort.active.order;
            }
            this.loading = true;
            this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["K" /* URL_PROFITREPORT */], option).then(function (res) {
                if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
                    _this3.page.pageLeng = res.data.data.count;
                    _this3.tbodyData = res.data.data.data;
                } else {
                    _this3.tbodyData = [];
                    _this3.page.pageLeng = 0;
                }
                _this3.loading = false;
                if (_this3.maxCloseTime) {
                    _this3.tbodyData.map(function (item) {
                        var closeStr = item.Close_Date + ' ' + item.Close_Time;
                        item.bgColor = _this3.$moment(closeStr).isAfter(_this3.maxCloseTime);
                    });
                    return;
                }
                // const latest = this.tbodyData[0] || {}
                // const closeTimeStr = `${latest.Close_Date} ${latest.Close_Time}`
                // const close = closeTimeStr ? closeTimeStr : getCurrentMT4Time(this.timeDiff)
                var close = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_util__["i" /* getCurrentMT4Time */])(_this3.timeDiff);
                _this3.maxCloseTime = _this3.$moment(close);
            }).catch(function (e) {
                alert(_this3.reuse.serverError);
            });
        },
        tipMessage: function tipMessage(value, message) {
            if (isNaN(new Number(value))) {
                this.$message({ message: this.reuse.pleaseInputNumber, type: 'warning' });
                this.tbodyData = [];
                this.page.pageLeng = 0;
                return true;
            }
        },
        changeTime: function changeTime() {
            if (this.type == '3') {
                this.canSelect = false;
                return;
            }
            this.canSelect = true;
            switch (this.type) {
                case '0':
                    this.closeTime = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_util__["k" /* getToDay */])(this.timeDiff);
                    break;
                case '1':
                    this.closeTime = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_util__["l" /* getWeekStartAndEnd */])(0, this.timeDiff);
                    break;
                case '2':
                    this.closeTime = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_util__["j" /* getMonthStartAndEnd */])(0, this.timeDiff);
                    break;
                default:
                    break;
            }
            this.searchHandle();
        },
        hideTableHeader: function hideTableHeader(selectedVal) {
            var _this4 = this;

            var rememberKey = this.reuse.rememberMyChoice.key;
            if (selectedVal.includes(rememberKey)) {
                var visibleStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedVal.filter(function (key) {
                    return ![_this4.reuse.selectAll.key, rememberKey].includes(key);
                }));
                localStorage[this.userRememberItem] = visibleStr;
            } else {
                localStorage.removeItem(this.userRememberItem);
            }
            this.visibleTableHeaders = selectedVal;
        }
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__webpack_require__(2).base({ reuseLan: 'reuse' })],
    model: {
        prop: "initSelectValues",
        event: "change"
    },
    props: {
        initSelectValues: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 下拉选项
        options: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 选项键值对
        props: {
            type: Object,
            default: function _default() {
                return {
                    label: "value",
                    value: "key"
                };
            }
        },
        initPlaceholder: {
            type: String,
            default: function _default() {
                return "";
            }
        },
        initRemember: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            selectValues: [],
            isSelectAll: false
            // rememberMyChoice: false,
        };
    },

    watch: {
        // 监听（全选，全不选以及checkbox是否勾选）
        selectValues: function selectValues() {
            this.changeHandler();
        },
        options: function options() {
            this.changeHandler();
        }
    },
    created: function created() {
        // 回显
        this.selectValues = this.initSelectValues;
        // this.rememberMyChoice = this.initRemember
        if (this.initRemember) this.selectValues.push(this.reuseLan.rememberMyChoice.key);
    },
    updated: function updated() {
        this.$children[0].$children[1].$refs.input.placeholder = this.initPlaceholder;
    },

    methods: {
        changeSelect: function changeSelect(val) {
            var _this = this;

            if (val.includes(this.reuseLan.selectAll.key)) {
                var cancelSelectAll = val.length > this.options.length;
                this.selectValues = cancelSelectAll ? [] : this.options.map(function (item) {
                    return item[_this.props.value];
                });
            }
            var rememberKey = this.reuseLan.rememberMyChoice.key;
            if (!this.selectValues.includes(rememberKey) && val.includes(rememberKey)) this.selectValues.push(rememberKey);
            this.$emit("change", this.selectValues);
        },
        changeHandler: function changeHandler() {
            var _this2 = this;

            var arr = this.selectValues;
            var selectAll = true;
            this.options.forEach(function (item) {
                item.isCheck = arr.includes(item[_this2.props.value]);
                if (selectAll && !item.isCheck) selectAll = false;
            });
            // this.rememberMyChoice = arr.includes(this.reuseLan.rememberMyChoice.key)
            this.isSelectAll = selectAll;
            // 强制更新（checkbox回显)
            this.$forceUpdate();
        }
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_util__ = __webpack_require__(43);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ lan: 'positionReport' }), __webpack_require__(2).base({ reuse: 'reuse' })],
  data: function data() {
    return {
      loading: false,
      loadText: '',
      page: {
        active: 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: {
        list: ['5', '10', '25', '50'],
        active: 1,
        limit: 10
      },
      sort: {
        list: 'All',
        active: { key: 'Open_Time', order: 'DESC' }
      },
      tbodyData: [],
      more: false,
      from: '',
      to: '',
      login: '',
      ibNum: '',
      office: null,
      region: null,
      symbol: '',
      canSelect: true,
      openTime: [],
      type: '0',
      security: ['ALL'],
      intervalID: '',
      diff: 0,
      securityList: []
    };
  },

  components: {
    reuseTable: __WEBPACK_IMPORTED_MODULE_2_components_reuseTable__["a" /* default */]
  },
  computed: {
    tableHead: function tableHead() {
      var redColorColumns = ['Commission', 'Swaps', 'Profit', 'TOTAL_CLOSE_PL', 'TOTAL_FLOATING_PL', 'TOTAL_PL'];
      this.lan.tableHead.forEach(function (head) {
        if (redColorColumns.includes(head.key)) head.redColor = true;
      });
      return this.lan.tableHead;
    },
    name: function name() {
      return this.lan.downloadName;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: __WEBPACK_IMPORTED_MODULE_1_api_api__["G" /* URL_OPENDEAL */],
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        ajaxPar: {
          pageSize: -1,
          pageNum: 0,
          openTime: this.openTime,
          symbol: this.symbol,
          from: this.from,
          to: this.to,
          login: this.login,
          ibNum: this.ibNum,
          office: this.office,
          region: this.region,
          security: this.security,
          sortKey: this.sort.active.key,
          order: this.sort.active.order
        }
      };
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_1_api_api__["V" /* URL_TIMEDIFF */]).then(function (res) {
      _this.diff = res.data.data.diff;
      _this.openTime = Object(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["k" /* getToDay */])(_this.diff);
      _this.$http.get(__WEBPACK_IMPORTED_MODULE_1_api_api__["Q" /* URL_SECURITY */]).then(function (res) {
        if (Object.prototype.toString.call(res.data.data) === '[object Array]') {
          _this.securityList = res.data.data;
        }
        _this.securityList.push({ TYPE: 'ALL' });
        _this.requestEngine();
      });
      _this.$nextTick(function () {
        this.intervalID = setInterval(this.searchHandle, 6e4);
      });
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.intervalID);
  },

  methods: {
    searchHandle: function searchHandle() {
      this.page.active = 1;
      this.requestEngine();
    },
    requestEngine: function requestEngine() {
      var _this2 = this;

      if (!this.openTime) {
        this.$message({ message: this.reuse.selectTimeText, type: 'warning' });
        return;
      }
      var paramsArray = ['from', 'to', 'login', 'ibNum', 'office', 'region'];
      // 檢查from、to是不是number
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramsArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;
          if (this[v] && this.tipMessage(this[v])) return;
        } // 檢查from、to是不是正數
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (Math.abs(this.from) !== +this.from || Math.abs(this.to) !== +this.to) {
        this.$message({ message: this.lan.plusNumber, type: 'warning' });
        return;
      }
      // 檢查手數範圍是不是正確的,to須大於from
      if (this.from && this.to && this.from > this.to) {
        this.$message({ message: this.lan.rightRange, type: 'warning' });
        return;
      }
      var option = { params: {} };
      option.params.openTime = this.openTime;
      option.params.pageNum = this.page.active;
      option.params.pageSize = +this.selPage.limit;
      option.params.security = this.security;
      paramsArray.push('symbol');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramsArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _v = _step2.value;
          if (this[_v]) option.params[_v] = this[_v];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.sort.active.order) {
        option.params.sortKey = this.sort.active.key;
        option.params.order = this.sort.active.order;
      }
      this.loading = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1_api_api__["G" /* URL_OPENDEAL */], option).then(function (res) {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          _this2.page.pageLeng = res.data.data.count;
          _this2.tbodyData = res.data.data.data;
        } else {
          _this2.tbodyData = [];
          _this2.page.pageLeng = 0;
        }
        _this2.loading = false;
      }).catch(function (e) {
        alert(_this2.reuse.serverError);
      });
    },
    tipMessage: function tipMessage(value, key) {
      if (isNaN(new Number(value))) {
        this.$message({
          message: this.reuse.pleaseInputNumber,
          type: 'warning'
        });
        this.tbodyData = [];
        this.page.pageLeng = 0;
        return true;
      }
    },
    changeTime: function changeTime() {
      if (this.type == '3') {
        this.canSelect = false;
        return;
      }
      this.canSelect = true;
      switch (this.type) {
        case '0':
          this.openTime = Object(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["k" /* getToDay */])(this.diff);
          break;
        case '1':
          this.openTime = Object(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["l" /* getWeekStartAndEnd */])(0, this.diff);
          break;
        case '2':
          this.openTime = Object(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["j" /* getMonthStartAndEnd */])(0, this.diff);
          break;
        default:
          break;
      }
      this.searchHandle();
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__webpack_require__(2).base({ lan: 'bBookReport' }), __webpack_require__(2).base({ reuse: 'reuse' })],
  data: function data() {
    return {
      tbodyData: [],
      group: 'BUK',
      account: '400021',
      loading: false
    };
  },

  components: {
    sllTable: __WEBPACK_IMPORTED_MODULE_1_components_reuseTable__["a" /* default */]
  },
  created: function created() {
    this.requestEngine();
  },

  computed: {
    downLoadTran: function downLoadTran() {
      return { SYMBOL: this.lan.sum };
    },
    tableHead: function tableHead() {
      var redColorColumns = ['B_NET_VOLUME', 'B_PROFIT', 'A_NET_VOLUME', 'A_PROFIT', 'NET_PROFIT'];
      this.lan.tableHead.forEach(function (head) {
        if (redColorColumns.includes(head.key)) head.redColor = true;
      });
      return this.lan.tableHead;
    },
    name: function name() {
      return this.lan.downloadName;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: __WEBPACK_IMPORTED_MODULE_0_api_api__["g" /* URL_BBOOKREPORT */],
        ajaxType: 'get',
        getKey: ['data', 'data'],
        ajaxPar: {
          group: this.group,
          account: this.account
        }
      };
    }
  },
  methods: {
    requestEngine: function requestEngine() {
      var _this = this;

      if (!this.account) {
        this.$message({ message: this.lan.tip, type: 'warning' });
        return;
      }
      this.loading = true;
      var option = { params: { group: this.group, account: this.account } };
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0_api_api__["g" /* URL_BBOOKREPORT */], option).then(function (res) {
        if (Object.prototype.toString.call(res.data.data) === '[object Array]') _this.tbodyData = res.data.data;else _this.tbodyData = [];
        _this.tbodyData.forEach(function (v, i) {
          if (i == _this.tbodyData.length - 1) v.SYMBOL = _this.lan.sum[v.SYMBOL];
        });
        _this.loading = false;
      }).catch(function (e) {
        alert(_this.reuse.serverError);
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_api__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  };
};

var mixins = [__webpack_require__(2).base({ language: 'clientReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  name: function name() {
    return this.language.downloadName;
  },
  tableHead: function tableHead() {
    return this.language.tableHead;
  },
  downLoadTran: function downLoadTran() {
    return {
      ENABLE: this.language.enableMapper,
      loadText: this.language.loadText
    };
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: __WEBPACK_IMPORTED_MODULE_1_api_api__["i" /* URL_CLIENT_REPORT */],
      ajaxType: 'get',
      getKey: ['data', 'data', 'data'],
      ajaxPar: {
        pageSize: -1,
        pageNum: 0
      }
    };
  }
};

var created = function created() {
  this.ajaxHandle();
};

var methods = {
  ajaxHandle: function ajaxHandle() {
    var _this = this;

    this.loading = true;
    this.$http.get(__WEBPACK_IMPORTED_MODULE_1_api_api__["i" /* URL_CLIENT_REPORT */], {
      params: { pageNum: this.page.active, pageSize: this.selPage.limit }
    }).then(function (res) {
      if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
        _this.page.pageLeng = res.data.data.count;
        _this.tbodyData = res.data.data.data;
        _this.tbodyData.forEach(function (v) {
          v.enable = [0, 1].includes(v.ENABLE) ? _this.language.enableMapper[v.ENABLE] : '';
        });
      } else {
        _this.tbodyData = [];
        _this.page.pageLeng = 0;
      }
      _this.loading = false;
    }).catch(function (e) {
      alert(_this.reuse.serverError);
    });
  }
};

var components = {
  customTable: __WEBPACK_IMPORTED_MODULE_0_components_reuseTable__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  components: components
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(43);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var data = function data() {
  return {
    tbodyData: [],
    accInfo: null,
    loadAccInfo: false,
    addAccWindow: false,
    ipTableWindow: false,
    keyword: '',
    allIps: [],
    filterIps: [],
    ipsData: [],
    ipPageNum: 1,
    ipPageSize: 5,
    ipTotal: 0,
    commentType: '',
    accForm: {
      login: null,
      comment: null
    },
    pageNum: 1,
    pageSize: 5,
    total: 0,
    notify: false,
    notifyData: {},
    intervalId: null
  };
};

var mixins = [__webpack_require__(2).base({ language: 'monitorAccounts' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
  accHead: function accHead() {
    var redColorColumns = ['DEPOSIT_TODAY', 'WITHDRAWAL_TODAY', 'CLOSED_PL', 'TOTAL_FLOATING_PL', 'TOTAL_CLOSE_PL', 'TOTAL_PL'];
    this.language.accHead.forEach(function (head) {
      if (redColorColumns.includes(head.key)) head.redColor = true;
    });
    return this.language.accHead;
  },
  tableHead: function tableHead() {
    return this.language.tableHead;
  },
  rules: function rules() {
    return this.language.rules;
  },
  notifyCount: function notifyCount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.notifyData).reduce(function (p, c) {
      if (_this.notifyData[c] != null) return p + 1;else return p;
    }, 0);
  }
};

var created = function created() {
  this.getAccount();
  this.checkTrades();
  this.intervalId = setInterval(this.checkTrades, 3e5);
};

var destroyed = function destroyed() {
  clearInterval(this.intervalId);
};

var methods = {
  refreshAcc: function refreshAcc() {
    this.pageNum = 1;
    this.getAccount();
  },
  addAccount: function addAccount() {
    var _this2 = this;

    this.$refs.accForm.validate(function (valid) {
      if (valid) {
        var createdBy = JSON.parse(sessionStorage.getItem('user') || '{}').name;
        _this2.$http.post(__WEBPACK_IMPORTED_MODULE_3_api_api__["y" /* URL_HANDLE_ACCOUNT */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ handleType: 'i', createdBy: createdBy }, _this2.accForm)).then(function (res) {
          var code = res.data.data;
          if (code === 9000) {
            _this2.$message({ message: _this2.language.addSuccess, type: 'success' });
            _this2.getAccount();
          } else _this2.$message({ message: _this2.language.addFailed, type: 'error' });
          _this2.resetAccInfo();
        });
      }
    });
  },
  getAccount: function getAccount() {
    var _this3 = this;

    this.loadAccInfo = true;
    this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api__["v" /* URL_GET_MONOTOR_ACCOUNT */], { params: { pageNum: this.pageNum, pageSize: this.pageSize } }).then(function (res) {
      var result = res.data.data;
      _this3.total = result.count;
      _this3.accInfo = result.rows;
      _this3.loadAccInfo = false;
    });
  },
  updateAccount: function updateAccount(row) {
    var _this4 = this;

    var login = row.LOGIN;
    var lg = this.language;
    this.$confirm(lg.updateMsg1Txt + '(' + login + ')' + lg.updateMsg2Txt, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(function () {
      var body = {
        LOGIN: login,
        COMMENT_1: row.COMMENT_1 || null,
        COMMENT_2: row.COMMENT_2 || null,
        COMMENT_3: row.COMMENT_3 || null,
        COMMENT_4: row.COMMENT_4 || null,
        COMMENT_5: row.COMMENT_5 || null,
        handleType: 'u'
      };
      _this4.$http.post(__WEBPACK_IMPORTED_MODULE_3_api_api__["y" /* URL_HANDLE_ACCOUNT */], body).then(function (res) {
        var code = res.data.data;
        if (code == 9000) {
          _this4.$message({ message: lg.updateSuccess, type: 'success' });
          _this4.getAccount();
        } else {
          _this4.$message({ message: lg.updateFailed, type: 'info' });
        }
      });
    });
  },
  deleteAccount: function deleteAccount(login) {
    var _this5 = this;

    var lg = this.language;
    this.$confirm(lg.deleteMsgTxt + '(' + login + ')', lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(function () {
      _this5.$http.post(__WEBPACK_IMPORTED_MODULE_3_api_api__["y" /* URL_HANDLE_ACCOUNT */], { login: login, handleType: 'd' }).then(function (res) {
        var code = res.data.data;
        if (code == 9000) {
          _this5.$message({ message: lg.delSuccess, type: 'success' });
          _this5.getAccount();
        } else {
          _this5.$message({ message: lg.delFailed, type: 'info' });
        }
      });
    });
  },
  checkTrades: function checkTrades() {
    var _this6 = this;

    var userTime = this.$moment();
    var tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3;
    var tzOfUser = userTime.utcOffset() / 60;
    var mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h');
    var end = mt4Time.format('YYYY-MM-DD HH:mm'),
        hmOfEnd = mt4Time.format('HH:mm');
    mt4Time.subtract(5, 'minute');
    var start = mt4Time.format('YYYY-MM-DD HH:mm'),
        hmOfStart = mt4Time.format('HH:mm');
    this.$http.get(__WEBPACK_IMPORTED_MODULE_3_api_api__["h" /* URL_CHECK_TRADES */], { params: { start: start, end: end } }).then(function (res) {
      var trades = res.data.data;
      if (Array.isArray(trades) && trades.length !== 0) {
        Object(__WEBPACK_IMPORTED_MODULE_4_common_js_util__["m" /* makeSound */])();
        var tmpObj = {};
        tmpObj[hmOfStart + ' - ' + hmOfEnd] = trades;
        _this6.notifyData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.notifyData, tmpObj);
      }
    });
  },
  resetAccInfo: function resetAccInfo() {
    this.addAccWindow = false;
    this.commentType = '';
    this.$refs.accForm.resetFields();
  },
  handlePageChange: function handlePageChange(val) {
    this.pageNum = val;
    this.getAccount();
  },
  handleSizeChange: function handleSizeChange(val) {
    this.pageNum = 1;
    this.pageSize = val;
    this.getAccount();
  },
  showTable: function showTable(ipRelatedLogins) {
    this.ipTableWindow = true;
    this.allIps = ipRelatedLogins || [];
    this.ipTotal = ipRelatedLogins.length;
    this.filterIps = this.allIps.filter(function (v) {
      return true;
    });
    this.ipsData = this.filterIps.slice(0, this.ipPageSize);
  },
  handleIPPageChange: function handleIPPageChange(val) {
    this.ipPageNum = val;
    this.ipsData = this.filterIps.slice((val - 1) * this.ipPageSize, val * this.ipPageSize);
  },
  handleIPSizeChange: function handleIPSizeChange(val) {
    this.ipPageNum = 1;
    this.ipPageSize = val;
    this.ipsData = this.filterIps.slice(0, val);
  },
  handleWindowClose: function handleWindowClose() {
    this.keyword = '';
    this.ipPageNum = 1;
    this.ipTotal = 0;
    this.ipsData = [];
    this.filterIps = [];
    this.allIps = [];
  },
  findByKeyword: function findByKeyword() {
    var kw = this.keyword;
    this.filterIps = this.allIps.filter(function (data) {
      return !kw || data.IP.includes(kw) || (data.RELATED_LOGINS || '').includes(kw);
    });
    this.ipTotal = this.filterIps.length;
    this.handleIPPageChange(1);
  },
  handleCommentChange: function handleCommentChange(val) {
    this.$refs.accForm.clearValidate('comment');
    this.accForm.comment = val == 6 ? null : this.language.commentOpt[val];
  },
  export2Excel: function export2Excel() {
    var _this7 = this;

    var header = this.language.ipTableHead;
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      var _require = __webpack_require__(51),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = header.map(function (v) {
        return v.value;
      });
      var filterVal = header.map(function (v) {
        return v.key;
      });
      var data = _this7.filterIps.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      export_json_to_excel(tHeader, data, _this7.language.excelName);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  clearNotify: function clearNotify(key) {
    this.notifyData[key] = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: data,
  mixins: mixins,
  computed: computed,
  created: created,
  methods: methods,
  destroyed: destroyed
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_api__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var data = function data() {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confKey: 'security',
        confForm: {
            minutes: null,
            showMaxCount: null,
            manager: null,
            security: null,
            tittle: null,
            types: [],
            abandonedMax: 0,
            abandonedMin: 0,
            specialSymbol: [],
            specialSecurity: ''
        },
        symbolList: [],
        securityList: [],
        disabledKeys: [],
        updateID: null,
        specialSecurityCanSelect: [],

        pageNum: 1,
        pageSize: 5,
        total: 0
    };
};

var mixins = [__webpack_require__(2).base({ language: 'autoPositionReport' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        return this.language.tableHead;
    },
    rules: function rules() {
        var _this = this;

        var language = this.language;
        var rules = {
            minutes: [{ required: true, message: language.miutesRulesRequired, trigger: 'blur' }, { type: 'number', message: language.miutesRulesNumber, trigger: 'blur' }],
            manager: [{ required: true, message: language.managerRulesRequired, trigger: 'blur' }, { type: 'number', message: language.managerRulesNumber, trigger: 'blur' }],
            security: [{ required: true, message: language.securityRulesRequired, trigger: 'blur' }],
            showMaxCount: [{ required: true, message: language.maxCountRulesRequired, trigger: 'blur' }, { type: 'number', message: language.maxCountRulesNumber, trigger: 'blur' }],
            types: [{ required: true, message: language.typeRulesRequired, trigger: 'blur' }],
            specialSymbol: [{
                required: true,
                validator: function validator(rule, value, callback) {
                    if (value.length || _this.updateID) callback();else callback(language.specialSymbolRulesRequired);
                },
                trigger: 'change'
            }],
            specialSecurity: [{ required: true, message: language.specialSecurityRulesRequired, trigger: 'blur' }]
        };
        return rules;
    }
};

var created = function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["T" /* URL_SYMBOL_LIST */]), this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["Q" /* URL_SECURITY */])]).then(function (res) {
        var _res = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(res, 2),
            symbolRes = _res[0],
            securityRes = _res[1];

        _this2.symbolList = symbolRes.data.data;
        _this2.securityList = securityRes.data.data;
    });
    this.getPositionConfig();
};

var methods = {
    addPositionConfig: function addPositionConfig() {
        var _this3 = this;

        this.$refs['confForm'].validate(function (valid) {
            if (valid) {
                var modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name;
                var confKey = _this3.confKey;
                var addObj = {
                    modifyBy: modifyBy,
                    confKey: confKey
                };
                var confValue = '',
                    formObj = _this3.confForm;
                if (confKey === 'minutes') confValue = formObj.minutes;
                if (confKey === 'manager') confValue = '{"' + formObj.manager + '":"' + (formObj.tittle || '') + '"}';
                if (confKey === 'security') {
                    var typesStr = formObj.types.reduce(function (p, c) {
                        if (p === "") return '"' + c + '"';
                        return p + ',"' + c + '"';
                    }, "");
                    confValue = '{"' + formObj.security + '":{"types":[' + typesStr + '], "abandonedMax": ' + formObj.abandonedMax + ',"abandonedMin": ' + formObj.abandonedMin + '}}';
                }
                if (confKey === 'showMaxCount') confValue = formObj.showMaxCount;
                if (confKey === 'specialSecurity') {
                    var specialSymbolStr = formObj.specialSymbol.reduce(function (p, c) {
                        if (p === "") return '"' + c + '"';
                        return p + ',"' + c + '"';
                    }, "");
                    confValue = '{"' + formObj.specialSecurity + '":[' + specialSymbolStr + ']}';
                }
                addObj.confValue = confValue;
                var addConfig = _this3.updateID === null;
                var successKey = addConfig ? 'addSuccess' : 'updateSuccess';
                var failedKey = addConfig ? 'addFailed' : 'updateFailed';
                !addConfig && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(addObj, { id: _this3.updateID });

                _this3.$http.post(__WEBPACK_IMPORTED_MODULE_4_api_api__["d" /* URL_ADDORUPDATE_POSITION_CONFIG */], addObj).then(function (res) {
                    var code = res.data.data;
                    if (code === 9000) _this3.$message({ message: _this3.language[successKey], type: 'success' });else _this3.$message({ message: _this3.language[failedKey], type: 'error' });
                    _this3.getPositionConfig();
                    _this3.resetFilledConfig();
                });
            }
        });
    },
    getPositionConfig: function getPositionConfig() {
        var _this4 = this;

        this.configLoading = true;
        this.specialSecurityCanSelect = [];
        this.$http.get(__WEBPACK_IMPORTED_MODULE_4_api_api__["w" /* URL_GET_POSITION_CONFIG */]).then(function (res) {
            var result = res.data.data;
            _this4.confList = result.data;
            _this4.confList.forEach(function (val) {
                var confKey = val.conf_key;
                val.conf_desc = _this4.language.confKeyOpt[confKey];
                if (confKey === 'security') val.types.forEach(function (type) {
                    return _this4.specialSecurityCanSelect.push({ TYPE: type });
                });
                val.value = val[confKey];
            });
            _this4.total = _this4.confList.length;
            _this4.disabledKeys = result.disabledKeys;
            _this4.slicData();
            _this4.configLoading = false;
        });
    },
    updateAccount: function updateAccount(row) {
        var _this5 = this;

        var confKey = row.conf_key;
        this.confKey = confKey;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.confForm).forEach(function (k) {
            return _this5.confForm[k] = row[k];
        });
        this.updateID = row.id;
        this.configWindow = true;
    },
    deletePositionConfig: function deletePositionConfig(id) {
        var _this6 = this;

        var lg = this.language;
        this.$confirm('' + lg.deleteMsgTxt, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(function () {
            _this6.$http.delete(__WEBPACK_IMPORTED_MODULE_4_api_api__["n" /* URL_DELETE_POSITION_CONFIG */], { params: { id: id } }).then(function (res) {
                var code = res.data.data;
                if (code == 9000) {
                    _this6.$message({ message: lg.delSuccess, type: 'success' });
                    // 第N页删除后页码需要减一
                    var countAfterDelete = _this6.total - 1;
                    if (countAfterDelete % _this6.pageSize === 0) _this6.pageNum -= countAfterDelete / _this6.pageSize;
                    _this6.getPositionConfig();
                } else {
                    _this6.$message({ message: lg.delFailed, type: 'info' });
                }
            });
        });
    },
    resetFilledConfig: function resetFilledConfig() {
        var _this7 = this;

        this.configWindow = false;
        setTimeout(function () {
            _this7.confKey = 'security';
            _this7.handleConfKeyChange();
        }, 100);
    },
    handlePageChange: function handlePageChange(val) {
        this.pageNum = val;
        this.slicData();
    },
    handleSizeChange: function handleSizeChange(val) {
        this.pageNum = 1;
        this.pageSize = val;
        this.confListPaging = this.confList.slice(0, this.pageSize);
    },
    handleConfKeyChange: function handleConfKeyChange(val) {
        this.resetFields();
        this.updateID = null;
        this.$refs['confForm'].clearValidate();
    },
    resetFields: function resetFields() {
        var _this8 = this;

        ['minutes', 'showMaxCount', 'manager', 'security', 'tittle'].forEach(function (k) {
            return _this8.confForm[k] = null;
        });
        ['types', 'specialSymbol'].forEach(function (k) {
            return _this8.confForm[k] = [];
        });
        ['abandonedMax', 'abandonedMin'].forEach(function (k) {
            return _this8.confForm[k] = 0;
        });
        this.confForm.specialSecurity = '';
    },
    slicData: function slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    }
};

var watch = {
    language: function language() {
        var _this9 = this;

        this.confListPaging.forEach(function (val) {
            return val.conf_desc = _this9.language.confKeyOpt[val.conf_key];
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    watch: watch
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var data = function data() {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confForm: {
            group: null,
            equityValve: null,
            leverageLte: null,
            leverageGt: null,
            enable: '1'
        },
        groupList: [],
        updateGroup: null,
        disabledGroups: [],

        pageNum: 1,
        pageSize: 5,
        total: 0,
        rerunKey: 'Rerun_Program'
    };
};

var mixins = [__webpack_require__(2).base({ language: 'autoUpdateLeverage' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        return this.language.tableHead;
    },
    rules: function rules() {
        var language = this.language;
        var rules = {
            group: [{
                required: true,
                validator: function validator(rule, value, callback) {
                    if (!value) callback(language.groupRulesRequired);else callback();
                },
                trigger: 'change'
            }],
            equityValve: [this.requiredRule(language.equityRulesRequired), this.numberRule(language.equityRulesNumber)],
            leverageLte: [this.requiredRule(language.leverageLteRulesRequired), this.numberRule(language.leverageLteRulesNumber)],
            leverageGt: [this.requiredRule(language.leverageGtRulesRequired), this.numberRule(language.leverageGtRulesNumber)]
        };
        return rules;
    }
};

var created = function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["x" /* URL_GROUP_LIST */]).then(function (res) {
        return _this.groupList = res.data.data;
    });
    this.getLeverageConfig();
};

var methods = {
    addLeverageConfig: function addLeverageConfig() {
        var _this2 = this;

        this.$refs['confForm'].validate(function (valid) {
            if (valid) {
                var modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name;
                var addObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    modifyBy: modifyBy
                }, _this2.confForm);
                var isAdd = _this2.updateGroup != addObj.group;
                var successKey = isAdd ? 'addSuccess' : 'updateSuccess';
                var failedKey = isAdd ? 'addFailed' : 'updateFailed';

                _this2.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["c" /* URL_ADDORUPDATE_LEVERAGE_CONFIG */], addObj).then(function (res) {
                    var code = res.data.data;
                    if (code === 9000) _this2.$message({ message: _this2.language[successKey], type: 'success' });else _this2.$message({ message: _this2.language[failedKey], type: 'error' });
                    _this2.getLeverageConfig();
                    _this2.resetFilledConfig();
                });
            }
        });
    },
    getLeverageConfig: function getLeverageConfig() {
        var _this3 = this;

        this.configLoading = true;
        this.disabledGroups = [];
        this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["u" /* URL_GET_LEVERAGE_CONFIG */]).then(function (res) {
            var result = res.data.data;
            _this3.confList = result;
            _this3.confList.forEach(function (conf) {
                _this3.disabledGroups.push(conf.group);
                var enableKey = conf.enable == '1' ? 'yesTxt' : 'noTxt';
                conf.enableDesc = _this3.language[enableKey];
            });
            _this3.total = result.length;
            _this3.slicData();
            _this3.configLoading = false;
        });
    },
    updateAccount: function updateAccount(row) {
        var group = row.group;
        var updateObj = { group: group, equityValve: row.equity_valve, leverageLte: row.leverage_lte, leverageGt: row.leverage_gt, enable: row.enable };
        this.configWindow = true;
        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.confForm, updateObj);
            this.updateGroup = group;
        });
    },
    deletePositionConfig: function deletePositionConfig(group) {
        var _this4 = this;

        var lg = this.language;
        this.$confirm('' + lg.deleteMsgTxt, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(function () {
            _this4.$http.delete(__WEBPACK_IMPORTED_MODULE_2_api_api__["m" /* URL_DELETE_LEVERAGE_CONFIG */], { params: { group: group } }).then(function (res) {
                var code = res.data.data;
                if (code == 9000) {
                    _this4.$message({ message: lg.delSuccess, type: 'success' });
                    // 第N页删除后页码需要减一
                    var countAfterDelete = _this4.total - 1;
                    if (countAfterDelete % _this4.pageSize === 0) _this4.pageNum -= countAfterDelete / _this4.pageSize;
                    _this4.getLeverageConfig();
                } else {
                    _this4.$message({ message: lg.delFailed, type: 'info' });
                }
            });
        });
    },
    openConfigWindow: function openConfigWindow() {
        this.configWindow = true;
        this.$refs['confForm'].resetFields();
    },
    resetFilledConfig: function resetFilledConfig() {
        this.configWindow = false;
        this.updateGroup = null;
    },
    handlePageChange: function handlePageChange(val) {
        this.pageNum = val;
        this.slicData();
    },
    handleSizeChange: function handleSizeChange(val) {
        this.pageNum = 1;
        this.pageSize = val;
        this.confListPaging = this.confList.slice(0, this.pageSize);
    },
    slicData: function slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    },
    requiredRule: function requiredRule(message) {
        return { required: true, message: message, trigger: 'blur' };
    },
    numberRule: function numberRule(message) {
        var numberRule = {
            type: 'number',
            validator: function validator(rule, value, callback) {
                if (value > 0) callback();else callback(message);
            },
            trigger: 'blur'
        };
        return numberRule;
    }
};

var watch = {
    language: function language() {
        var _this5 = this;

        this.confListPaging.forEach(function (conf) {
            var enableKey = conf.enable == '1' ? 'yesTxt' : 'noTxt';
            conf.enableDesc = _this5.language[enableKey];
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    watch: watch
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_api__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var data = function data() {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confForm: {
            symbol: null,
            group: null,
            zipcode: null,
            buy: null,
            sell: null,
            excuteTime: null,
            comment: null
        },
        symbolList: [],
        updateSymbol: null,
        disabledSymbols: [],

        pageNum: 1,
        pageSize: 5,
        total: 0
    };
};

var mixins = [__webpack_require__(2).base({ language: 'chargeDividends' }), __webpack_require__(2).base({ reuse: 'reuse' })];

var computed = {
    tableHead: function tableHead() {
        return this.language.tableHead;
    },
    rules: function rules() {
        var language = this.language;
        var buyOrSellRegexp = new RegExp(/^-?[0-9]+([.]{1}[0-9]+){0,1} ([a-zA-Z]{3}|pt)$/);
        var timeRegexp = new RegExp(/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/);
        var rules = {
            symbol: [{
                required: true,
                validator: function validator(rule, value, callback) {
                    if (!value) callback(language.symbolRulesRequired);else callback();
                },
                trigger: 'change'
            }],
            buy: [this.regexpRule(buyOrSellRegexp, language.buyRulesRequired, language.buyOrSellRulesInvalid)],
            sell: [this.regexpRule(buyOrSellRegexp, language.sellRulesRequired, language.buyOrSellRulesInvalid)],
            group: [this.requiredRule(language.groupRulesRequired)],
            zipcode: [this.requiredRule(language.zipcodeRulesRequired)],
            comment: [this.requiredRule(language.commentRulesRequired)],
            excuteTime: [this.regexpRule(timeRegexp, language.excuteTimeRulesRequired, language.timeRulesInvalid)]
        };
        return rules;
    }
};

var created = function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["T" /* URL_SYMBOL_LIST */]).then(function (res) {
        return _this.symbolList = res.data.data;
    });
    this.getChargeDividendsConfig();
};

var methods = {
    addChargeDividendsConfig: function addChargeDividendsConfig() {
        var _this2 = this;

        this.$refs['confForm'].validate(function (valid) {
            if (valid) {
                var modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name;
                var addObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    modifyBy: modifyBy
                }, _this2.confForm);
                var isAdd = _this2.updateSymbol != addObj.symbol;
                var successKey = isAdd ? 'addSuccess' : 'updateSuccess';
                var failedKey = isAdd ? 'addFailed' : 'updateFailed';

                _this2.$http.post(__WEBPACK_IMPORTED_MODULE_2_api_api__["b" /* URL_ADDORUPDATE_DIVIDENDS_CONFIG */], addObj).then(function (res) {
                    var code = res.data.data;
                    if (code === 9000) _this2.$message({ message: _this2.language[successKey], type: 'success' });else _this2.$message({ message: _this2.language[failedKey], type: 'error' });
                    _this2.getChargeDividendsConfig();
                    _this2.resetFilledConfig();
                });
            }
        });
    },
    getChargeDividendsConfig: function getChargeDividendsConfig() {
        var _this3 = this;

        this.configLoading = true;
        this.disabledSymbols = [];
        this.$http.get(__WEBPACK_IMPORTED_MODULE_2_api_api__["t" /* URL_GET_DIVIDENDS_CONFIG */]).then(function (res) {
            var result = res.data.data;
            _this3.confList = result;
            _this3.confList.forEach(function (conf) {
                _this3.disabledSymbols.push(conf.symbol);
                conf.statusDesc = _this3.language.statusMapping[conf.status];
            });
            _this3.total = result.length;
            _this3.slicData();
            _this3.configLoading = false;
        });
    },
    updateConfig: function updateConfig(row) {
        var symbol = row.symbol;
        var updateObj = { symbol: symbol, buy: row.buy, sell: row.sell, group: row.group, zipcode: row.zipcode, comment: row.comment, excuteTime: row.excute_time };
        this.configWindow = true;
        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.confForm, updateObj);
            this.updateSymbol = symbol;
        });
    },
    deleteChargeDividendsConfig: function deleteChargeDividendsConfig(symbol) {
        var _this4 = this;

        var lg = this.language;
        this.$confirm('' + lg.deleteMsgTxt, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(function () {
            _this4.$http.delete(__WEBPACK_IMPORTED_MODULE_2_api_api__["l" /* URL_DELETE_DIVIDENDS_CONFIG */], { params: { symbol: symbol } }).then(function (res) {
                var code = res.data.data;
                if (code == 9000) {
                    _this4.$message({ message: lg.delSuccess, type: 'success' });
                    // 第N页删除后页码需要减一
                    var countAfterDelete = _this4.total - 1;
                    if (countAfterDelete % _this4.pageSize === 0) _this4.pageNum -= countAfterDelete / _this4.pageSize;
                    _this4.getChargeDividendsConfig();
                } else {
                    _this4.$message({ message: lg.delFailed, type: 'info' });
                }
            });
        });
    },
    openConfigWindow: function openConfigWindow() {
        this.configWindow = true;
        this.$refs['confForm'].resetFields();
    },
    resetFilledConfig: function resetFilledConfig() {
        this.configWindow = false;
        this.updateSymbol = null;
    },
    handlePageChange: function handlePageChange(val) {
        this.pageNum = val;
        this.slicData();
    },
    handleSizeChange: function handleSizeChange(val) {
        this.pageNum = 1;
        this.pageSize = val;
        this.confListPaging = this.confList.slice(0, this.pageSize);
    },
    slicData: function slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    },
    requiredRule: function requiredRule(message) {
        return { required: true, message: message, trigger: 'blur' };
    },
    numberRule: function numberRule(message) {
        var numberRule = {
            type: 'number',
            validator: function validator(rule, value, callback) {
                if (value > 0) callback();else callback(message);
            },
            trigger: 'blur'
        };
        return numberRule;
    },
    regexpRule: function regexpRule(regExp, requiredMsg, invalidMsg) {
        var regexpRule = {
            required: true,
            validator: function validator(rule, value, callback) {
                if (value) {
                    regExp.test(value) ? callback() : callback(invalidMsg);
                    return;
                } else callback(requiredMsg);
            },
            trigger: 'blur'
        };
        return regexpRule;
    }
};

var watch = {
    language: function language() {
        var _this5 = this;

        this.confListPaging.forEach(function (conf) {
            conf.statusDesc = _this5.language.statusMapping[conf.status];
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: data,
    mixins: mixins,
    computed: computed,
    created: created,
    methods: methods,
    watch: watch
});

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175);
module.exports = __webpack_require__(212);


/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07749a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07749a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5182e737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5182e737"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5182e737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"loginBox"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(659)}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.loginLan.priceEngine))]),_vm._v(" "),_c('label',[_c('img',{attrs:{"src":__webpack_require__(660)}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formValue.name),expression:"formValue.name"}],attrs:{"type":"text","placeholder":_vm.loginLan.loginTxt},domProps:{"value":(_vm.formValue.name)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loginFn.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formValue, "name", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('img',{attrs:{"src":__webpack_require__(661)}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formValue.password),expression:"formValue.password"}],attrs:{"type":"password","placeholder":_vm.loginLan.passwordTxt},domProps:{"value":(_vm.formValue.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loginFn.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formValue, "password", $event.target.value)}}})]),_vm._v(" "),_c('button',{on:{"click":_vm.loginFn}},[_vm._v(_vm._s(_vm.loginLan.login))]),_vm._v(" "),_c('div',{staticClass:"language"},[_c('span',[_vm._v(_vm._s(_vm.loginLan.language))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.lang),expression:"lang"}],ref:"language",attrs:{"name":"language","id":"language"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.lang=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.changeLanguage(_vm.lang)}]}},[_c('option',{attrs:{"value":"cn"}},[_vm._v(" 简体中文 ")]),_vm._v(" "),_c('option',{attrs:{"value":"hk"}},[_vm._v(" 繁體中文 ")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v(" English ")])])])]),_vm._v(" "),_c('Modal',{staticClass:"modal-content-j",attrs:{"size":"sm","footer":false,"header":false,"backdrop":true},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('div',{staticStyle:{"font-size":"16px","text-align":"center"}},[_c('i',{staticClass:"glyphicon glyphicon-warning-sign color-red"}),_vm._v(_vm._s(_vm.errTips))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWlJREFUeNpi/P//PwOtARMDHcDwsYQFXWD69Om41LoAcRgQS0P5L4F4DRBvQ1aUmZlJ2BIcoASIHYH4CdRgUGoxAeJsIDYH4nqSfIIFpEEtaAHi40jiC4DYCIibgbgciDvJjRN+IPYH4pVoFsDAOSCeBcR2QCxJriW2UHoxHjUbobQPuZbAXEdMjiXbJy9JSKlvyLXkMJSOwqPGE0pvJ9eS99B8EA3Epljk9YA4B5oA7lOShKdC1TUA8UkgvgmNI1UgtgLis0BcR2k+0UWKVHMoRgaCUB9dIteSRCAOQcp8IJ+8hvL5oLk+HojbgXgLqFQi1ZI4qAUngLgDiH+jyX8H4q1QnAvNJ4xAPI3YiNcA4nBoLm/GYgE6mAz1iTewgDUn1pIqKN1CQj4BBdUPIK4gxhJZIBYG4iVkVB0zgZgN6Bt9QpZYQ+kDZFgCy7xOhCwRhEbqOzIsAen7AMTMyIKMo60VUgBAgAEAMmFKE+uGQbIAAAAASUVORK5CYII="

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAU5JREFUeNpi/P//PwOtARMDHQBdLGEhRtH06dN1gVQYEBshCR8H4i2ZmZkXCOlnJBQnQAvcgFQ+lPsSiN8BsTgQC0HF1gItmke2JUALZIDUTCD+A8RVQMOuIslZAKlaKHcKUG47uXGSCaVzkS0AS2RmngBSBVBuDtBSIZItAWpiA1IGQHwDaOAjrC7IzLwNpHZAua7kRLwklD5PwLeLgBgUrA/IsYQHSn/AG56ZmR+BVDm5+eQLlP5OaT7BmrqA8eEIpEBJVw+IPwHxQ3xmAPF/aNK+DvTZZmKDC5QvWKG+4QJiXSIdbQ/ERFsCEgeFdTIQ/4C6Fhf4D1XfB8RKpEQ8yNCPQK9/RzIIH/gNDOJnuCxhorRcQwIcw7+ox2fJPxLN+kuOJawkWsJKTuSKA1NMKwlJ2IhUS/YAsQ20FCYWgOqcS2TVjKOtFWQAEGAAVjBf9ENnmGgAAAAASUVORK5CYII="

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainView_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d15dca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainView_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d15dca0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d15dca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aHeader_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74e45ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aHeader_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d74e45ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74e45ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar navbar-inverse"},[_c('div',{staticClass:"navbar-header"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(672),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"navbar-right-box"},[_c('div',{staticClass:"user-info pull-right"},[_vm._v("\n      "+_vm._s(_vm.headerLan.hello)+" ! "+_vm._s(_vm.userName)+"  "+_vm._s(_vm.headerLan.userName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"language pull-right"},[_c('dropdown',{attrs:{"menu-right":""}},[_c('a',{staticClass:"dropdown-toggle language-btn",attrs:{"role":"button","data-role":"trigger"}},[_c('img',{staticClass:"language-img",attrs:{"src":_vm.languageImage}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.headerLan.language))]),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('li',{on:{"click":function($event){return _vm.changeLanguage('cn')}}},[_c('a',{staticClass:"language-t",attrs:{"role":"button"}},[_c('img',{staticClass:"language-img",attrs:{"src":"/static/images/flags/cn.png"}}),_vm._v("简体中文")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.changeLanguage('hk')}}},[_c('a',{staticClass:"language-t",attrs:{"role":"button"}},[_c('img',{staticClass:"language-img",attrs:{"src":"/static/images/flags/hk.png"}}),_vm._v("繁體中文")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.changeLanguage('en')}}},[_c('a',{staticClass:"language-t",attrs:{"role":"button"}},[_c('img',{staticClass:"language-img",attrs:{"src":"/static/images/flags/en.png"}}),_vm._v("English")])])])],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAVCAMAAADIH7jSAAABQVBMVEUAAADQ1Nr29/fx8vTO0tj6+/v5+vr+///8/f3wrJa5vsn39/fw8vP+/v76+/z5+/v19fXw8fHt7+/+/v76+vr8/P38+/z5+vr4+PnxmHv29/f09PXz9PTv8PHv8vPv8PDu7/DY2t/8/fz8/f77+/v5+vr29/f4+fn19fX29/f19vby9fXz9PTw8fH+/v79/v7y8/X+/v7t7/H7+/v6+/vz9Pb09fb6+/r29/f09PXz9PXs7e/z9PTuoIj29/b09PXx8vLv8PDn6evu7+/+/v7yWSjw8vTq7O/s7vD0ooj5+vryoojzvav0uafxj2/7/PvvknTxj3Hl5+rwk3bvkXTwsZ3vn4be4OSzusXvw7Xy///z+fmqsr7t9fXo6uv////zQwzvNQD96+X9zL36sZn3k3T0QwvyPQTyPQP0NwDwIwDqSdR2AAAAX3RSTlMAhEHnAumb/edjPpQv8cCvaj0k7eTc0LyokIZfWjMdDwUB7NTKtaejgHl1T0kn+vXn39jGw8Culo1uYmFUS0I/KxoZCfjl4c7NxL+1rqOhm4qHgXt0Z1pKRz8+OTIgFS9nhgAAAAHASURBVDjLjZTnVsJAEIXHAokmQaqgVEFEwN577713vfb2/g9gNmGXrAcO+f7sncnJ3TM7s0ucbiPNpQ8mStYzBEa/mdFggBM1Yx0lEuSHucqomOU6pqhqeBjIhlVVVVh6G4on7LFQ+sz4EQhShQRyXMaBTpIYx7LQY7gmiTiiFZXewArPTgAYICdNWBJ6BK0kk4ffFgUUeS6A8CQ6/pk0C92CHpJJASm2lh0FxBCgUQTrm7TSP/zWnushJKu+EZbudmUiehgnmnb8088qTGNovXE5gkEopCMi4h4DaWsa4nVMxuCd9jKOO+ZFsoTChKODCWhs0dFZx2QHgj0SRIG+atQLvVJmoLbJFtof2i1u1sixN85EcM+be4dYbZMR+UzE3piy1eXR+e77/kWXyenJK1ZddEd0Q8tXBnTz5/vl5evzmfH7gaJrEx2G2SE1w/Tt4sHb4WKbxVUbsq5NelEmmsGMHeWQIo4XCy5NSnZnRu1elJ2nmYSvkYkYtSe2LiFidzsgPQC6KxMfErbQ2OCvyO/IAjQ3Jn5x5TPsCnoxJ30OYa2xSRDVWRgwC5oyMtL3In8Q5k3BmcyRRNK5cyH0B7FGXs+PDSiiAAAAAElFTkSuQmCC"

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crumbs_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0426254d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crumbs_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0426254d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0426254d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumbs-box"},[_c('span',{staticStyle:{"width":"82%","display":"inline-block"}},[_c('i',{class:_vm.activeItem.cicon,attrs:{"aria-hidden":"true"}}),_vm._v("\n    "+_vm._s(_vm.activeItem.ct)+"\n  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.login),expression:"login"}],staticStyle:{"width":"15%","display":"inline-block"}},[_vm._v(_vm._s(("" + (_vm.desc.current) + _vm.login)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.login),expression:"login"}],on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.desc.exit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aheader'),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"side-bar pull-left"},[_c('ul',[_vm._l((_vm.fnList),function(item){return [(_vm.allList || _vm.fnListKeys.includes(item.id))?_c('li',{key:item.id,class:{ 'cur-bg': _vm.currentSideBar === item.id },on:{"click":function($event){return _vm.saveSideBar(item.id, item.link)}}},[_c('i',{class:item.icon,attrs:{"aria-hidden":"true"}}),_vm._v("\n            "+_vm._s(item.text)+"\n          ")]):_vm._e()]}),_vm._v(" "),_c('li',{on:{"click":_vm.logoutFn}},[_c('i',{staticClass:"fa fa-power-off",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm.mainViewLan.sidebarList.logout)+"\n        ")])],2)]),_vm._v(" "),_c('div',{staticClass:"content-view pull-left"},[_c('crumbs',{attrs:{"activeItem":_vm.activeItem,"desc":_vm.desc,"login":_vm.managerAccount},on:{"exit":_vm.exit}}),_vm._v(" "),_c('router-view',{staticClass:"content-box",attrs:{"viewReadOnly":_vm.viewReadOnly}})],1),_vm._v(" "),_c('div',{staticClass:"clear"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userMaintenance_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a179404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userMaintenance_vue__ = __webpack_require__(691);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a179404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table"},[_c('div',{staticClass:"d-header"},[_c('div',{staticClass:"pull-left seek"},[_c('dropdown',{ref:"dropdown",staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-default dropdown-toggle dropBtn",attrs:{"data-role":"trigger","type":"button"}},[_c('span',[_vm._v(_vm._s(_vm.tableModelLan[_vm.seekKey.active]))]),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('template',{slot:"dropdown"},_vm._l((_vm.seekKey.list),function(item,index){return _c('li',{on:{"click":function($event){return _vm.$emit('handleChangeSeekKey',item)}}},[_c('a',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.tableModelLan[item]))])])}),0)],2),_vm._v(" "),_c('div',{staticClass:"pull-left form-group",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.seekVal),expression:"seekVal"}],staticClass:"form-control seek-input",attrs:{"type":"text","placeholder":_vm.tableModelLan.search},domProps:{"value":(_vm.seekVal)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSeek.apply(null, arguments)},"blur":_vm.handleSeek,"input":function($event){if($event.target.composing){ return; }_vm.seekVal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"pull-left btn btn-primary seekBtn",on:{"click":_vm.handleSeek}},[_vm._v(_vm._s(_vm.tableModelLan.search))]),_vm._v(" "),_c('div',{staticClass:"clear"})],1),_vm._v(" "),_c('div',{staticClass:"pull-left btn-group"},[_c('btn-group',[_c('btn',{on:{"click":function($event){return _vm.$emit('refresh')}}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.tableModelLan.btnGroup[_vm.btnGroup.refresh]))]),_vm._v(" "),_c('btn',{attrs:{"disabled":_vm.viewReadOnly},on:{"click":function($event){return _vm.$emit('toAdd')}}},[_c('i',{staticClass:"fa fa-user-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.tableModelLan.btnGroup[_vm.btnGroup.add]))]),_vm._v(" "),(!_vm.confirmDelete)?_c('btn',{staticClass:"delete-btn",attrs:{"disabled":_vm.viewReadOnly},on:{"click":function($event){return _vm.$emit('toDelete')}}},[_c('i',{staticClass:"fa fa-user-times",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.tableModelLan.btnGroup[_vm.btnGroup.delete]))]):_c('btn',{staticClass:"delete-btn",attrs:{"disabled":_vm.viewReadOnly},on:{"click":function($event){return _vm.$emit('toConfirmDelete')}}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.tableModelLan.btnGroup[_vm.btnGroup.confirmDelete]))])],1)],1),_vm._v(" "),_c('div',{staticClass:"pull-right tool-selPage"},[_c('span',[_vm._v(_vm._s(_vm.tableModelLan.showclausesnum))]),_vm._v(" "),_c('dropdown',{attrs:{"menu-right":""}},[_c('btn',{staticClass:"dropdown-toggle"},[_vm._v("\n            "+_vm._s(_vm.selPage.list[_vm.selPage.active])+"\n            "),_c('span',{staticClass:"caret",staticStyle:{"margin-left":"5px"}})]),_vm._v(" "),_vm._l((_vm.selPage.list),function(item,index){return _c('template',{slot:"dropdown"},[_c('li',{on:{"click":function($event){return _vm.emitSelPage(index,item)}}},[_c('a',{attrs:{"role":"button"}},[_vm._v(_vm._s(item))])])])})],2)],1),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"d-section"},[_c('table',{staticClass:"table table-bordered table-hover"},[_c('thead',[_c('tr',_vm._l((_vm.theadText),function(thead,index){return _c('th',[_vm._v(_vm._s(thead))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tbodyData),function(tbody,tbodyIndex){return _c('tr',[_vm._l((Object.keys(tbody)),function(key,keyIndex){return (keyIndex < Object.keys(tbody).length)?_c('td',{style:(key === 'functions' ? 'width: 40%' : ''),domProps:{"innerHTML":_vm._s(
            (key ==='enable' || key === 'changed') ? _vm.tableModelLan.enable[tbody[key]] : 
            key ==='functions'? _vm.formatData(tbody[key].split('; ')) :
            tbody[key])}}):_vm._e()}),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.confirmDelete),expression:"!confirmDelete"}],staticClass:"last-td"},[_c('i',{staticClass:"fa fa-pencil-square-o",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('toEdit',tbody[_vm.viewKey])}}}),_vm._v(" "),(!_vm.viewReadOnly)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewKey === 'providerId'),expression:"viewKey === 'providerId'"}],staticClass:"fa fa-sort",staticStyle:{"margin-left":"10px"},attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('handleSort',tbody)}}}):_vm._e()]),_vm._v(" "),(!_vm.viewReadOnly)?_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmDelete&&!_vm.deleteDataKeys.includes(tbody[_vm.viewKey])),expression:"confirmDelete&&!deleteDataKeys.includes(tbody[viewKey])"}],staticClass:"last-td",on:{"click":function($event){return _vm.$emit('hanldeDelete',tbodyIndex)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!_vm.viewReadOnly)?_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmDelete&&_vm.deleteDataKeys.includes(tbody[_vm.viewKey])),expression:"confirmDelete&&deleteDataKeys.includes(tbody[viewKey])"}],staticClass:"last-td",on:{"click":function($event){return _vm.$emit('hanldeChecked',tbodyIndex)}}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})]):_vm._e()],2)}),0)]),_vm._v(" "),(_vm.tbodyData.length === 0)?_c('div',{staticClass:"noData"},[_c('i',{staticClass:"fa fa-exclamation-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.tableModelLan.noData))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-footer"},[_c('div',{staticClass:"pull-left number-entries"},[_vm._v("\n      "+_vm._s(_vm.tableModelLan.clausesamount)+_vm._s(_vm.page.pageLeng)+" \n      "+_vm._s(_vm.tableModelLan.present)+_vm._s(_vm.page.active*_vm.selPage.limit-_vm.selPage.limit+1)+"-"+_vm._s(Math.min(_vm.page.active*_vm.selPage.limit,_vm.page.pageLeng))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('pagination',{staticStyle:{"height":"32px"},attrs:{"total-page":Math.ceil(_vm.page.pageLeng/_vm.selPage.limit),"boundary-links":""},on:{"change":_vm.callpageFn},model:{value:(_vm.page.active),callback:function ($$v) {_vm.$set(_vm.page, "active", $$v)},expression:"page.active"}})],1),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('d-table',{attrs:{"viewKey":'login',"seekKey":_vm.seekKey,"theadText":_vm.theadText,"tbodyData":_vm.tbodyData,"confirmDelete":_vm.confirmDelete,"page":_vm.page,"selPage":_vm.selPage,"deleteDataKeys":_vm.deleteDataKeys,"btnGroup":_vm.btnGroup},on:{"handleChangeSeekKey":_vm.handleChangeSeekKey,"handleChangeSeekVal":_vm.handleChangeSeekVal,"handleSeek":_vm.handleSeek,"toAdd":_vm.toAdd,"toEdit":_vm.toEdit,"toDelete":_vm.toDelete,"hanldeDelete":_vm.hanldeDelete,"hanldeChecked":_vm.hanldeChecked,"toConfirmDelete":_vm.toConfirmDelete,"selPage":_vm.selPageFn,"pagingFn":_vm.pagingFn,"refresh":_vm.refresh}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleMaintenance_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452ca661_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleMaintenance_vue__ = __webpack_require__(693);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452ca661_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('d-table',{attrs:{"viewKey":'roleId',"seekKey":_vm.seekKey,"theadText":_vm.theadText,"tbodyData":_vm.tbodyData,"confirmDelete":_vm.confirmDelete,"page":_vm.page,"selPage":_vm.selPage,"deleteDataKeys":_vm.deleteDataKeys,"btnGroup":_vm.btnGroup},on:{"handleChangeSeekKey":_vm.handleChangeSeekKey,"handleChangeSeekVal":_vm.handleChangeSeekVal,"handleSeek":_vm.handleSeek,"toAdd":_vm.toAdd,"toEdit":_vm.toEdit,"toDelete":_vm.toDelete,"hanldeDelete":_vm.hanldeDelete,"hanldeChecked":_vm.hanldeChecked,"toConfirmDelete":_vm.toConfirmDelete,"selPage":_vm.selPageFn,"pagingFn":_vm.pagingFn,"refresh":_vm.refresh}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLog_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba8b6c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditLog_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba8b6c00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba8b6c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */,
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 240,
	"./af.js": 240,
	"./ar": 241,
	"./ar-dz": 242,
	"./ar-dz.js": 242,
	"./ar-kw": 243,
	"./ar-kw.js": 243,
	"./ar-ly": 244,
	"./ar-ly.js": 244,
	"./ar-ma": 245,
	"./ar-ma.js": 245,
	"./ar-sa": 246,
	"./ar-sa.js": 246,
	"./ar-tn": 247,
	"./ar-tn.js": 247,
	"./ar.js": 241,
	"./az": 248,
	"./az.js": 248,
	"./be": 249,
	"./be.js": 249,
	"./bg": 250,
	"./bg.js": 250,
	"./bm": 251,
	"./bm.js": 251,
	"./bn": 252,
	"./bn-bd": 253,
	"./bn-bd.js": 253,
	"./bn.js": 252,
	"./bo": 254,
	"./bo.js": 254,
	"./br": 255,
	"./br.js": 255,
	"./bs": 256,
	"./bs.js": 256,
	"./ca": 257,
	"./ca.js": 257,
	"./cs": 258,
	"./cs.js": 258,
	"./cv": 259,
	"./cv.js": 259,
	"./cy": 260,
	"./cy.js": 260,
	"./da": 261,
	"./da.js": 261,
	"./de": 262,
	"./de-at": 263,
	"./de-at.js": 263,
	"./de-ch": 264,
	"./de-ch.js": 264,
	"./de.js": 262,
	"./dv": 265,
	"./dv.js": 265,
	"./el": 266,
	"./el.js": 266,
	"./en-au": 267,
	"./en-au.js": 267,
	"./en-ca": 268,
	"./en-ca.js": 268,
	"./en-gb": 269,
	"./en-gb.js": 269,
	"./en-ie": 270,
	"./en-ie.js": 270,
	"./en-il": 271,
	"./en-il.js": 271,
	"./en-in": 272,
	"./en-in.js": 272,
	"./en-nz": 273,
	"./en-nz.js": 273,
	"./en-sg": 274,
	"./en-sg.js": 274,
	"./eo": 275,
	"./eo.js": 275,
	"./es": 276,
	"./es-do": 277,
	"./es-do.js": 277,
	"./es-mx": 278,
	"./es-mx.js": 278,
	"./es-us": 279,
	"./es-us.js": 279,
	"./es.js": 276,
	"./et": 280,
	"./et.js": 280,
	"./eu": 281,
	"./eu.js": 281,
	"./fa": 282,
	"./fa.js": 282,
	"./fi": 283,
	"./fi.js": 283,
	"./fil": 284,
	"./fil.js": 284,
	"./fo": 285,
	"./fo.js": 285,
	"./fr": 286,
	"./fr-ca": 287,
	"./fr-ca.js": 287,
	"./fr-ch": 288,
	"./fr-ch.js": 288,
	"./fr.js": 286,
	"./fy": 289,
	"./fy.js": 289,
	"./ga": 290,
	"./ga.js": 290,
	"./gd": 291,
	"./gd.js": 291,
	"./gl": 292,
	"./gl.js": 292,
	"./gom-deva": 293,
	"./gom-deva.js": 293,
	"./gom-latn": 294,
	"./gom-latn.js": 294,
	"./gu": 295,
	"./gu.js": 295,
	"./he": 296,
	"./he.js": 296,
	"./hi": 297,
	"./hi.js": 297,
	"./hr": 298,
	"./hr.js": 298,
	"./hu": 299,
	"./hu.js": 299,
	"./hy-am": 300,
	"./hy-am.js": 300,
	"./id": 301,
	"./id.js": 301,
	"./is": 302,
	"./is.js": 302,
	"./it": 303,
	"./it-ch": 304,
	"./it-ch.js": 304,
	"./it.js": 303,
	"./ja": 305,
	"./ja.js": 305,
	"./jv": 306,
	"./jv.js": 306,
	"./ka": 307,
	"./ka.js": 307,
	"./kk": 308,
	"./kk.js": 308,
	"./km": 309,
	"./km.js": 309,
	"./kn": 310,
	"./kn.js": 310,
	"./ko": 311,
	"./ko.js": 311,
	"./ku": 312,
	"./ku.js": 312,
	"./ky": 313,
	"./ky.js": 313,
	"./lb": 314,
	"./lb.js": 314,
	"./lo": 315,
	"./lo.js": 315,
	"./lt": 316,
	"./lt.js": 316,
	"./lv": 317,
	"./lv.js": 317,
	"./me": 318,
	"./me.js": 318,
	"./mi": 319,
	"./mi.js": 319,
	"./mk": 320,
	"./mk.js": 320,
	"./ml": 321,
	"./ml.js": 321,
	"./mn": 322,
	"./mn.js": 322,
	"./mr": 323,
	"./mr.js": 323,
	"./ms": 324,
	"./ms-my": 325,
	"./ms-my.js": 325,
	"./ms.js": 324,
	"./mt": 326,
	"./mt.js": 326,
	"./my": 327,
	"./my.js": 327,
	"./nb": 328,
	"./nb.js": 328,
	"./ne": 329,
	"./ne.js": 329,
	"./nl": 330,
	"./nl-be": 331,
	"./nl-be.js": 331,
	"./nl.js": 330,
	"./nn": 332,
	"./nn.js": 332,
	"./oc-lnc": 333,
	"./oc-lnc.js": 333,
	"./pa-in": 334,
	"./pa-in.js": 334,
	"./pl": 335,
	"./pl.js": 335,
	"./pt": 336,
	"./pt-br": 337,
	"./pt-br.js": 337,
	"./pt.js": 336,
	"./ro": 338,
	"./ro.js": 338,
	"./ru": 339,
	"./ru.js": 339,
	"./sd": 340,
	"./sd.js": 340,
	"./se": 341,
	"./se.js": 341,
	"./si": 342,
	"./si.js": 342,
	"./sk": 343,
	"./sk.js": 343,
	"./sl": 344,
	"./sl.js": 344,
	"./sq": 345,
	"./sq.js": 345,
	"./sr": 346,
	"./sr-cyrl": 347,
	"./sr-cyrl.js": 347,
	"./sr.js": 346,
	"./ss": 348,
	"./ss.js": 348,
	"./sv": 349,
	"./sv.js": 349,
	"./sw": 350,
	"./sw.js": 350,
	"./ta": 351,
	"./ta.js": 351,
	"./te": 352,
	"./te.js": 352,
	"./tet": 353,
	"./tet.js": 353,
	"./tg": 354,
	"./tg.js": 354,
	"./th": 355,
	"./th.js": 355,
	"./tk": 356,
	"./tk.js": 356,
	"./tl-ph": 357,
	"./tl-ph.js": 357,
	"./tlh": 358,
	"./tlh.js": 358,
	"./tr": 359,
	"./tr.js": 359,
	"./tzl": 360,
	"./tzl.js": 360,
	"./tzm": 361,
	"./tzm-latn": 362,
	"./tzm-latn.js": 362,
	"./tzm.js": 361,
	"./ug-cn": 363,
	"./ug-cn.js": 363,
	"./uk": 364,
	"./uk.js": 364,
	"./ur": 365,
	"./ur.js": 365,
	"./uz": 366,
	"./uz-latn": 367,
	"./uz-latn.js": 367,
	"./uz.js": 366,
	"./vi": 368,
	"./vi.js": 368,
	"./x-pseudo": 369,
	"./x-pseudo.js": 369,
	"./yo": 370,
	"./yo.js": 370,
	"./zh-cn": 371,
	"./zh-cn.js": 371,
	"./zh-hk": 372,
	"./zh-hk.js": 372,
	"./zh-mo": 373,
	"./zh-mo.js": 373,
	"./zh-tw": 374,
	"./zh-tw.js": 374
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 697;

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excel_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92757668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_excel_vue__ = __webpack_require__(700);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92757668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_excel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.excelLoading),expression:"excelLoading"}],on:{"click":_vm.generate_excel}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table"},[_c('div',{staticClass:"d-header"},[_c('div',{staticClass:"pull-left seek"},[_vm._t("search"),_vm._v(" "),(_vm.jsonExcelAjax)?_c('jsonExcel',{staticClass:"btn btn-default",attrs:{"ajaxGetKey":_vm.jsonExcelAjax.getKey,"ajaxPar":_vm.jsonExcelAjax.ajaxPar || false,"ajaxType":_vm.jsonExcelAjax.ajaxType,"ajaxUrl":_vm.jsonExcelAjax.url || false,"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"downloadUrl":_vm.jsonExcelAjax.downloadUrl || false,"keys":_vm.tableHead,"name":_vm.name}},[_c('i',{staticClass:"glyphicon glyphicon-save tab-he-glyphicon"}),_vm._v("\n        "+_vm._s(_vm.reuseLan.downloadExcelForms)+"\n      ")]):_vm._e()],2),_vm._v(" "),(_vm.pageEnable)?_c('div',{staticClass:"pull-right tool-selPage"},[_c('span',[_vm._v(_vm._s(_vm.reuseLan.showTotal))]),_vm._v(" "),_c('dropdown',{attrs:{"menu-right":""}},[_c('btn',{staticClass:"dropdown-toggle"},[_vm._v("\n          "+_vm._s(_vm.selPage.list[_vm.selPage.active])+"\n          "),_c('span',{staticClass:"caret",staticStyle:{"margin-left":"5px"}})]),_vm._v(" "),_vm._l((_vm.selPage.list),function(item,index){return _c('template',{slot:"dropdown"},[_c('li',{key:index,on:{"click":function($event){return _vm.emitSelPage(index,item)}}},[_c('a',{attrs:{"role":"button"}},[_vm._v(_vm._s(item))])])])})],2)],1):_vm._e(),_vm._v(" "),_vm._t("more-filters"),_vm._v(" "),_c('div',{staticClass:"clear"})],2),_vm._v(" "),_c('div',{staticClass:"d-section",staticStyle:{"overflow-x":"auto","margin-bottom":"20px"}},[_c('div',[_c('table',{staticClass:"table table-bordered table-hover",class:{'t': _vm.changeHeight}},[_c('thead',[_c('tr',{staticStyle:{"white-space":"nowrap"}},_vm._l((_vm.tableHead),function(item){return _c('th',{key:item.key,on:{"click":function($event){return _vm.emitSort(item.key)}}},[_vm._v("\n              "+_vm._s(item.value)+"\n              "),((_vm.sort && _vm.sort.list.indexOf(item.key) > -1) || _vm.sort.list === 'All')?_c('span',{staticClass:"caret-wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{staticClass:"el-icon-caret-top",style:({color: (_vm.sort.active.key==item.key && _vm.sort.active.order == 'ASC') ? '#409eff': '#aaa'}),on:{"click":function($event){return _vm.emitSort(item.key,'ASC')}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-caret-bottom",style:({color: (_vm.sort.active.key==item.key && _vm.sort.active.order == 'DESC') ? '#409eff': '#aaa'}),on:{"click":function($event){return _vm.emitSort(item.key,'DESC')}}})]):_vm._e()])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tbodyData),function(tbody,tbodyIndex){return _c('tr',{key:tbodyIndex,class:{'less-zero': +tbody['TOTAL_PL'] > 0 },style:(("white-space:nowrap;" + (tbody.bgColor ? 'background-color:#e4effe;' : '')))},_vm._l((_vm.tableHead),function(head){return _c('td',{key:head.key},[(_vm.tip && _vm.tip.includes(head.key) && tbody[head.key])?_c('el-tooltip',[_c('div',{attrs:{"slot":"content"},slot:"content"},_vm._l((JSON.parse(tbody[head.key])),function(tips,value){return _c('span',{key:value},[_vm._v("\n                    "+_vm._s(value)+"  :  "+_vm._s(tips)+"\n                    "),_c('br')])}),0),_vm._v(" "),(tbody[head.key] && tbody[head.key].length > 40)?_c('span',{domProps:{"textContent":_vm._s(tbody[head.key].substr(0, 40) + '...')}}):_c('span',{domProps:{"textContent":_vm._s(tbody[head.key])}})]):(head.redColor)?_c('span',{style:(+tbody[head.key] < 0 ? 'color:red;' : ''),domProps:{"textContent":_vm._s(tbody[head.key])}}):_c('span',{domProps:{"textContent":_vm._s(tbody[head.key])}})],1)}),0)}),0)])]),_vm._v(" "),(_vm.tbodyData.length === 0)?_c('div',{staticClass:"noData"},[_c('i',{staticClass:"fa fa-exclamation-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.noDataMessage === "" ? _vm.reuseLan.noData : _vm.noDataMessage)+"\n    ")]):_vm._e()]),_vm._v(" "),(_vm.pageEnable)?_c('div',{staticClass:"d-footer"},[_c('div',{staticClass:"pull-left number-entries"},[_vm._v("\n      "+_vm._s(_vm.reuseLan.total)+" "+_vm._s(_vm.page.pageLeng || '*')+"\n      "+_vm._s(_vm.reuseLan.current)+"\n      "+_vm._s((_vm.page.active - 1)*_vm.selPage.limit + 1)+"-\n      "+_vm._s(_vm.page.pageLeng ? Math.min(_vm.page.active*_vm.selPage.limit, _vm.page.pageLeng) : (_vm.page.active*_vm.selPage.limit - (_vm.tbodyData.length == _vm.selPage.limit ? 0 : (_vm.selPage.limit - _vm.tbodyData.length))))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('pagination',{staticStyle:{"height":"32px"},attrs:{"total-page":_vm.page.pageLeng ? Math.ceil(_vm.page.pageLeng/_vm.selPage.limit) : (_vm.page.active + (_vm.tbodyData.length == _vm.selPage.limit)),"boundary-links":""},on:{"change":_vm.callpageFn},model:{value:(_vm.page.active),callback:function ($$v) {_vm.$set(_vm.page, "active", $$v)},expression:"page.active"}})],1),_vm._v(" "),_c('div',{staticClass:"clear"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('sll-table',{attrs:{"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData,"page":_vm.page,"selPage":_vm.selPage,"tip":_vm.tip},on:{"tableChange":_vm.requestEngine}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.typeText)}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"80px"},on:{"change":_vm.requestEngine},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.lan.typeMaps),function(val,key){return _c('el-option',{key:key,attrs:{"label":val,"value":key}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.logDate)}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetimerange","picker-options":_vm.pickerOptions,"range-separator":_vm.lan.to,"start-placeholder":_vm.lan.startTime,"end-placeholder":_vm.lan.endTime,"align":"right"},model:{value:(_vm.logDate),callback:function ($$v) {_vm.logDate=$$v},expression:"logDate"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.modifiedID)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"placeholder":_vm.lan.inputDefault},model:{value:(_vm.modifiedID),callback:function ($$v) {_vm.modifiedID=$$v},expression:"modifiedID"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.description)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"placeholder":_vm.lan.inputDefault},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.lan.searchText)},on:{"click":_vm.requestEngine}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fac4822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unenabled_vue__ = __webpack_require__(704);
var normalizeComponent = __webpack_require__(3)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fac4822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unenabled_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  无权访问\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePassword_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc0ef15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePassword_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc0ef15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc0ef15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-8 col-lg-offset-2"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 col-lg-2 control-label mimput-label"},[_vm._v(_vm._s(_vm.changePasswordLan.loginId))]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-lg-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login),expression:"login"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.login=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 col-lg-2 control-label mimput-label"},[_vm._v(_vm._s(_vm.changePasswordLan.oldPwd))]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-lg-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPwd),expression:"oldPwd"}],staticClass:"form-control",attrs:{"type":"password","disabled":_vm.viewReadOnly},domProps:{"value":(_vm.oldPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPwd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 col-lg-2 control-label mimput-label"},[_vm._v(_vm._s(_vm.changePasswordLan.newPwd))]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-lg-10"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.newPwd),expression:"newPwd"}],ref:"newPwd",staticClass:"form-control",attrs:{"name":"newPwd","type":"password","disabled":_vm.viewReadOnly},domProps:{"value":(_vm.newPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPwd=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('newPwd')),expression:"errors.has('newPwd')"}],staticClass:"failed-modal"},[_vm._v(_vm._s(_vm.changePasswordLan.errTips.newPwd))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 col-lg-2 control-label mimput-label"},[_vm._v(_vm._s(_vm.changePasswordLan.confirmPwd))]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-lg-10"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPwd'),expression:"'required|confirmed:newPwd'"}],staticClass:"form-control",attrs:{"name":"confirmPwd","type":"password","disabled":_vm.viewReadOnly}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('confirmPwd')),expression:"errors.has('confirmPwd')"}],staticClass:"failed-modal"},[_vm._v(_vm._s(_vm.changePasswordLan.errTips.confirmPwd))])])])])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.viewReadOnly},on:{"click":_vm.saveFn}},[_vm._v(_vm._s(_vm.changePasswordLan.saveBtn))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userEdit_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfd79314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userEdit_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfd79314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfd79314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),((_vm.inputType)==='checkbox'&&(_vm.inputType === 'text' || _vm.inputType === 'password'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"},{name:"validate",rawName:"v-validate",value:(_vm.validateRule),expression:"validateRule"}],staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"name":_vm.modelKey,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.mData)?_vm._i(_vm.mData,null)>-1:(_vm.mData)},on:{"change":function($event){var $$a=_vm.mData,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mData=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mData=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.mData=$$c}}}}):((_vm.inputType)==='radio'&&(_vm.inputType === 'text' || _vm.inputType === 'password'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"},{name:"validate",rawName:"v-validate",value:(_vm.validateRule),expression:"validateRule"}],staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"name":_vm.modelKey,"disabled":_vm.disabled,"type":"radio"},domProps:{"checked":_vm._q(_vm.mData,null)},on:{"change":function($event){_vm.mData=null}}}):(_vm.inputType === 'text' || _vm.inputType === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"},{name:"validate",rawName:"v-validate",value:(_vm.validateRule),expression:"validateRule"}],staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"name":_vm.modelKey,"disabled":_vm.disabled,"type":_vm.inputType},domProps:{"value":(_vm.mData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mData=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.inputType === 'radio')?_c('div',{staticClass:"radio min-radio"},[_c('label',[((_vm.inputType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.mData)?_vm._i(_vm.mData,true)>-1:(_vm.mData)},on:{"change":function($event){var $$a=_vm.mData,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mData=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mData=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.mData=$$c}}}}):((_vm.inputType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.mData,true)},on:{"change":function($event){_vm.mData=true}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":_vm.inputType},domProps:{"value":true,"value":(_vm.mData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mData=$event.target.value}}}),_vm._v("\n        "+_vm._s(_vm.radioYes)+"\n      ")]),_vm._v(" "),_c('label',[((_vm.inputType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":false,"checked":Array.isArray(_vm.mData)?_vm._i(_vm.mData,false)>-1:(_vm.mData)},on:{"change":function($event){var $$a=_vm.mData,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=false,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mData=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mData=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.mData=$$c}}}}):((_vm.inputType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.mData,false)},on:{"change":function($event){_vm.mData=false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"}],attrs:{"name":_vm.modelKey,"disabled":_vm.disabled,"type":_vm.inputType},domProps:{"value":false,"value":(_vm.mData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mData=$event.target.value}}}),_vm._v("\n        "+_vm._s(_vm.radioNo)+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.inputType === 'select')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mData),expression:"mData"},{name:"validate",rawName:"v-validate",value:(_vm.validateRule),expression:"validateRule"}],staticClass:"form-control",attrs:{"name":_vm.modelKey,"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mData=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.selectData),function(item){return _c('option',{domProps:{"value":item.value}},[_vm._v(_vm._s(item.text))])}),0):_vm._e(),_vm._v(" "),(_vm.errors.has(_vm.modelKey))?_c('div',{staticClass:"err-tips"},[_vm._v(_vm._s(_vm.errTips))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edie-wrap"},[_c('div',{staticClass:"title"},[_c('h2',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.userModelLan.userInfo))]),_vm._v(" "),_c('div',{staticClass:"btn-back pull-right"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.hanldeBack}},[_vm._v(_vm._s(_vm.userModelLan.btnBack))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"section row"},[_c('input-model',{ref:'login',attrs:{"label":_vm.userModelLan.loginId,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.login,"modelKey":'login',"validateRule":'required|max:20',"disabled":true},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'name',attrs:{"label":_vm.userModelLan.loginName,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.name,"modelKey":'name',"validateRule":'required|max:50',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'password',attrs:{"label":_vm.userModelLan.userPwd,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.password,"modelKey":'password',"validateRule":{required: false},"disabled":false,"inputType":'password'},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'enable',attrs:{"label":_vm.userModelLan.isEnable,"placeholder":_vm.userModelLan.pleaseSelect,"errTips":_vm.userModelLan.errTips,"data":_vm.enable,"modelKey":'enable',"validateRule":'',"disabled":false,"inputType":'radio',"radioYes":_vm.userModelLan.yes,"radioNo":_vm.userModelLan.no},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.userModelLan.setRole))]),_vm._v(" "),_c('el-transfer',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data":_vm.tData,"titles":_vm.transferTitles,"name":"setRole"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('setRole')),expression:"errors.has('setRole')"}],staticClass:"err-tips"},[_vm._v(_vm._s(_vm.userModelLan.pleaseSelect))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveFn}},[_vm._v(_vm._s(_vm.userModelLan.saveBtn))])]),_vm._v(" "),_c('modal',{attrs:{"title":"Modal Title","header":false,"footer":false,"size":"sm"},on:{"hide":_vm.handleModalHide},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccessfulModal),expression:"showSuccessfulModal"}],staticClass:"successful-modal"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSuccessfulModal),expression:"!showSuccessfulModal"}],staticClass:"failed-modal"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addUser_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fd8efe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addUser_vue__ = __webpack_require__(715);
function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34fd8efe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fd8efe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-usr-box"},[_c('div',{staticClass:"title"},[_c('h2',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.userModelLan.userInfo))]),_vm._v(" "),_c('div',{staticClass:"btn-back pull-right"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.hanldeBack}},[_vm._v(_vm._s(_vm.userModelLan.btnBack))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"section row"},[_c('input-model',{ref:'login',attrs:{"label":_vm.userModelLan.loginId,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.login,"modelKey":'login',"validateRule":'required|max:20',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'name',attrs:{"label":_vm.userModelLan.loginName,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.name,"modelKey":'name',"validateRule":'required|max:50',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'password',attrs:{"label":_vm.userModelLan.userPwd,"placeholder":_vm.userModelLan.pleaseEnter,"errTips":_vm.userModelLan.errTips,"data":_vm.password,"modelKey":'password',"validateRule":'required|max:100',"disabled":false,"inputType":'password'},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'enable',attrs:{"label":_vm.userModelLan.isEnable,"placeholder":_vm.userModelLan.pleaseSelect,"errTips":_vm.userModelLan.errTips,"data":_vm.enable,"modelKey":'enable',"validateRule":'required',"disabled":false,"inputType":'radio',"radioYes":_vm.userModelLan.yes,"radioNo":_vm.userModelLan.no},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.userModelLan.setRole))]),_vm._v(" "),_c('el-transfer',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data":_vm.tData,"titles":_vm.transferTitles,"name":"setRole"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('setRole')),expression:"errors.has('setRole')"}],staticClass:"err-tips"},[_vm._v(_vm._s(_vm.userModelLan.pleaseSelect))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveFn}},[_vm._v(_vm._s(_vm.userModelLan.saveBtn))])]),_vm._v(" "),_c('modal',{attrs:{"title":"Modal Title","header":false,"footer":false,"size":"sm"},on:{"hide":_vm.handleModalHide},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccessfulModal),expression:"showSuccessfulModal"}],staticClass:"successful-modal"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSuccessfulModal),expression:"!showSuccessfulModal"}],staticClass:"failed-modal"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addRole_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_708ff56c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addRole_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-708ff56c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_708ff56c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-usr-box"},[_c('div',{staticClass:"title"},[_c('h2',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.roleModelLan.roleInfo))]),_vm._v(" "),_c('div',{staticClass:"btn-back pull-right"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.hanldeBack}},[_vm._v(_vm._s(_vm.roleModelLan.btnBack))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"section row"},[_c('input-model',{ref:'roleId',attrs:{"label":_vm.roleModelLan.role,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.roleId,"modelKey":'roleId',"validateRule":'required|max:50',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'name',attrs:{"label":_vm.roleModelLan.roleName,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.name,"modelKey":'name',"validateRule":'required|max:50',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'description',attrs:{"label":_vm.roleModelLan.description,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.description,"modelKey":'description',"validateRule":'required|max:255',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(this.roleModelLan.setFunc))]),_vm._v(" "),_c('el-transfer',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data":_vm.tData,"titles":_vm.transferTitles,"name":"setFunc"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('setFunc')),expression:"errors.has('setFunc')"}],staticClass:"err-tips"},[_vm._v(_vm._s(_vm.roleModelLan.pleaseSelect))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(this.roleModelLan.setReadOnly))]),_vm._v(" "),_c('div',{staticClass:"checkbox",staticStyle:{"margin-top":"0"}},_vm._l((_vm.requestData.functions),function(item){return _c('label',{staticStyle:{"width":"100%","margin-bottom":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.readOnlyArr),expression:"readOnlyArr"}],attrs:{"type":"checkbox"},domProps:{"value":item.name,"checked":Array.isArray(_vm.readOnlyArr)?_vm._i(_vm.readOnlyArr,item.name)>-1:(_vm.readOnlyArr)},on:{"change":function($event){var $$a=_vm.readOnlyArr,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.readOnlyArr=$$a.concat([$$v]))}else{$$i>-1&&(_vm.readOnlyArr=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.readOnlyArr=$$c}}}}),_vm._v(" "+_vm._s(item.name)+"\n          ")])}),0)])])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveFn}},[_vm._v(_vm._s(this.roleModelLan.saveBtn))])]),_vm._v(" "),_c('modal',{attrs:{"title":"Modal Title","header":false,"footer":false,"size":"sm"},on:{"hide":_vm.handleModalHide},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccessfulModal),expression:"showSuccessfulModal"}],staticClass:"successful-modal"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSuccessfulModal),expression:"!showSuccessfulModal"}],staticClass:"failed-modal"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleEdit_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abbbbf38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleEdit_vue__ = __webpack_require__(721);
function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abbbbf38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abbbbf38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-box"},[_c('div',{staticClass:"title"},[_c('h2',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.roleModelLan.roleInfo))]),_vm._v(" "),_c('div',{staticClass:"btn-back pull-right"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.hanldeBack}},[_vm._v(_vm._s(_vm.roleModelLan.btnBack))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"section row"},[_c('input-model',{ref:'roleId',attrs:{"label":_vm.roleModelLan.role,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.roleId,"modelKey":'roleId',"validateRule":'required|max:50',"disabled":true},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'name',attrs:{"label":_vm.roleModelLan.roleName,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.name,"modelKey":'name',"validateRule":'required|max:50',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('input-model',{ref:'description',attrs:{"label":_vm.roleModelLan.description,"placeholder":_vm.roleModelLan.pleaseEnter,"errTips":_vm.roleModelLan.errTips,"data":_vm.description,"modelKey":'description',"validateRule":'required|max:255',"disabled":false},on:{"changeData":_vm.handleChangeData}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(this.roleModelLan.setFunc))]),_vm._v(" "),_c('el-transfer',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data":_vm.tData,"titles":_vm.transferTitles,"name":"setFunc"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('setFunc')),expression:"errors.has('setFunc')"}],staticClass:"err-tips"},[_vm._v(_vm._s(_vm.roleModelLan.pleaseSelect))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(this.roleModelLan.setReadOnly))]),_vm._v(" "),_c('div',{staticClass:"checkbox",staticStyle:{"margin-top":"0"}},_vm._l((_vm.selectedFunc),function(item){return _c('label',{staticStyle:{"width":"100%","margin-bottom":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.readOnlyArr),expression:"readOnlyArr"}],attrs:{"type":"checkbox"},domProps:{"value":item.name,"checked":Array.isArray(_vm.readOnlyArr)?_vm._i(_vm.readOnlyArr,item.name)>-1:(_vm.readOnlyArr)},on:{"change":function($event){var $$a=_vm.readOnlyArr,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.readOnlyArr=$$a.concat([$$v]))}else{$$i>-1&&(_vm.readOnlyArr=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.readOnlyArr=$$c}}}}),_vm._v(" "+_vm._s(item.name)+"\n          ")])}),0)])])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveFn}},[_vm._v(_vm._s(this.roleModelLan.saveBtn))])]),_vm._v(" "),_c('modal',{attrs:{"title":"Modal Title","header":false,"footer":false,"size":"sm"},on:{"hide":_vm.handleModalHide},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccessfulModal),expression:"showSuccessfulModal"}],staticClass:"successful-modal"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSuccessfulModal),expression:"!showSuccessfulModal"}],staticClass:"failed-modal"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.modalTips))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_manager_report_closed_trades_report__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_manager_report_floatingpl_report__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_manager_report_open_trades_report__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_manager_report_account_analyze_report__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_manager_report_symbol_profit_report__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_manager_report_profit_top_list__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_manager_report_download_report__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_manager_report_mt4_closed_trades_report__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_manager_report_mt4_deposit_withdrawl_report__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_manager_report_mt4_credit_report__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_manager_report_mt4_summary_report__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_manager_report_mt4_seregated_report__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_manager_report_mt4_equity_report__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_manager_report_mt4_equity_multi_report__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_manager_report_mt4_profitloss_report__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_manager_report_mt4_account_report__ = __webpack_require__(771);


















var managerRouters = [{ path: '/closedTradesReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_0__views_manager_report_closed_trades_report__["a" /* default */] }, { path: '/floatingPLReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_1__views_manager_report_floatingpl_report__["a" /* default */] }, { path: '/openTradesReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_2__views_manager_report_open_trades_report__["a" /* default */] }, { path: '/accountAnalyzeReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_3__views_manager_report_account_analyze_report__["a" /* default */] }, { path: '/symbolProfitReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_4__views_manager_report_symbol_profit_report__["a" /* default */] }, { path: '/profitTopList', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_5__views_manager_report_profit_top_list__["a" /* default */] }, { path: '/downloadReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_6__views_manager_report_download_report__["a" /* default */] }, { path: '/mt4ClosedTradesReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_7__views_manager_report_mt4_closed_trades_report__["a" /* default */] }, { path: '/mt4DepositWithdrawlReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_8__views_manager_report_mt4_deposit_withdrawl_report__["a" /* default */] }, { path: '/mt4CreditReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_9__views_manager_report_mt4_credit_report__["a" /* default */] }, { path: '/mt4SummaryReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_10__views_manager_report_mt4_summary_report__["a" /* default */] }, { path: '/mt4SeregatedReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_11__views_manager_report_mt4_seregated_report__["a" /* default */] }, { path: '/mt4EquityReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_12__views_manager_report_mt4_equity_report__["a" /* default */] }, { path: '/mt4EquityMultiReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_13__views_manager_report_mt4_equity_multi_report__["a" /* default */] }, { path: '/mt4ProfitLossReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_14__views_manager_report_mt4_profitloss_report__["a" /* default */] }, { path: '/mt4AccountReport', meta: { showInCrumb: true }, component: __WEBPACK_IMPORTED_MODULE_15__views_manager_report_mt4_account_report__["a" /* default */] }, { path: '/managerAuth', component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 940));
    } }];

/* harmony default export */ __webpack_exports__["a"] = (managerRouters);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_closed_trades_report_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee87a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_closed_trades_report_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eee87a16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_closed_trades_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee87a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_closed_trades_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.posText)}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"90px"},on:{"change":_vm.filterHandle},model:{value:(_vm.formData.dealType),callback:function ($$v) {_vm.$set(_vm.formData, "dealType", $$v)},expression:"formData.dealType"}},_vm._l((_vm.language.typeMapping),function(val,key){return _c('el-option',{key:key,attrs:{"label":val,"value":key}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-select',{staticStyle:{"width":"125px"},model:{value:(_vm.formData.timeType),callback:function ($$v) {_vm.$set(_vm.formData, "timeType", $$v)},expression:"formData.timeType"}},_vm._l((_vm.orderTime),function(val,key){return _c('el-option',{key:key,attrs:{"label":val,"value":key}})}),1),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"230px"},attrs:{"default-time":['00:00:00', '00:00:00'],"end-placeholder":_vm.language.endTime,"picker-options":_vm.pickerOption,"start-placeholder":_vm.language.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd HH:mm:ss"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.orderTime),callback:function ($$v) {_vm.$set(_vm.formData, "orderTime", $$v)},expression:"formData.orderTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.filterHandle}},[_vm._v(_vm._s(_vm.reuse.searchText))])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.ticketText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ticket),callback:function ($$v) {_vm.$set(_vm.formData, "ticket", $$v)},expression:"formData.ticket"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.symbolText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.symbol),callback:function ($$v) {_vm.$set(_vm.formData, "symbol", $$v)},expression:"formData.symbol"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.currencyText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.currency),callback:function ($$v) {_vm.$set(_vm.formData, "currency", $$v)},expression:"formData.currency"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floatingpl_report_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070f0995_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floatingpl_report_vue__ = __webpack_require__(728);
function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-070f0995"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floatingpl_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070f0995_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floatingpl_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle",attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"disabled":_vm.btnStatus,"type":"primary"},on:{"click":function($event){return _vm.handlePageChange(1)}}},[_vm._v(_vm._s(_vm.reuse.refresh))])],1),_vm._v(" "),_c('el-col',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.realtimeDownload),expression:"realtimeDownload"}],attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"disabled":_vm.btnStatus},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.language.nowDownload))])],1),_vm._v(" "),_c('el-col',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dailyDownload),expression:"dailyDownload"}],attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",on:{"click":_vm.downloadDaily}},[_vm._v(_vm._s(_vm.language.endOfDayDownload))])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-date-picker',{staticClass:"handle-row",attrs:{"picker-options":_vm.pickerOptions,"placeholder":_vm.language.placeholder,"type":"date","value-format":"yyyy-MM-dd"},model:{value:(_vm.dayOfReport),callback:function ($$v) {_vm.dayOfReport=$$v},expression:"dayOfReport"}})],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadAccInfo),expression:"loadAccInfo"}]},[_c('el-table',{attrs:{"data":_vm.plData,"border":""}},[_vm._l((_vm.tableColumns),function(v,i){return [_c('el-table-column',{key:i,attrs:{"fixed":v.fixed,"width":160,"prop":v.key,"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.redColor)?_c('span',{style:(+scope.row[v.key] < 0 ? 'color:red;':'')},[_vm._v(_vm._s(scope.row[v.key]))]):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_open_trades_report_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ee826_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_open_trades_report_vue__ = __webpack_require__(734);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-084ee826"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_open_trades_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ee826_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_open_trades_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle",attrs:{"gutter":20}},[_c('el-col',{attrs:{"lg":18,"md":18,"sm":18,"xl":18,"xs":18}},[_c('el-select',{staticClass:"handle-row",attrs:{"filterable":"","multiple":"","placeholder":_vm.language.symbolText},model:{value:(_vm.symbols),callback:function ($$v) {_vm.symbols=$$v},expression:"symbols"}},_vm._l((_vm.symbolList),function(v,i){return _c('el-option',{key:i,attrs:{"label":v.SYMBOL,"value":v.SYMBOL}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"lg":3,"md":3,"sm":3,"xl":3,"xs":3}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary"},on:{"click":_vm.getOpenTradesBySymbols}},[_vm._v(_vm._s(_vm.reuse.refresh))])],1),_vm._v(" "),_c('el-col',{attrs:{"lg":3,"md":3,"sm":3,"xl":3,"xs":3}},[_c('el-button',{staticClass:"handle-row",on:{"click":_vm.export2Excel}},[_vm._v(_vm._s(_vm.reuse.downloadExcelForms))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"filter"},[_c('el-col',[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":_vm.language.filterText},on:{"change":_vm.findByKeyword},model:{value:(_vm.filterVal),callback:function ($$v) {_vm.filterVal=$$v},expression:"filterVal"}},[_c('el-select',{attrs:{"slot":"prepend"},slot:"prepend",model:{value:(_vm.filterKey),callback:function ($$v) {_vm.filterKey=$$v},expression:"filterKey"}},[_vm._l((_vm.language.filterOptions),function(v,k){return [_c('el-option',{key:k,attrs:{"label":v,"value":k}})]})],2)],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-table',{attrs:{"data":_vm.openTrades,"border":""}},[_c('el-table-column',{key:"expand",attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-table',{attrs:{"data":_vm.copySymbols.map(function (s) {
                  return {
                    SYMBOL: s,
                    SELL_VOLUME: props.row[(s + "_SELL_VOLUME")] || 0,
                    BUY_VOLUME: props.row[(s + "_BUY_VOLUME")] || 0,
                    VOLUME: props.row[(s + "_VOLUME")] || 0,
                    PL: props.row[(s + "_PL")] || 0,
                  }
                }),"border":"","max-height":"200","size":"mini"}},[_vm._l((_vm.language.expandHead),function(v,k){return [_c('el-table-column',{key:k,attrs:{"prop":k,"label":v},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(['PL'].includes(k) && scope.row[k] < 0 ? 'color:red;' : '')},[_vm._v(_vm._s(scope.row[k]))])]}}],null,true)})]})],2)]}}])}),_vm._v(" "),_vm._l((_vm.tableHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"prop":v.key,"fixed":"","label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.redColor)?_c('span',{style:(+scope.row[v.key] < 0 ? 'color:red;' : '')},[_vm._v(_vm._s(scope.row[v.key]))]):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_analyze_report_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4117c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_analyze_report_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad4117c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_analyze_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4117c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_analyze_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.pageHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type"},[_c('div',{staticStyle:{"display":"inline"},on:{"click":function($event){_vm.showBox = true}}},[_c('i',{staticClass:"glyphicon glyphicon-question-sign"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.language.statusText)}})]),_vm._v(" "),_c('el-select',{on:{"change":_vm.selectHandle},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.language.status),function(v,k){return _c('el-option',{key:k,attrs:{"label":v,"value":k}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.dateText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOptions,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('div',{staticClass:"btn btn-default",on:{"click":_vm.export2Excel}},[_c('i',{staticClass:"glyphicon glyphicon-save tab-he-glyphicon"}),_vm._v("\n            "+_vm._s(_vm.reuse.downloadExcelForms)+"\n          ")])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.description,"visible":_vm.showBox},on:{"update:visible":function($event){_vm.showBox=$event}}},[_vm._l((_vm.language.status),function(v,k){return [(k >= 0)?_c('el-row',{key:k},[_c('el-col',{attrs:{"span":2}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_vm._v(_vm._s(_vm.language.desc ? _vm.language.desc[k].replace(/start/g,_vm.start).replace(/end/g,_vm.end): ''))])],1):_vm._e()]})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_symbol_profit_report_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b06e4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_symbol_profit_report_vue__ = __webpack_require__(740);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82b06e4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_symbol_profit_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b06e4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_symbol_profit_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel"},[_c('el-row',{staticClass:"function",attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.btnStatus,"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.refresh)},on:{"click":_vm.ajaxHandle}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.btnStatus},domProps:{"textContent":_vm._s(_vm.language.nowDownload)},on:{"click":function($event){return _vm.export2Excel(_vm.tbodyData, _vm.language.excelName)}}})],1),_vm._v(" "),_c('el-col',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dailyLoading),expression:"dailyLoading"}],attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticStyle:{"width":"100%"},domProps:{"textContent":_vm._s(_vm.language.endOfDayDownload)},on:{"click":_vm.export2EndOfDayExcel}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"picker-options":_vm.pickerOptions,"placeholder":_vm.language.placeholder,"type":"date"},model:{value:(_vm.dayOfReport),callback:function ($$v) {_vm.dayOfReport=$$v},expression:"dayOfReport"}})],1)],1),_vm._v(" "),_c('el-row',[_c('custom-table',{attrs:{"changeHeight":true,"pageEnable":false,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_top_list_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b959c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_top_list_vue__ = __webpack_require__(743);
function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50b959c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_top_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b959c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_top_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel"},[_c('el-row',{staticClass:"function",attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-col',{staticStyle:{"padding":"10px 0 0 0"},attrs:{"xs":6,"sm":6,"md":6,"lg":6,"xl":6}},[_vm._v(_vm._s(_vm.language.topTxt))]),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"0"},attrs:{"xs":18,"sm":18,"md":18,"lg":18,"xl":18}},[_c('el-input',{model:{value:(_vm.formData.topValue),callback:function ($$v) {_vm.$set(_vm.formData, "topValue", $$v)},expression:"formData.topValue"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-col',{staticStyle:{"padding":"10px 0 0 0"},attrs:{"xs":8,"sm":8,"md":8,"lg":8,"xl":8}},[_vm._v(_vm._s(_vm.language.profitTypeTxt))]),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"0"},attrs:{"xs":16,"sm":16,"md":16,"lg":16,"xl":16}},[_c('el-select',{on:{"change":_vm.profitTypeChange},model:{value:(_vm.formData.profitType),callback:function ($$v) {_vm.$set(_vm.formData, "profitType", $$v)},expression:"formData.profitType"}},[_vm._l((_vm.language.profitType),function(k,v){return [_c('el-option',{key:v,attrs:{"label":k,"value":v}})]})],2)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":5,"sm":5,"md":5,"lg":5,"xl":5}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"end-placeholder":_vm.language.endTime,"picker-options":_vm.pickerOptions,"start-placeholder":_vm.language.startTime,"type":"daterange","value-format":"yyyy-MM-dd"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.dateRange),callback:function ($$v) {_vm.$set(_vm.formData, "dateRange", $$v)},expression:"formData.dateRange"}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":2,"sm":2,"md":2,"lg":2,"xl":2}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.language.searchTxt)},on:{"click":_vm.ajaxHandle}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticStyle:{"width":"100%"},domProps:{"textContent":_vm._s(_vm.language.downloadTxt)},on:{"click":function($event){return _vm.export2Excel(_vm.tbodyData, _vm.language.excelName)}}})],1)],1),_vm._v(" "),_c('el-row',[_c('custom-table',{attrs:{"changeHeight":true,"pageEnable":false,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_report_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e239d7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_report_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e239d7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e239d7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"grid-content",attrs:{"gutter":1}},[_c('el-col',{attrs:{"lg":4}},[_c('el-button',{attrs:{"disabled":!_vm.folderName,"type":"primary"},on:{"click":_vm.comeBack}},[_vm._v(_vm._s(_vm.lan.previous))])],1),_vm._v(" "),_c('el-col',{staticClass:"current-path",attrs:{"lg":20}},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.folders),function(k,v){return _c('el-breadcrumb-item',{key:v},[_vm._v(_vm._s(k))])}),1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-table',{attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":_vm.lan.tableHead.file},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{class:("el-icon-" + (scope.row.file ? 'tickets' : 'folder'))}),_vm._v(" "),_c('span',{style:(("margin-left: 10px;" + (!scope.row.file ? 'color:#409EFF;' : '')))},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.lan.tableHead.handle},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.file)?_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":function($event){return _vm.downloadFile(scope.row)}}},[_vm._v(_vm._s(_vm.lan.download))]):_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":function($event){return _vm.openFolder(scope.row)}}},[_vm._v(_vm._s(_vm.lan.open))])]}}])})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"grid-content",attrs:{"gutter":20}},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_closed_trades_report_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044f7039_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_closed_trades_report_vue__ = __webpack_require__(749);
function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-044f7039"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_closed_trades_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044f7039_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_closed_trades_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOption,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.closeTime),callback:function ($$v) {_vm.$set(_vm.formData, "closeTime", $$v)},expression:"formData.closeTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.securityText)}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"210px"},attrs:{"collapse-tags":"","multiple":""},model:{value:(_vm.formData.security),callback:function ($$v) {_vm.$set(_vm.formData, "security", $$v)},expression:"formData.security"}},_vm._l((_vm.securityList),function(val,key){return _c('el-option',{key:key,attrs:{"label":val.TYPE,"value":val.TYPE}})}),1)],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_deposit_withdrawl_report_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c643c38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_deposit_withdrawl_report_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c643c38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_deposit_withdrawl_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c643c38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_deposit_withdrawl_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOption,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.closeTime),callback:function ($$v) {_vm.$set(_vm.formData, "closeTime", $$v)},expression:"formData.closeTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.commentText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.comment),callback:function ($$v) {_vm.$set(_vm.formData, "comment", $$v)},expression:"formData.comment"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_credit_report_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1560f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_credit_report_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1560f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_credit_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1560f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_credit_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOption,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.closeTime),callback:function ($$v) {_vm.$set(_vm.formData, "closeTime", $$v)},expression:"formData.closeTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_summary_report_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ac13e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_summary_report_vue__ = __webpack_require__(758);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60ac13e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_summary_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ac13e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_summary_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOption,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},on:{"blur":_vm.blurHandle},model:{value:(_vm.formData.closeTime),callback:function ($$v) {_vm.$set(_vm.formData, "closeTime", $$v)},expression:"formData.closeTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_seregated_report_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351b32be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_seregated_report_vue__ = __webpack_require__(761);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-351b32be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_seregated_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351b32be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_seregated_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_equity_report_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90736464_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_equity_report_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90736464"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_equity_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90736464_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_equity_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"150px"},attrs:{"picker-options":_vm.pickerOptions,"placeholder":_vm.language.dateText,"type":"date","value-format":"yyyy-MM-dd"},model:{value:(_vm.formData.date),callback:function ($$v) {_vm.$set(_vm.formData, "date", $$v)},expression:"formData.date"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_equity_multi_report_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231eb9ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_equity_multi_report_vue__ = __webpack_require__(767);
function injectStyle (ssrContext) {
  __webpack_require__(766)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-231eb9ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_equity_multi_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231eb9ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_equity_multi_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOptions,"start-placeholder":_vm.reuse.startTime,"type":"daterange","value-format":"yyyy-MM-dd"},model:{value:(_vm.formData.dateRange),callback:function ($$v) {_vm.$set(_vm.formData, "dateRange", $$v)},expression:"formData.dateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_profitloss_report_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77793062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_profitloss_report_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77793062"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_profitloss_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77793062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_profitloss_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.timeText)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"end-placeholder":_vm.reuse.endTime,"picker-options":_vm.pickerOptions,"start-placeholder":_vm.reuse.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd"},model:{value:(_vm.formData.dateRange),callback:function ($$v) {_vm.$set(_vm.formData, "dateRange", $$v)},expression:"formData.dateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_account_report_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27cc1a26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_account_report_vue__ = __webpack_require__(773);
function injectStyle (ssrContext) {
  __webpack_require__(772)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27cc1a26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mt4_account_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27cc1a26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mt4_account_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.login),callback:function ($$v) {_vm.$set(_vm.formData, "login", $$v)},expression:"formData.login"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.groupText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.group),callback:function ($$v) {_vm.$set(_vm.formData, "group", $$v)},expression:"formData.group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.ibNum),callback:function ($$v) {_vm.$set(_vm.formData, "ibNum", $$v)},expression:"formData.ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.office),callback:function ($$v) {_vm.$set(_vm.formData, "office", $$v)},expression:"formData.office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.nameFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.nameFilter),callback:function ($$v) {_vm.$set(_vm.formData, "nameFilter", $$v)},expression:"formData.nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.loginFilterText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.formData.loginFilter),callback:function ($$v) {_vm.$set(_vm.formData, "loginFilter", $$v)},expression:"formData.loginFilter"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_record_manager_operate_record__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_record_login_record__ = __webpack_require__(782);



var recordRouters = [{ path: '/managerOperateRecord', component: __WEBPACK_IMPORTED_MODULE_0__views_record_manager_operate_record__["a" /* default */] }, { path: '/loginRecord', component: __WEBPACK_IMPORTED_MODULE_1__views_record_login_record__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (recordRouters);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manager_operate_record_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6fe307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manager_operate_record_vue__ = __webpack_require__(781);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f6fe307"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manager_operate_record_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6fe307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manager_operate_record_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel"},[_c('custom-table',{attrs:{"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData,"noDataMessage":_vm.noDataMessage},on:{"tableChange":_vm.pageHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.typeText)}}),_vm._v(" "),_c('el-select',{on:{"change":_vm.selectHandle},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.language.operateTypeMapping),function(v,k){return _c('el-option',{key:k,attrs:{"label":v,"value":k}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.language.operateDay)}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"200px"},attrs:{"type":"date","value-format":"yyyy-MM-dd"},model:{value:(_vm.operateDay),callback:function ($$v) {_vm.operateDay=$$v},expression:"operateDay"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.filterHandle}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('div',{staticClass:"btn btn-default",on:{"click":_vm.export2Excel}},[_c('i',{staticClass:"glyphicon glyphicon-save tab-he-glyphicon"}),_vm._v("\n                  "+_vm._s(_vm.reuse.downloadExcelForms)+"\n                  ")])])])]),_vm._v(" "),_c('custom-table',{attrs:{"tableHead":_vm.summaryHead,"pageEnable":false,"tbodyData":_vm.summaryData,"noDataMessage":_vm.noDataMessage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_record_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e24e1a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_record_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e24e1a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_record_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e24e1a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_record_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel"},[_c('custom-table',{attrs:{"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.pageHandle}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type"},[_c('el-input',{model:{value:(_vm.searchVal),callback:function ($$v) {_vm.searchVal=$$v},expression:"searchVal"}},[_c('el-select',{staticStyle:{"width":"110px"},attrs:{"slot":"prepend"},slot:"prepend",model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}},[_vm._l((_vm.language.searchKeys),function(k,v){return [_c('el-option',{key:v,attrs:{"label":k,"value":v}})]})],2),_vm._v(" "),_c('el-button',{attrs:{"slot":"append"},on:{"click":_vm.ajaxHandle},slot:"append"},[_vm._v(_vm._s(_vm.reuse.searchText))])],1)],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('div',{staticClass:"btn btn-default",on:{"click":_vm.export2Excel}},[_c('i',{staticClass:"glyphicon glyphicon-save tab-he-glyphicon"}),_vm._v("\n                  "+_vm._s(_vm.reuse.downloadExcelForms)+"\n                  ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_report_day_trade_report__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_report_position_report__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_report_b_book_report__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_report_client_report__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_report_monitor_accounts_report__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_report_auto_position_report__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_report_auto_update_leverage__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_report_charge_dividends__ = __webpack_require__(810);









var reportRouters = [{ path: '/dayTradeReport', component: __WEBPACK_IMPORTED_MODULE_0__views_report_day_trade_report__["a" /* default */] }, { path: '/positionReport', component: __WEBPACK_IMPORTED_MODULE_1__views_report_position_report__["a" /* default */] }, { path: '/bBookReport', component: __WEBPACK_IMPORTED_MODULE_2__views_report_b_book_report__["a" /* default */] }, { path: '/clientReport', component: __WEBPACK_IMPORTED_MODULE_3__views_report_client_report__["a" /* default */] }, { path: '/monitorAccountsReport', component: __WEBPACK_IMPORTED_MODULE_4__views_report_monitor_accounts_report__["a" /* default */] }, { path: '/autoPositionReport', component: __WEBPACK_IMPORTED_MODULE_5__views_report_auto_position_report__["a" /* default */] }, { path: '/autoUpdateLeverage', component: __WEBPACK_IMPORTED_MODULE_6__views_report_auto_update_leverage__["a" /* default */] }, { path: '/chargeDividends', component: __WEBPACK_IMPORTED_MODULE_7__views_report_charge_dividends__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (reportRouters);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_day_trade_report_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7cbaa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_day_trade_report_vue__ = __webpack_require__(791);
function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b7cbaa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_day_trade_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7cbaa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_day_trade_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleSelect_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f56a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleSelect_vue__ = __webpack_require__(790);
function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-203f56a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f56a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"multiple":""},on:{"change":_vm.changeSelect},model:{value:(_vm.selectValues),callback:function ($$v) {_vm.selectValues=$$v},expression:"selectValues"}},[(_vm.options.length)?_c('el-option',{attrs:{"label":_vm.reuseLan.selectAll.label,"value":_vm.reuseLan.selectAll.key}},[_c('el-checkbox',{nativeOn:{"click":function($event){$event.preventDefault();}},model:{value:(_vm.isSelectAll),callback:function ($$v) {_vm.isSelectAll=$$v},expression:"isSelectAll"}},[_vm._v(_vm._s(_vm.reuseLan.selectAll.label))])],1):_vm._e(),_vm._v(" "),(_vm.options.length)?_c('hr'):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(item){return _c('el-option',{key:item[_vm.props.value],attrs:{"label":item[_vm.props.label],"value":item[_vm.props.value]}},[_c('el-checkbox',{nativeOn:{"click":function($event){$event.preventDefault();}},model:{value:(item.isCheck),callback:function ($$v) {_vm.$set(item, "isCheck", $$v)},expression:"item.isCheck"}},[_vm._v(_vm._s(item[_vm.props.label]))])],1)}),_vm._v(" "),(_vm.options.length)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.options.length)?_c('el-option',{attrs:{"label":_vm.reuseLan.rememberMyChoice.label,"value":_vm.reuseLan.rememberMyChoice.key}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"maintenance-box",attrs:{"element-loading-text":_vm.loadText}},[_c('div',{staticClass:"panel"},[_c('reuse-table',{attrs:{"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"sort":_vm.sort,"tableHead":_vm.vTableHeader,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.requestEngine}},[_c('el-row',{staticClass:"search-box",attrs:{"slot":"search","gutter":20},slot:"search"},[_c('el-col',{staticClass:"select-type more-select",attrs:{"xs":3,"sm":3,"md":3,"lg":3,"xl":3}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('el-col',{staticClass:"select-type",attrs:{"xs":7,"sm":7,"md":7,"lg":7,"xl":7}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.CloseDateText)}})]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":8,"sm":8,"md":8,"lg":8,"xl":8}},[_c('el-select',{staticClass:"date-range-type",on:{"change":_vm.changeTime},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.reuse.typeMaps),function(val,key){return _c('el-option',{key:key,attrs:{"label":val,"value":key}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":16,"sm":16,"md":16,"lg":16,"xl":16}},[_c('el-date-picker',{staticClass:"date-range-value",attrs:{"default-time":['00:00:00', '00:00:00'],"disabled":_vm.canSelect,"end-placeholder":_vm.lan.endTime,"start-placeholder":_vm.lan.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.closeTime),callback:function ($$v) {_vm.closeTime=$$v},expression:"closeTime"}})],1)],1)],1),_vm._v(" "),_c('el-col',{staticClass:"select-type",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.pointText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.pointVal),callback:function ($$v) {_vm.pointVal=$$v},expression:"pointVal"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"select-type",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.profitText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.profit),callback:function ($$v) {_vm.profit=$$v},expression:"profit"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"select-type",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.ownTimeText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.ownTime),callback:function ($$v) {_vm.ownTime=$$v},expression:"ownTime"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"select-type search-btn",attrs:{"xs":2,"sm":2,"md":2,"lg":2,"xl":2}},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.searchHandle}})],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters","gutter":20},slot:"more-filters"},[_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.securityText)}})]),_vm._v(" "),_c('el-row',[_c('el-select',{attrs:{"collapse-tags":"","multiple":""},model:{value:(_vm.security),callback:function ($$v) {_vm.security=$$v},expression:"security"}},_vm._l((_vm.securityList),function(val,key){return _c('el-option',{key:key,attrs:{"label":val.TYPE,"value":val.TYPE}})}),1)],1)],1),_vm._v(" "),_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.loginText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.ibNumText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.ibNum),callback:function ($$v) {_vm.ibNum=$$v},expression:"ibNum"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.office),callback:function ($$v) {_vm.office=$$v},expression:"office"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"searchDiv",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-row',[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.symbolText)}})]),_vm._v(" "),_c('el-row',[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.symbol),callback:function ($$v) {_vm.symbol=$$v},expression:"symbol"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"control-table-header",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('el-col',[_c('multiple-select',{attrs:{"initRemember":_vm.initRemember,"initSelectValues":_vm.visibleTableHeaders,"options":_vm.tableHead,"initPlaceholder":_vm.initPlaceholder},on:{"change":_vm.hideTableHeader}})],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_position_report_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0feed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_position_report_vue__ = __webpack_require__(794);
function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba0feed6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_position_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0feed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_position_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"maintenance-box",attrs:{"element-loading-text":_vm.loadText}},[_c('div',{staticClass:"panel"},[_c('reuse-table',{attrs:{"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"sort":_vm.sort,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.requestEngine}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type",staticStyle:{"margin-top":"2px"}},[_c('el-switch',{attrs:{"active-text":_vm.reuse.moreSelect,"inactive-text":""},model:{value:(_vm.more),callback:function ($$v) {_vm.more=$$v},expression:"more"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.OpenDateText)}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"117px"},on:{"change":_vm.changeTime},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.reuse.typeMaps),function(val,key){return _c('el-option',{key:key,attrs:{"label":val,"value":key}})}),1),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"230px"},attrs:{"default-time":['00:00:00', '00:00:00'],"disabled":_vm.canSelect,"end-placeholder":_vm.lan.endTime,"start-placeholder":_vm.lan.startTime,"type":"daterange","unlink-panels":"","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.openTime),callback:function ($$v) {_vm.openTime=$$v},expression:"openTime"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.symbolText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"120px"},attrs:{"clearable":""},model:{value:(_vm.symbol),callback:function ($$v) {_vm.symbol=$$v},expression:"symbol"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.volumeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"90px"},attrs:{"clearable":""},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 5px"}},[_vm._v(_vm._s(_vm.lan.to))]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"90px"},attrs:{"clearable":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.searchHandle}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],staticClass:"extraSearch",attrs:{"slot":"more-filters"},slot:"more-filters"},[_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.loginText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.ibNumText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.ibNum),callback:function ($$v) {_vm.ibNum=$$v},expression:"ibNum"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.officeText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.office),callback:function ($$v) {_vm.office=$$v},expression:"office"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.reuse.regionText)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"210px"},attrs:{"clearable":""},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}})],1),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.securityText)}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"210px"},attrs:{"collapse-tags":"","multiple":""},model:{value:(_vm.security),callback:function ($$v) {_vm.security=$$v},expression:"security"}},_vm._l((_vm.securityList),function(val,key){return _c('el-option',{key:key,attrs:{"label":val.TYPE,"value":val.TYPE}})}),1)],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_b_book_report_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac53a5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_b_book_report_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ac53a5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_b_book_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac53a5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_b_book_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel"},[_c('sll-table',{attrs:{"changeHeight":true,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"pageEnable":false,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.requestEngine}},[_c('div',{staticClass:"search-box",attrs:{"slot":"search"},slot:"search"},[_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.bGroup)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"clearable":""},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('span',{domProps:{"textContent":_vm._s(_vm.lan.aAccount)}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"clearable":""},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}})],1),_vm._v(" "),_c('div',{staticClass:"select-type"},[_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.reuse.searchText)},on:{"click":_vm.requestEngine}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_client_report_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a60a85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_client_report_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40a60a85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_client_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a60a85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_client_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"panel",attrs:{"element-loading-text":_vm.loadText}},[_c('custom-table',{attrs:{"downloadLoading":_vm.downloadLoading,"downLoadTran":_vm.downLoadTran,"jsonExcelAjax":_vm.jsonExcelAjax,"name":_vm.name,"page":_vm.page,"selPage":_vm.selPage,"tableHead":_vm.tableHead,"tbodyData":_vm.tbodyData},on:{"tableChange":_vm.ajaxHandle}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monitor_accounts_report_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4fa8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monitor_accounts_report_vue__ = __webpack_require__(803);
function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c4fa8c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monitor_accounts_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4fa8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monitor_accounts_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"xs":2,"sm":2,"md":2,"lg":2,"xl":2}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary","icon":"el-icon-refresh"},on:{"click":_vm.refreshAcc}},[_vm._v(_vm._s(_vm.reuse.refresh))])],1),_vm._v(" "),_c('el-col',{staticClass:"trades",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary","icon":"el-icon-circle-plus"},on:{"click":function($event){_vm.addAccWindow = true}}},[_vm._v(_vm._s(_vm.language.addBtnTxt))])],1),_vm._v(" "),_c('el-col',{staticClass:"trades",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-badge',{attrs:{"value":_vm.notifyCount}},[_c('el-button',{staticClass:"handle-row",attrs:{"disabled":_vm.notifyCount === 0},on:{"click":function($event){_vm.notify = true}}},[_vm._v(_vm._s(_vm.language.badgeBtnTxt))])],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadAccInfo),expression:"loadAccInfo"}]},[_c('el-table',{attrs:{"data":_vm.accInfo,"border":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-form',{staticClass:"demo-table-expand",attrs:{"label-position":"left","inline":""}},[_vm._l((_vm.tableHead),function(v,i){return [_c('el-form-item',{key:i,attrs:{"label":v.value}},[(v.writable)?_c('el-input',{attrs:{"type":"textarea","maxlength":"255","show-word-limit":""},model:{value:(scope.row[v.key]),callback:function ($$v) {_vm.$set(scope.row, v.key, $$v)},expression:"scope.row[v.key]"}}):(v.table)?_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.showTable(scope.row.LOGINS)}}},[_vm._v(_vm._s(_vm.language.showIPBtnTxt))]):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])],1)]})],2)]}}])}),_vm._v(" "),_vm._l((_vm.accHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.writable)?_c('el-input',{attrs:{"type":"textarea","maxlength":"255"},model:{value:(scope.row[v.key]),callback:function ($$v) {_vm.$set(scope.row, v.key, $$v)},expression:"scope.row[v.key]"}}):(v.redColor)?_c('span',{style:(+scope.row[v.key] < 0 ? 'color:red;' : '')},[_vm._v(_vm._s(scope.row[v.key]))]):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.language.lastTableColumnTxt,"width":"120px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.deleteAccount(scope.row.LOGIN)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit","circle":""},on:{"click":function($event){return _vm.updateAccount(scope.row)}}})]}}])})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.addDialogTitle,"visible":_vm.addAccWindow,"before-close":function (done) {},"show-close":false},on:{"update:visible":function($event){_vm.addAccWindow=$event}}},[_c('el-form',{ref:"accForm",attrs:{"model":_vm.accForm,"rules":_vm.rules,"label-position":"top"}},[_c('el-form-item',{attrs:{"label":_vm.language.formLoginLabel,"prop":"login"}},[_c('el-input',{model:{value:(_vm.accForm.login),callback:function ($$v) {_vm.$set(_vm.accForm, "login", _vm._n($$v))},expression:"accForm.login"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.formCommentLabel,"prop":"comment"}},[_c('el-select',{attrs:{"placeholder":_vm.language.formSelectDefaultTxt},on:{"change":_vm.handleCommentChange},model:{value:(_vm.commentType),callback:function ($$v) {_vm.commentType=$$v},expression:"commentType"}},_vm._l((_vm.language.commentOpt),function(k,v){return _c('el-option',{key:v,attrs:{"label":k,"value":v}})}),1)],1),_vm._v(" "),(_vm.commentType == 6)?_c('el-form-item',{attrs:{"prop":"comment"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.accForm.comment),callback:function ($$v) {_vm.$set(_vm.accForm, "comment", $$v)},expression:"accForm.comment"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.resetAccInfo}},[_vm._v(_vm._s(_vm.language.formCancelTxt))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addAccount}},[_vm._v(_vm._s(_vm.language.formConfirmTxt))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.ipTableDialogTitle,"visible":_vm.ipTableWindow,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.ipTableWindow=$event},"close":_vm.handleWindowClose}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"lg":18,"md":18,"sm":18,"xl":18,"xs":18}},[_c('el-input',{attrs:{"placeholder":_vm.language.ipTableKeywordTxt},on:{"change":_vm.findByKeyword},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1),_vm._v(" "),_c('el-col',{attrs:{"lg":6,"md":6,"sm":6,"xl":6,"xs":6}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"disabled":this.allIps.length == 0,"type":"primary"},on:{"click":_vm.export2Excel}},[_vm._v(_vm._s(_vm.reuse.downloadExcelForms))])],1)],1),_vm._v(" "),_c('el-row',[_c('el-table',{attrs:{"data":_vm.ipsData}},[_vm._l((_vm.language.ipTableHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"property":v.key,"label":v.value}})]})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":10,"md":10,"sm":10,"xl":10,"xs":10}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":14,"md":14,"sm":14,"xl":14,"xs":14}},[_c('el-pagination',{attrs:{"current-page":_vm.ipPageNum,"page-size":_vm.ipPageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.ipTotal,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handleIPPageChange,"size-change":_vm.handleIPSizeChange}})],1)],1)],1),_vm._v(" "),_c('el-drawer',{attrs:{"visible":_vm.notify,"direction":"rtl","size":"50%","with-header":false},on:{"update:visible":function($event){_vm.notify=$event}}},[_vm._l((_vm.notifyData),function(arr,k){return [(arr != null)?_c('div',{key:k},[_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":22,"md":22,"sm":22,"xl":22,"xs":22}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v(_vm._s(k))])],1),_vm._v(" "),_c('el-col',{attrs:{"lg":2,"md":2,"sm":2,"xl":2,"xs":2}},[_c('el-button',{attrs:{"type":"text","icon":"el-icon-close","circle":""},on:{"click":function($event){return _vm.clearNotify(k)}}})],1)],1),_vm._v(" "),_c('el-row',[_c('el-table',{attrs:{"data":arr}},[_vm._l((_vm.language.tradesHead),function(v,i){return [(v.key == 'CMD')?_c('el-table-column',{key:i,attrs:{"label":v.value,"width":"80px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.reuse.cmdMapping[scope.row[v.key]]))])]}}],null,true)}):(v.key == 'TIME')?_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? scope.row.OPEN_TIME : scope.row.CLOSE_TIME))])]}}],null,true)}):(v.key == 'PRICE')?_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? scope.row.OPEN_PRICE : scope.row.CLOSE_PRICE))])]}}],null,true)}):(v.key == 'TYPE')?_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? _vm.language.open : _vm.language.close))])]}}],null,true)}):_c('el-table-column',{key:i,attrs:{"property":v.key,"label":v.value,"width":"100px"}})]})],2)],1)],1):_vm._e()]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_position_report_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431b7f31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_position_report_vue__ = __webpack_require__(806);
function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-431b7f31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_position_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431b7f31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_position_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle"},[_c('el-col',{staticClass:"trades",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary","icon":"el-icon-circle-plus"},on:{"click":function($event){_vm.configWindow = true}}},[_vm._v(_vm._s(_vm.language.addBtnTxt))])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.configLoading),expression:"configLoading"}]},[_c('el-table',{attrs:{"data":_vm.confListPaging,"border":""}},[_vm._l((_vm.language.accHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.writable)?_c('el-input',{attrs:{"type":"textarea","maxlength":"255"},model:{value:(scope.row[v.key]),callback:function ($$v) {_vm.$set(scope.row, v.key, $$v)},expression:"scope.row[v.key]"}}):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.language.lastTableColumnTxt,"width":"120px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.deletePositionConfig(scope.row.id)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit","circle":""},on:{"click":function($event){return _vm.updateAccount(scope.row)}}})]}}])})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.addDialogTitle,"visible":_vm.configWindow,"before-close":function (done) {},"show-close":false},on:{"update:visible":function($event){_vm.configWindow=$event}}},[_c('el-form',{ref:"confForm",attrs:{"model":_vm.confForm,"rules":_vm.rules,"label-position":"top"}},[_c('el-form-item',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              "+_vm._s(_vm.language.confValLabelOpt.confType)+"\n              "),_c('el-tooltip',{attrs:{"effect":"light","placement":"bottom-start"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},_vm._l((_vm.language.descContent),function(k,v){return _c('el-row',{key:v},[_vm._v(_vm._s(k))])}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-question"})])],1),_vm._v(" "),_c('el-select',{attrs:{"placeholder":_vm.language.formSelectDefaultTxt},on:{"change":_vm.handleConfKeyChange},model:{value:(_vm.confKey),callback:function ($$v) {_vm.confKey=$$v},expression:"confKey"}},_vm._l((_vm.language.confKeyOpt),function(k,v){return _c('el-option',{key:v,attrs:{"disabled":_vm.disabledKeys.includes(v),"label":k,"value":v}})}),1)],1),_vm._v(" "),(_vm.confKey !== 'specialSecurity')?_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt[_vm.confKey],"prop":_vm.confKey}},[_c('el-input',{model:{value:(_vm.confForm[_vm.confKey]),callback:function ($$v) {_vm.$set(_vm.confForm, _vm.confKey, _vm._n($$v))},expression:"confForm[confKey]"}})],1):_vm._e(),_vm._v(" "),(_vm.confKey === 'manager')?_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt.tittle,"prop":"tittle"}},[_c('el-input',{model:{value:(_vm.confForm.tittle),callback:function ($$v) {_vm.$set(_vm.confForm, "tittle", $$v)},expression:"confForm.tittle"}})],1):_vm._e(),_vm._v(" "),(_vm.confKey === 'security')?[_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt.types,"prop":"types"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","placeholder":_vm.language.formSelectDefaultTxt},model:{value:(_vm.confForm.types),callback:function ($$v) {_vm.$set(_vm.confForm, "types", $$v)},expression:"confForm.types"}},_vm._l((_vm.securityList),function(item){return _c('el-option',{key:item.TYPE,attrs:{"disabled":!_vm.specialSecurityCanSelect.every(function (v) { return v.TYPE !== item.TYPE; }),"label":item.TYPE,"value":item.TYPE}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt.abandonedRange,"prop":"abandonedRange"}},[_c('el-col',{attrs:{"span":11}},[_c('el-slider',{attrs:{"show-input":"","min":-5000,"max":0},model:{value:(_vm.confForm.abandonedMin),callback:function ($$v) {_vm.$set(_vm.confForm, "abandonedMin", $$v)},expression:"confForm.abandonedMin"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_vm._v(" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-slider',{attrs:{"show-input":"","min":0,"max":5000},model:{value:(_vm.confForm.abandonedMax),callback:function ($$v) {_vm.$set(_vm.confForm, "abandonedMax", $$v)},expression:"confForm.abandonedMax"}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.confKey === 'specialSecurity')?[_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt.specialSymbol,"prop":"specialSymbol"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","placeholder":_vm.language.formSelectDefaultTxt},model:{value:(_vm.confForm.specialSymbol),callback:function ($$v) {_vm.$set(_vm.confForm, "specialSymbol", $$v)},expression:"confForm.specialSymbol"}},_vm._l((_vm.symbolList),function(item){return _c('el-option',{key:item.SYMBOL,attrs:{"label":item.SYMBOL,"value":item.SYMBOL}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.confValLabelOpt.specialSecurity,"prop":"specialSecurity"}},[_c('el-select',{attrs:{"filterable":"","placeholder":_vm.language.formSelectDefaultTxt},model:{value:(_vm.confForm.specialSecurity),callback:function ($$v) {_vm.$set(_vm.confForm, "specialSecurity", $$v)},expression:"confForm.specialSecurity"}},_vm._l((_vm.specialSecurityCanSelect),function(item){return _c('el-option',{key:item.TYPE,attrs:{"label":item.TYPE,"value":item.TYPE}})}),1)],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.resetFilledConfig}},[_vm._v(_vm._s(_vm.language.formCancelTxt))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addPositionConfig}},[_vm._v(_vm._s(_vm.language.formConfirmTxt))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_update_leverage_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd2d89fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_update_leverage_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd2d89fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_update_leverage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd2d89fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_update_leverage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle"},[_c('el-col',{staticClass:"addBtn",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary","icon":"el-icon-circle-plus"},on:{"click":_vm.openConfigWindow}},[_vm._v(_vm._s(_vm.language.addBtnTxt))])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.configLoading),expression:"configLoading"}]},[_c('el-table',{attrs:{"data":_vm.confListPaging,"border":""}},[_vm._l((_vm.language.accHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.writable)?_c('el-input',{attrs:{"type":"textarea","maxlength":"255"},model:{value:(scope.row[v.key]),callback:function ($$v) {_vm.$set(scope.row, v.key, $$v)},expression:"scope.row[v.key]"}}):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.language.lastTableColumnTxt,"width":"120px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.group != _vm.rerunKey)?_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.deletePositionConfig(scope.row.group)}}}):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit","circle":""},on:{"click":function($event){return _vm.updateAccount(scope.row)}}})]}}])})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"description"},[_c('el-col',{staticClass:"description"},[_c('el-icon',{staticClass:"el-icon-info"}),_vm._v(_vm._s(_vm.language.descriptionTxt)+"\n      ")],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.addDialogTitle,"visible":_vm.configWindow,"before-close":function (done) {},"show-close":false},on:{"update:visible":function($event){_vm.configWindow=$event}}},[_c('el-form',{ref:"confForm",attrs:{"model":_vm.confForm,"rules":_vm.rules,"label-position":"top"}},[_c('el-form-item',{attrs:{"label":_vm.language.addGroupTxt,"prop":"group"}},[_c('el-select',{attrs:{"disabled":_vm.updateGroup == _vm.rerunKey,"filterable":"","placeholder":_vm.language.formSelectDefaultTxt},model:{value:(_vm.confForm.group),callback:function ($$v) {_vm.$set(_vm.confForm, "group", $$v)},expression:"confForm.group"}},_vm._l((_vm.groupList),function(item){return _c('el-option',{key:item.GROUP,attrs:{"disabled":_vm.disabledGroups.includes(item.GROUP) || item.GROUP == 'manager',"label":item.GROUP,"value":item.GROUP}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addEquityTxt,"prop":"equityValve"}},[_c('el-input',{attrs:{"disabled":_vm.updateGroup == _vm.rerunKey},model:{value:(_vm.confForm.equityValve),callback:function ($$v) {_vm.$set(_vm.confForm, "equityValve", $$v)},expression:"confForm.equityValve"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addLeveragelteTxt,"prop":"leverageLte"}},[_c('el-input',{attrs:{"disabled":_vm.updateGroup == _vm.rerunKey},model:{value:(_vm.confForm.leverageLte),callback:function ($$v) {_vm.$set(_vm.confForm, "leverageLte", _vm._n($$v))},expression:"confForm.leverageLte"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addLeveragegtTxt,"prop":"leverageGt"}},[_c('el-input',{model:{value:(_vm.confForm.leverageGt),callback:function ($$v) {_vm.$set(_vm.confForm, "leverageGt", _vm._n($$v))},expression:"confForm.leverageGt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addEnableTxt,"prop":"enable"}},[_c('el-switch',{attrs:{"active-value":"1","inactive-value":"0","active-text":_vm.language.yesTxt,"inactive-text":_vm.language.noTxt},model:{value:(_vm.confForm.enable),callback:function ($$v) {_vm.$set(_vm.confForm, "enable", $$v)},expression:"confForm.enable"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.resetFilledConfig}},[_vm._v(_vm._s(_vm.language.formCancelTxt))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addLeverageConfig}},[_vm._v(_vm._s(_vm.language.formConfirmTxt))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charge_dividends_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103e1288_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charge_dividends_vue__ = __webpack_require__(812);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-103e1288"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charge_dividends_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103e1288_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charge_dividends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-box"},[_c('div',{staticClass:"panel"},[_c('el-row',{staticClass:"handle"},[_c('el-col',{staticClass:"addBtn",attrs:{"xs":4,"sm":4,"md":4,"lg":4,"xl":4}},[_c('el-button',{staticClass:"handle-row",attrs:{"type":"primary","icon":"el-icon-circle-plus"},on:{"click":_vm.openConfigWindow}},[_vm._v(_vm._s(_vm.language.addBtnTxt))])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.configLoading),expression:"configLoading"}]},[_c('el-table',{attrs:{"data":_vm.confListPaging,"border":""}},[_vm._l((_vm.language.accHead),function(v,i){return [_c('el-table-column',{key:i,attrs:{"label":v.value},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(v.writable)?_c('el-input',{attrs:{"type":"textarea","maxlength":"255"},model:{value:(scope.row[v.key]),callback:function ($$v) {_vm.$set(scope.row, v.key, $$v)},expression:"scope.row[v.key]"}}):_c('span',[_vm._v(_vm._s(scope.row[v.key]))])]}}],null,true)})]}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.language.lastTableColumnTxt,"width":"120px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.deleteChargeDividendsConfig(scope.row.symbol)}}}),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(scope.row.status == 0),expression:"scope.row.status == 0"}],attrs:{"type":"primary","icon":"el-icon-edit","circle":""},on:{"click":function($event){return _vm.updateConfig(scope.row)}}})]}}])})],2)],1),_vm._v(" "),_c('el-row',{staticClass:"handle"},[_c('el-col',{attrs:{"lg":15,"md":15,"sm":15,"xl":15,"xs":15}},[_c('div',{staticClass:"empty"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":9,"md":9,"sm":9,"xl":9,"xs":9}},[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-size":_vm.pageSize,"page-sizes":[5, 10, 25, 50],"pager-count":5,"total":_vm.total,"layout":"total, sizes, prev, pager, next"},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.language.addDialogTitle,"visible":_vm.configWindow,"before-close":function (done) {},"show-close":false},on:{"update:visible":function($event){_vm.configWindow=$event}}},[_c('el-form',{ref:"confForm",attrs:{"model":_vm.confForm,"rules":_vm.rules,"label-position":"top"}},[_c('el-form-item',{attrs:{"label":_vm.language.addSymbolTxt,"prop":"symbol"}},[_c('el-select',{attrs:{"filterable":"","placeholder":_vm.language.formSelectDefaultTxt},model:{value:(_vm.confForm.symbol),callback:function ($$v) {_vm.$set(_vm.confForm, "symbol", $$v)},expression:"confForm.symbol"}},_vm._l((_vm.symbolList),function(item){return _c('el-option',{key:item.SYMBOL,attrs:{"disabled":_vm.disabledSymbols.includes(item.SYMBOL),"label":item.SYMBOL,"value":item.SYMBOL}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addBuyTxt,"prop":"buy"}},[_c('el-input',{model:{value:(_vm.confForm.buy),callback:function ($$v) {_vm.$set(_vm.confForm, "buy", $$v)},expression:"confForm.buy"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addSellTxt,"prop":"sell"}},[_c('el-input',{model:{value:(_vm.confForm.sell),callback:function ($$v) {_vm.$set(_vm.confForm, "sell", $$v)},expression:"confForm.sell"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addGroupTxt,"prop":"group"}},[_c('el-input',{model:{value:(_vm.confForm.group),callback:function ($$v) {_vm.$set(_vm.confForm, "group", $$v)},expression:"confForm.group"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addZipTxt,"prop":"zipcode"}},[_c('el-input',{model:{value:(_vm.confForm.zipcode),callback:function ($$v) {_vm.$set(_vm.confForm, "zipcode", $$v)},expression:"confForm.zipcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addCommentTxt,"prop":"comment"}},[_c('el-input',{model:{value:(_vm.confForm.comment),callback:function ($$v) {_vm.$set(_vm.confForm, "comment", $$v)},expression:"confForm.comment"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.language.addExcuteTimeTxt,"prop":"excuteTime"}},[_c('el-input',{model:{value:(_vm.confForm.excuteTime),callback:function ($$v) {_vm.$set(_vm.confForm, "excuteTime", $$v)},expression:"confForm.excuteTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.resetFilledConfig}},[_vm._v(_vm._s(_vm.language.formCancelTxt))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addChargeDividendsConfig}},[_vm._v(_vm._s(_vm.language.formConfirmTxt))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(111);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        USER: "",
        LANGUAGE: "en",
        PAGEMAXINDEX: 0
    },
    mutations: {
        SAVEUSER: function SAVEUSER(state, user) {
            state.USER = user;
            sessionStorage.user = user;
        },
        SAVELANGUAGE: function SAVELANGUAGE(state, language) {
            state.LANGUAGE = language;
            localStorage.language = language;
        },
        SAVEPAGEMAXINDEX: function SAVEPAGEMAXINDEX(state, pageMaxIndex) {
            state.PAGEMAXINDEX = pageMaxIndex;
            localStorage.pageMaxIndex = pageMaxIndex;
        }
    },
    actions: {
        SAVEUSER: function SAVEUSER(context, user) {
            context.commit('SAVEUSER', user);
        },
        SAVELANGUAGE: function SAVELANGUAGE(context, language) {
            context.commit("SAVELANGUAGE", language);
        },
        SAVEPAGEMAXINDEX: function SAVEPAGEMAXINDEX(state, pageMaxIndex) {
            context.commit('SAVEPAGEMAXINDEX', pageMaxIndex);
        }
    }
}));

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(212);




__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
    if (__WEBPACK_IMPORTED_MODULE_2__main__["default"].$route.meta.showInCrumb) config.headers.token = sessionStorage.getItem('token');
    return config;
});

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (res) {
    if (res.data.data == 'BAD_TOKEN') {
        sessionStorage.removeItem('token');
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/managerAuth', query: { nextUrl: __WEBPACK_IMPORTED_MODULE_2__main__["default"].$route.path } });
    }
    return res;
});

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multilanguage__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multilanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_js__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header_js__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tableModel_js__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auditLog__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reuse__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mainView_js__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__userModel_js__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__roleModel_js__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__changePassword_js__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__checkManager__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__report__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__manager_report__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__record__ = __webpack_require__(935);


















var LanguageArr = [__WEBPACK_IMPORTED_MODULE_4__login_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__header_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__tableModel_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__auditLog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__reuse__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mainView_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__userModel_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__roleModel_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__changePassword_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__checkManager__["a" /* default */]].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__report__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__manager_report__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__record__["a" /* default */]));

var LanguageData = {
    cn: {},
    hk: {},
    en: {}
};

var LanguageKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(LanguageData);

LanguageArr.forEach(function (item, index) {
    // 重新合并对象
    LanguageKeys.forEach(function (lan) {
        var key = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(LanguageArr[index][lan])[0]];
        LanguageData[lan][key] = LanguageArr[index][lan][key];
    });
});

// 检测翻译
var allKey = {};
var detection = function detection(obj, LanguageKey) {
    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
    keys.forEach(function (item) {
        if (Object.prototype.toString.call(obj[item]) == "[object Object]") {
            detection(obj[item], LanguageKey);
        }
        allKey[LanguageKey]++;
    });
};
LanguageKeys.forEach(function (item) {
    allKey[item] = 0;
    detection(LanguageData[item], item);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_multilanguage___default.a, LanguageData);

/***/ }),
/* 898 */,
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        login: {
            priceEngine: '交易报表系统',
            login: "登 录",
            loginTxt: '账户名称',
            passwordTxt: '交易密码',
            language: '请选择语言:',
            tips: {
                loginErr: "账号或密码错误",
                disabledUser: "賬號停用"
            }
        }
    },
    hk: {
        login: {
            priceEngine: '交易報表',
            login: "登 錄",
            loginTxt: '帳戶名稱',
            passwordTxt: '交易密碼',
            language: '請選擇語言:',
            tips: {
                loginErr: "帳號或密碼錯誤",
                disabledUser: "賬號停用"
            }
        }
    },
    en: {
        login: {
            priceEngine: 'Dealing Report Engine',
            login: 'Login',
            loginTxt: 'account name',
            passwordTxt: 'passwordTxt',
            language: 'language:',
            tips: {
                loginErr: "An account or password error",
                disabledUser: "Invalid User"
            }
        }
    }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        header: {
            hello: '你好',
            userName: '欢迎使用交易报表系统',
            language: '简体中文',
            adminSuperuser: {
                text: '管理超级用户',
                list: {
                    logOut: '登出'
                }
            }
        }
    },
    hk: {
        header: {
            hello: '你好',
            userName: '歡迎使用交易報表系統',
            language: '繁體中文',
            adminSuperuser: {
                text: '管理超級用戶',
                list: {
                    logOut: '登出'
                }
            }
        }
    },
    en: {
        header: {
            hello: 'hello',
            userName: 'Welcome to the dealing report engine',
            language: 'English',
            adminSuperuser: {
                text: 'adminSuperuser',
                list: {
                    logOut: 'logOut'
                }
            }
        }
    }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        tableModel: {
            userThead: ['登录账户', '账户名称', '启用', '角色', '最后登录时间', '操作'],
            roleThead: ['角色', '角色名称', '描述', '功能列表', "最后更新时间", "最后更新人", '操作'],
            symbolThead: ['产品', '描述', '启用', '小数位', '更新生效', '最后更新时间', '最后更新人', '操作'],
            userId: '登录账户',
            userName: '账户名称',
            search: "搜索",
            roleId: '角色',
            roleName: '角色名称',
            symbol: '产品',
            btnGroup: {
                refresh: '全部数据',
                addUser: '添加用户',
                addRole: '添加角色',
                deleteUser: '删除用户',
                deleteRole: '删除角色',
                confirmDelete: '确认删除',
                addSymbol: '添加产品',
                deleteSymbol: '删除产品'
            },
            showclausesnum: '显示条目数：',
            clausesamount: '条目总数：',
            present: "当前：",
            noData: '没有数据',
            confirmDeleteTips: '确认删除这些数据吗？',
            enable: {
                true: '是',
                false: '否'
            },
            readOnly: '只读'
        }
    },
    hk: {
        tableModel: {
            userThead: ['登錄賬戶', '賬戶名稱', '啟用', '角色', '最后登錄時間', '操作'],
            roleThead: ['角色', '角色名稱', '描述', '功能列表', "最后更新時間", "最后更新人", '操作'],
            symbolThead: ['產品', '描述', '啟用', '小數位', '更新生效', '最后更新時間', '最后更新人', '操作'],
            userId: '登錄賬戶',
            userName: '賬戶名稱',
            search: "搜索",
            roleId: '角色',
            roleName: '角色名稱',
            symbol: '產品',
            btnGroup: {
                refresh: '全部數據',
                addUser: '添加用戶',
                addRole: '添加角色',
                deleteUser: '刪除用戶',
                deleteRole: '刪除角色',
                confirmDelete: '確認刪除',
                addSymbol: '添加產品',
                deleteSymbol: '刪除產品'
            },
            showclausesnum: '顯示條目數：',
            clausesamount: '條目總數：',
            present: "當前：",
            noData: '沒有數據',
            confirmDeleteTips: '確認刪除這些數據嗎？',
            enable: {
                true: '是',
                false: '否'
            },
            readOnly: '只讀'
        }
    },
    en: {
        tableModel: {
            userThead: ['Login', 'Login Name', 'Enabled', 'Roles', 'Last Login Time', 'Opertion'],
            roleThead: ['Role', 'Role Name', 'Description', 'Functions', "Last Update", "Update By", 'Opertion'],
            symbolThead: ['Symbol', 'Description', 'Enabled', 'Digits', 'Changed', 'Last Update', 'Update By', 'Opertion'],
            userId: 'Login ID',
            userName: 'Login Name',
            roleId: 'Role',
            roleName: 'Role Name',
            search: "Search",
            symbol: 'Symbol',
            btnGroup: {
                refresh: 'Refresh',
                addUser: 'Add User',
                addRole: 'Add Role',
                deleteUser: 'Delete User',
                deleteRole: 'Delete Role',
                confirmDelete: 'Confirm Delete',
                addSymbol: 'Add Symbol',
                deleteSymbol: 'Delete Symbol'
            },
            showclausesnum: 'Display item number:',
            clausesamount: 'param int count:',
            present: "present:",
            noData: 'No Data',
            confirmDeleteTips: 'Are you sure to delete this data?',
            enable: {
                true: 'Yes',
                false: 'No'
            },
            readOnly: 'Read Only'
        }
    }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        auditLog: {
            logDate: '记录时间：',
            typeText: '类别：',
            description: '描述：',
            modifiedID: '账号：',
            selectTimeText: '请选择日期',
            inputDefault: '请输入内容',
            searchText: '搜索',
            to: '至',
            startTime: '开始时间',
            endTime: '结束时间',
            lastWeek: '最近一周',
            lastMonth: '最近一个月',
            lastThreeMonths: '最近三个月',
            notNumber: '账号请输入数字',
            tableHead: [{ key: 'type', value: '类别' }, { key: 'MODIFIED_ID', value: '账号' }, { key: 'DESCRIPTION', value: '描述' }, { key: 'OLD_VALUE', value: '修改前的值' }, { key: 'NEW_VALUE', value: '修改后的值' }, { key: 'LOG_BY', value: '修改人' }, { key: 'LOG_DATE', value: '记录时间' }],
            typeMaps: { "-1": "所有", "0": "增加", "1": "修改", "2": "刪除" }
        }
    },
    hk: {
        auditLog: {
            logDate: '記錄時間：',
            typeText: '類別：',
            description: '描述：',
            modifiedID: '賬號：',
            selectTimeText: '請選擇日期',
            inputDefault: '請輸入內容',
            searchText: '搜索',
            to: '至',
            startTime: '開始時間',
            endTime: '結束時間',
            lastWeek: '最近一周',
            lastMonth: '最近一個月',
            lastThreeMonths: '最近三個月',
            notNumber: '賬號請輸入數字',
            tableHead: [{ key: 'type', value: '類別' }, { key: 'MODIFIED_ID', value: '賬號' }, { key: 'DESCRIPTION', value: '描述' }, { key: 'OLD_VALUE', value: '修改前的值' }, { key: 'NEW_VALUE', value: '修改後的值' }, { key: 'LOG_BY', value: '修改人' }, { key: 'LOG_DATE', value: '記錄時間' }],
            typeMaps: { "-1": "所有", "0": "增加", "1": "修改", "2": "刪除" }
        }
    },
    en: {
        auditLog: {
            logDate: 'Log Date：',
            typeText: 'Type：',
            description: 'Description：',
            modifiedID: 'Modified ID：',
            selectTimeText: 'Pleaese Select Date',
            inputDefault: 'Pleaese Input Text',
            searchText: 'Search',
            to: 'to',
            startTime: 'Start Time',
            endTime: 'End Time',
            lastWeek: 'Last Week',
            lastMonth: 'Last Month',
            lastThreeMonths: 'Last Three Months',
            notNumber: 'Modified ID Must Be Number',
            tableHead: [{ key: 'type', value: 'Type' }, { key: 'MODIFIED_ID', value: 'Modified ID' }, { key: 'DESCRIPTION', value: 'Description' }, { key: 'OLD_VALUE', value: 'Old Value' }, { key: 'NEW_VALUE', value: 'New Value' }, { key: 'LOG_BY', value: 'Log By' }, { key: 'LOG_DATE', value: 'Log Date' }],
            typeMaps: { "-1": "All", "0": "Add", "1": "Update", "2": "Delete" }
        }
    }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        reuse: {
            showTotal: '显示条目总数:',
            total: '条目总数:',
            current: '当前:',
            noData: '没有数据',
            downloadExcelForms: '下载 Excel',
            selectTimeText: '请选择日期',
            pleaseInputNumber: '请输入数字',
            moreSelect: '显示更多筛选',
            searchText: '搜 索',
            refresh: '刷 新',
            upload: '上传 Html',
            typeMaps: { "0": "今日", "1": "今周", "2": "今月", "3": "自定义" },
            serverError: '服务器响应失败',
            invalidParam: '无效的参数',
            startTime: '开始时间',
            endTime: '结束时间',
            loginText: '账号：',
            groupText: '组别：',
            ibNumText: '代理账号：',
            officeText: '办事处号码：',
            regionText: '地区编号：',
            nameFilterText: '名字过滤：',
            loginFilterText: '账号过滤：',
            cmdMapping: { 0: '买入', 1: '卖出' },
            selectAll: { key: "selectAll", label: "全选" },
            rememberMyChoice: { key: "rememberMyChoice", label: "记住我的选择" },
            showMoreColumns: "显示更多列"
        }
    },
    hk: {
        reuse: {
            showTotal: '顯示條目總數:',
            total: '條目總數:',
            current: '當前:',
            noData: '沒有數據',
            downloadExcelForms: '下載 Excel',
            selectTimeText: '請選擇日期',
            pleaseInputNumber: '請輸入數字',
            moreSelect: '顯示更多篩選',
            searchText: '搜 索',
            refresh: '刷 新',
            upload: '上傳 Html',
            typeMaps: { "0": "今日", "1": "今周", "2": "今月", "3": "自定義" },
            serverError: '服務器響應失敗',
            invalidParam: '無效的參數',
            startTime: '開始時間',
            endTime: '結束時間',
            loginText: '賬號：',
            groupText: '組別：',
            ibNumText: '代理賬號：',
            officeText: '辦事處號碼：',
            regionText: '地區編號：',
            nameFilterText: '名字過濾：',
            loginFilterText: '賬號過濾：',
            cmdMapping: { 0: '買入', 1: '賣出' },
            selectAll: { key: "selectAll", label: "全選" },
            rememberMyChoice: { key: "rememberMyChoice", label: "記住我的選擇" },
            showMoreColumns: "顯示更多列"
        }
    },
    en: {
        reuse: {
            showTotal: 'Display Record Count:',
            total: 'Record Total Count:',
            current: 'Current:',
            noData: 'No data',
            downloadExcelForms: 'Download Excel',
            selectTimeText: 'Please Select Date',
            pleaseInputNumber: 'Please Input Number',
            moreSelect: 'Show More',
            searchText: 'Search',
            refresh: 'Refresh',
            upload: 'Upload Html',
            typeMaps: { "0": "Today", "1": "This Week", "2": "This Month", "3": "Custom" },
            serverError: 'Server Response Failed',
            invalidParam: 'Invalid Parameter',
            startTime: 'Start Time',
            endTime: 'End Time',
            loginText: 'Login：',
            groupText: 'Group：',
            ibNumText: 'IB Account：',
            officeText: 'Office ID：',
            regionText: 'Region ID：',
            nameFilterText: 'Name Filter：',
            loginFilterText: 'Login Filter：',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            selectAll: { key: "selectAll", label: "Select All" },
            rememberMyChoice: { key: "rememberMyChoice", label: "Remember My Choice" },
            showMoreColumns: "Visible Columns"
        }
    }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mainView: {
            sidebarList: {
                userMaintenance: '用户管理',
                roleMaintenance: '角色管理',
                changePassword: '修改密码',
                symbol: '产品列表',
                logout: "登出",
                auditLog: '审核记录',
                dayTradeReport: '短线平仓及盈利单报告',
                positionReport: '未平仓报表',
                bBookReport: 'B-Book 报表',
                clientReport: '客户报表',
                closedTradesReport: '交易价值报表',
                mt4ClosedTradesReport: 'MT4已平仓报表 (Dealing)',
                mt4DepositWithdrawlReport: 'MT4出入金报表 (Dealing)',
                mt4CreditReport: 'MT4信用额报表 (Dealing)',
                mt4SummaryReport: 'MT4总结报表 (Dealing)',
                mt4SeregatedReport: 'MT4实时盈亏报表 (Dealing)',
                mt4EquityReport: 'MT4净值报表 (Dealing)',
                mt4EquityMultiReport: 'MT4净值报表(Dealing)(Multi)',
                mt4ProfitLossReport: 'MT4盈亏报表 (Dealing)',
                mt4AccountReport: 'MT4账号报表 (Dealing)',
                accountAnalyze: '账户分析报表',
                symbolProfit: '产品盈亏报表',
                downloadReport: '下载报表',
                monitorAccounts: '监察客户名单',
                floatingPL: '客户浮动盈亏统计',
                openTradeStat: '未平仓交易统计',
                managerOperateRecord: 'MT4经理操作记录',
                loginRecord: 'MT4登录记录',
                profitTopList: '盈利Top榜',
                autoPositionReportConfig: '自动报仓配置',
                autoUpdateLeverage: '自动更新杠杆配置',
                chargeDividends: '利息自动计算配置'
            },
            currentManLogin: '当前经理账号：',
            exit: '退出'
        }
    },
    hk: {
        mainView: {
            sidebarList: {
                userMaintenance: '用戶管理',
                roleMaintenance: '角色管理',
                changePassword: '修改密碼',
                symbol: '產品列表',
                logout: "登出",
                auditLog: '審核記錄',
                dayTradeReport: '短線平倉及盈利單報告',
                positionReport: '未平倉報表',
                bBookReport: 'B-Book 報表',
                clientReport: '客戶報表',
                closedTradesReport: '交易價值報表',
                mt4ClosedTradesReport: 'MT4已平倉報表 (Dealing)',
                mt4DepositWithdrawlReport: 'MT4出入金報表 (Dealing)',
                mt4CreditReport: 'MT4信用額報表 (Dealing)',
                mt4SummaryReport: 'MT4總結报表 (Dealing)',
                mt4SeregatedReport: 'MT4實時盈虧報表 (Dealing)',
                mt4EquityReport: 'MT4淨值報表 (Dealing)',
                mt4EquityMultiReport: 'MT4淨值報表(Dealing)(Multi)',
                mt4ProfitLossReport: 'MT4盈虧報表 (Dealing)',
                mt4AccountReport: 'MT4賬號報表 (Dealing)',
                accountAnalyze: '賬戶分析報表',
                symbolProfit: '產品盈虧報表',
                downloadReport: '下載報表',
                monitorAccounts: '監察客戶名單',
                floatingPL: '客戶浮動盈虧統計',
                openTradeStat: '未平倉交易統計',
                managerOperateRecord: 'MT4經理操作記錄',
                loginRecord: 'MT4登錄記錄',
                profitTopList: '盈利Top榜',
                autoPositionReportConfig: '自動報倉配置',
                autoUpdateLeverage: '自動更新槓桿配置',
                chargeDividends: '利息自動計算配置'
            },
            currentManLogin: '當前經理賬號：',
            exit: '退出'
        }
    },
    en: {
        mainView: {
            sidebarList: {
                userMaintenance: 'User Maintenance',
                roleMaintenance: 'Role Maintenance',
                changePassword: 'Change Password',
                symbol: 'Symbol List',
                logout: "Logout",
                auditLog: 'Audit Log',
                dayTradeReport: 'Day Trade Report',
                positionReport: 'Open Deal Report',
                bBookReport: 'B-Book Report',
                clientReport: 'Client Report',
                closedTradesReport: 'Trade Value Report',
                mt4ClosedTradesReport: 'MT4 Closed Trades Report (Dealing)',
                mt4DepositWithdrawlReport: 'MT4 Deposit And Withdrawl Report (Dealing)',
                mt4CreditReport: 'MT4 Credit Report (Dealing)',
                mt4SummaryReport: 'MT4 Summary Report (Dealing)',
                mt4SeregatedReport: 'MT4 Segregated Report (Dealing)',
                mt4EquityReport: 'MT4 Equity Report (Dealing)',
                mt4EquityMultiReport: 'MT4 Equity Report (Dealing)(Multi)',
                mt4ProfitLossReport: 'MT4 Profit And Loss Report (Dealing)',
                mt4AccountReport: 'MT4 Account Report (Dealing)',
                accountAnalyze: 'Account Analyze Report',
                symbolProfit: 'Symbol Profit Report',
                downloadReport: 'Download Report',
                monitorAccounts: 'Monitor Accounts',
                floatingPL: 'Client Floating PL Statistics',
                openTradeStat: 'Open Trades Statistics',
                managerOperateRecord: 'MT4 Manager Operate Record',
                loginRecord: 'MT4 Login Record',
                profitTopList: 'Profit Top List',
                autoPositionReportConfig: 'Auto Position Report Configuration',
                autoUpdateLeverage: 'Auto Update Leverage Configuration',
                chargeDividends: 'Charge Dividends Configration'
            },
            currentManLogin: 'Current Manager：',
            exit: 'Exit'
        }
    }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cn: {
    userModel: {
      userInfo: '用户信息',
      loginId: '登录账号',
      loginName: '用户名称',
      userPwd: '用户密码',
      isEnable: '是否启用',
      yes: '是',
      no: '否',
      setRole: '设置角色',
      existingRoleList: '已有角色列表',
      selectedRoleList: '已选中的角色列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '请输入',
      pleaseSelect: '请选择',
      noEdit: '尚未修改，无须保存',
      errTips: '请正确填写信息',
      btnBack: '返回'
    }
  },
  hk: {
    userModel: {
      userInfo: '用戶信息',
      loginId: '登錄賬號',
      loginName: '用戶名稱',
      userPwd: '用戶密碼',
      isEnable: '是否啟用',
      yes: '是',
      no: '否',
      setRole: '設置角色',
      existingRoleList: '已有角色列表',
      selectedRoleList: '已選中的角色列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '請輸入',
      pleaseSelect: '請選擇',
      noEdit: '尚未修改，無須保存',
      errTips: '請正確填寫信息',
      btnBack: '返回'
    }
  },
  en: {
    userModel: {
      userInfo: 'User Info',
      loginId: 'Login ID',
      loginName: 'User Name',
      userPwd: 'Password',
      isEnable: 'Enabled',
      yes: 'Yes',
      no: 'No',
      setRole: 'Set Role',
      existingRoleList: 'Existing Role List',
      selectedRoleList: 'Selected Role List',
      saveBtn: 'SAVE',
      success: 'Successful',
      pleaseEnter: 'Please Enter',
      pleaseSelect: 'Please Select',
      noEdit: 'Not yet modified, no need to save',
      errTips: 'Please fill in the information correctly',
      btnBack: 'Back'
    }
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cn: {
    roleModel: {
      roleInfo: '角色信息',
      role: '角色',
      roleName: '角色名称',
      description: '描述',
      setFunc: '设置功能',
      setReadOnly: '设置只读',
      existingFuncList: '已有功能列表',
      selectedFuncList: '已选中的功能列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '请输入',
      pleaseSelect: '请选择',
      noEdit: '尚未修改，无须保存',
      errTips: '请正确填写信息',
      btnBack: '返回'
    }
  },
  hk: {
    roleModel: {
      roleInfo: '角色信息',
      role: '角色',
      roleName: '角色名稱',
      description: '描述',
      setFunc: '設置功能',
      setReadOnly: '設置只讀',
      existingFuncList: '已有功能列表',
      selectedFuncList: '已選中的功能列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '請輸入',
      pleaseSelect: '請選擇',
      noEdit: '尚未修改，無須保存',
      errTips: '請正確填寫信息',
      btnBack: '返回'
    }
  },
  en: {
    roleModel: {
      roleInfo: 'Role Info',
      role: 'Role',
      roleName: 'Role Name',
      description: 'Description',
      setFunc: 'Set Function',
      setReadOnly: 'Set Read Only',
      existingFuncList: 'Existing Function List',
      selectedFuncList: 'Selected Function List',
      saveBtn: 'SAVE',
      success: 'Successful',
      pleaseEnter: 'Please Enter',
      pleaseSelect: 'Please Select',
      noEdit: 'Not yet modified, no need to save',
      errTips: 'Please fill in the information correctly',
      btnBack: 'Back'
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cn: {
    changePassword: {
      loginId: '登录账号',
      oldPwd: '旧密码',
      newPwd: '新密码',
      confirmPwd: '确认密码',
      saveBtn: '保存',
      errTips: {
        newPwd: '请输入新密码',
        confirmPwd: '两次输入不一致'
      },
      success: '保存成功'
    }
  },
  hk: {
    changePassword: {
      loginId: '登錄賬號',
      oldPwd: '舊密碼',
      newPwd: '新密碼',
      confirmPwd: '確認密碼',
      saveBtn: '保存',
      errTips: {
        newPwd: '請輸入新密碼',
        confirmPwd: '兩次輸入不一致'
      },
      success: '保存成功'
    }
  },
  en: {
    changePassword: {
      loginId: 'Login ID',
      oldPwd: 'Old Password',
      newPwd: 'New Password',
      confirmPwd: 'Confirm Password',
      saveBtn: 'SAVE',
      errTips: {
        newPwd: 'Please enter new password',
        confirmPwd: "The two inputs don't agree"
      },
      success: 'successfully'
    }
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        checkManager: {
            login: 'MT4经理账号',
            password: 'MT4经理密码',
            confirm: '验证',
            success: '保存成功'
        }
    },
    hk: {
        checkManager: {
            login: 'MT4經理賬號',
            password: 'MT4經理密碼',
            confirm: '驗證',
            success: '保存成功'
        }
    },
    en: {
        checkManager: {
            login: 'MT4 Login',
            password: 'MT4 Password',
            confirm: 'Confirm',
            success: 'successfully'
        }
    }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dayTradeReport__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positionReport__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bBookReport__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clientReport__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__monitorAccountsReport__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__autoPositionReport__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__autoUpdateLeverage__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chargeDividends__ = __webpack_require__(917);









var reportLanguages = [__WEBPACK_IMPORTED_MODULE_0__dayTradeReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__positionReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__bBookReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__clientReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__monitorAccountsReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__autoPositionReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__autoUpdateLeverage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__chargeDividends__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (reportLanguages);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        dayTradeReport: {
            CloseDateText: '平仓日期：',
            pointText: '点值：',
            ownTimeText: '持仓时间(分钟)：',
            profitText: '盈利额(以上)：',
            downloadName: '短线平仓及盈利单报告',
            loginText: '账号：',
            ibNumText: '代理账号：',
            symbolText: '产品：',
            regionText: '地区编号：',
            securityText: '产品组：',
            to: '至',
            startTime: '开始时间',
            endTime: '结束时间',
            tableHead: [{ key: 'Ticket', value: '单号', upper: false }, { key: 'Login', value: '账号', upper: false }, { key: 'NAME', value: '客户', upper: false }, { key: 'C_GROUP', value: '组别', upper: false }, { key: 'CURRENCY', value: '入金货币', upper: false }, { key: 'AGENT_ACCOUNT', value: '代理账号' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '办事处号码' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'RID', value: '地区编号' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'Symbol', value: '产品', upper: false }, { key: 'TYPE', value: '产品组' }, { key: 'Volume', value: '手数', upper: false }, { key: 'Cmd', value: '买/卖', upper: false }, { key: 'Open_Date', value: '开仓日期', upper: false }, { key: 'Open_Time', value: '开仓时间', upper: false }, { key: 'Open_Price', value: '开仓价', upper: false }, { key: 'Close_Date', value: '平仓日期', upper: false }, { key: 'Close_Time', value: '平仓时间', upper: false }, { key: 'Close_Price', value: '平仓价', upper: false }, { key: 'Commission', value: '客户佣金', upper: false }, { key: 'Swaps', value: '利息', upper: false }, { key: 'Profit', value: '平仓盈亏', upper: false }, { key: 'Minutes', value: '持仓时间(分)', upper: false }, { key: 'PointVal', value: '点值', upper: false }, { key: 'TOTAL_PL_MONTHLY', value: '今月平仓盈亏' }, { key: 'TOTAL_CLOSE_PL', value: '开户至今平仓盈亏' }, { key: 'TOTAL_FLOATING_PL', value: '开户至今未平仓盈亏' }, { key: 'TOTAL_PL', value: '开户至今盈亏' }]
        }
    },
    hk: {
        dayTradeReport: {
            CloseDateText: '平倉日期：',
            pointText: '點值：',
            ownTimeText: '持倉時間(分鐘)：',
            profitText: '盈利額(以上)：',
            downloadName: '短線平倉及盈利單報告',
            loginText: '賬號：',
            ibNumText: '代理賬號：',
            symbolText: '產品：',
            regionText: '地區編號：',
            securityText: '產品組：',
            to: '至',
            startTime: '開始時間',
            endTime: '結束時間',
            tableHead: [{ key: 'Ticket', value: '單號', upper: false }, { key: 'Login', value: '賬號', upper: false }, { key: 'NAME', value: '客戶', upper: false }, { key: 'C_GROUP', value: '組別', upper: false }, { key: 'CURRENCY', value: '入金貨幣', upper: false }, { key: 'AGENT_ACCOUNT', value: '代理張號' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '辦事處號碼' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'RID', value: '地區編號' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'Symbol', value: '產品', upper: false }, { key: 'TYPE', value: '產品組' }, { key: 'Volume', value: '手數', upper: false }, { key: 'Cmd', value: '買/賣', upper: false }, { key: 'Open_Date', value: '開倉日期', upper: false }, { key: 'Open_Time', value: '開倉時間', upper: false }, { key: 'Open_Price', value: '開倉價', upper: false }, { key: 'Close_Date', value: '平倉日期', upper: false }, { key: 'Close_Time', value: '平倉時間', upper: false }, { key: 'Close_Price', value: '平倉價', upper: false }, { key: 'Commission', value: '客戶佣金', upper: false }, { key: 'Swaps', value: '利息', upper: false }, { key: 'Profit', value: '平倉盈虧', upper: false }, { key: 'Minutes', value: '持倉時間(分)', upper: false }, { key: 'PointVal', value: '點值', upper: false }, { key: 'TOTAL_PL_MONTHLY', value: '今月平倉盈虧' }, { key: 'TOTAL_CLOSE_PL', value: '開戶至今平倉盈虧' }, { key: 'TOTAL_FLOATING_PL', value: '開戶至今未平倉盈虧' }, { key: 'TOTAL_PL', value: '開戶至今盈虧' }]
        }
    },
    en: {
        dayTradeReport: {
            CloseDateText: 'Close Date：',
            pointText: 'Point Value(Above)：',
            ownTimeText: 'Hold Time(Minutes)：',
            profitText: 'Profit：',
            downloadName: 'Short Term Close Position And Profit Gain Report',
            loginText: 'login：',
            ibNumText: 'IB Account：',
            symbolText: 'Symbol：',
            regionText: 'Region ID：',
            securityText: 'Securities：',
            to: 'to',
            startTime: 'Start Time',
            endTime: 'End Time',
            tableHead: [{ key: 'Ticket', value: 'Ticket', upper: false }, { key: 'Login', value: 'Login', upper: false }, { key: 'NAME', value: 'Client Name', upper: false }, { key: 'C_GROUP', value: 'Group', upper: false }, { key: 'CURRENCY', value: 'Currency', upper: false }, { key: 'AGENT_ACCOUNT', value: 'IB Account' },
            // { key: 'IB_NAME', value: 'IB Name' },
            { key: 'OID', value: 'Office ID' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'RID', value: 'Region ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'Symbol', value: 'Symbol', upper: false }, { key: 'TYPE', value: 'Security' }, { key: 'Volume', value: 'Volume', upper: false }, { key: 'Cmd', value: 'Buy/Sell', upper: false }, { key: 'Open_Date', value: 'Open Date', upper: false }, { key: 'Open_Time', value: 'Open Time', upper: false }, { key: 'Open_Price', value: 'Open Price', upper: false }, { key: 'Close_Date', value: 'Close Date', upper: false }, { key: 'Close_Time', value: 'Close Time', upper: false }, { key: 'Close_Price', value: 'Close Price', upper: false }, { key: 'Commission', value: 'Commission', upper: false }, { key: 'Swaps', value: 'Swaps', upper: false }, { key: 'Profit', value: 'Profit', upper: false }, { key: 'Minutes', value: 'Hold Time(Minutes)', upper: false }, { key: 'PointVal', value: 'Point Value', upper: false }, { key: 'TOTAL_PL_MONTHLY', value: 'Total PL Monthly' }, { key: 'TOTAL_CLOSE_PL', value: 'Total Close PL' }, { key: 'TOTAL_FLOATING_PL', value: 'Total Floating PL' }, { key: 'TOTAL_PL', value: 'Total PL' }]
        }
    }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        positionReport: {
            OpenDateText: '开仓时间：',
            volumeText: '手数：',
            symbolText: '产品：',
            loginText: '账号：',
            ibNumText: '代理账号：',
            regionText: '地区编号：',
            securityText: '产品组：',
            to: '至',
            startTime: '开始时间',
            endTime: '结束时间',
            downloadName: '未平仓报表',
            plusNumber: '手数须为正数',
            rightRange: '请输入正确的手数范围(X 至 Y, Y 须大于 X)',
            tableHead: [{ key: 'Ticket', value: '单号', upper: false }, { key: 'Login', value: '账号', upper: false }, { key: 'NAME', value: '客户', upper: false }, { key: 'CURRENCY', value: '入金货币', upper: false }, { key: 'AGENT_ACCOUNT', value: '代理账号' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '办事处号码' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'RID', value: '地区编号' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'Symbol', value: '产品', upper: false }, { key: 'TYPE', value: '产品组' }, { key: 'Volume', value: '手数', upper: false }, { key: 'Cmd', value: '买/卖', upper: false }, { key: 'Open_Date', value: '开仓日期', upper: false }, { key: 'Open_Time', value: '开仓时间', upper: false }, { key: 'Open_Price', value: '开仓价', upper: false }, { key: 'Close_Price', value: '市场价', upper: false }, { key: 'Commission', value: '客户佣金', upper: false }, { key: 'Swaps', value: '利息', upper: false }, { key: 'Profit', value: '盈亏', upper: false }, { key: 'TOTAL_CLOSE_PL', value: '开户至今平仓盈亏' }, { key: 'TOTAL_FLOATING_PL', value: '开户至今未平仓盈亏' }, { key: 'TOTAL_PL', value: '开户至今盈亏' }]
        }
    },
    hk: {
        positionReport: {
            OpenDateText: '開倉時間：',
            volumeText: '手數：',
            symbolText: '產品：',
            loginText: '賬號：',
            ibNumText: '代理賬號：',
            regionText: '地區編號：',
            securityText: '產品組：',
            to: '至',
            startTime: '開始時間',
            endTime: '結束時間',
            downloadName: '未平倉報表',
            plusNumber: '手數須為正數',
            rightRange: '請輸入正確的手數範圍(X 至 Y, Y 須大於 X)',
            tableHead: [{ key: 'Ticket', value: '單號', upper: false }, { key: 'Login', value: '賬號', upper: false }, { key: 'NAME', value: '客戶', upper: false }, { key: 'CURRENCY', value: '入金貨幣', upper: false }, { key: 'AGENT_ACCOUNT', value: '代理張號' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '辦事處號碼' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'RID', value: '地區編號' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'Symbol', value: '產品', upper: false }, { key: 'TYPE', value: '產品組' }, { key: 'Volume', value: '手數', upper: false }, { key: 'Cmd', value: '買/賣', upper: false }, { key: 'Open_Date', value: '開倉日期', upper: false }, { key: 'Open_Time', value: '開倉時間', upper: false }, { key: 'Open_Price', value: '開倉價', upper: false }, { key: 'Close_Price', value: '市場價', upper: false }, { key: 'Commission', value: '客戶佣金', upper: false }, { key: 'Swaps', value: '利息', upper: false }, { key: 'Profit', value: '盈虧', upper: false }, { key: 'TOTAL_CLOSE_PL', value: '開戶至今平倉盈虧' }, { key: 'TOTAL_FLOATING_PL', value: '開戶至今未平倉盈虧' }, { key: 'TOTAL_PL', value: '開戶至今盈虧' }]
        }
    },
    en: {
        positionReport: {
            OpenDateText: 'Open Time：',
            volumeText: 'Volume：',
            symbolText: 'Symbol：',
            loginText: 'Login：',
            ibNumText: 'IB Account：',
            regionText: 'Region ID：',
            securityText: 'Securities：',
            to: 'to',
            startTime: 'Start Time',
            endTime: 'End Time',
            downloadName: 'Open-Deal-Report',
            plusNumber: 'Volume Must Be Positive Number',
            rightRange: 'Please Enter The Correct Volume Range(X to Y, Y Must More Than X)',
            tableHead: [{ key: 'Ticket', value: 'Ticket', upper: false }, { key: 'Login', value: 'Login', upper: false }, { key: 'NAME', value: 'Client Name', upper: false }, { key: 'CURRENCY', value: 'Currency', upper: false }, { key: 'AGENT_ACCOUNT', value: 'IB Account' },
            // { key: 'IB_NAME', value: 'IB Name' },
            { key: 'OID', value: 'Office ID' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'RID', value: 'Region ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'Symbol', value: 'Symbol', upper: false }, { key: 'TYPE', value: 'Security' }, { key: 'Volume', value: 'Volume', upper: false }, { key: 'Cmd', value: 'Buy/Sell', upper: false }, { key: 'Open_Date', value: 'Open Date', upper: false }, { key: 'Open_Time', value: 'Open Time', upper: false }, { key: 'Open_Price', value: 'Open Price', upper: false }, { key: 'Close_Price', value: 'Market Price', upper: false }, { key: 'Commission', value: 'Commission', upper: false }, { key: 'Swaps', value: 'Swaps', upper: false }, { key: 'Profit', value: 'Profit', upper: false }, { key: 'TOTAL_CLOSE_PL', value: 'Total Close PL' }, { key: 'TOTAL_FLOATING_PL', value: 'Total Floating PL' }, { key: 'TOTAL_PL', value: 'Total PL' }]
        }
    }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        bBookReport: {
            bGroup: 'B-Book 组别：',
            aAccount: 'A-Book 账号：',
            tip: 'A-Book 账号不能为空',
            downloadName: 'B-Book报表',
            sum: { TOTAL: '合计', part: 'part', index: 1 },
            tableHead: [{ key: 'SYMBOL', value: '产品' }, { key: 'B_DEALS', value: 'B-Bk 交易量' }, { key: 'B_BUY_VOLUME', value: 'B-Bk 买手数' }, { key: 'B_BUY_PRICE', value: 'B-Bk 买价' }, { key: 'B_SELL_VOLUME', value: 'B-Bk 卖手数' }, { key: 'B_SELL_PRICE', value: 'B-Bk 卖价' }, { key: 'B_NET_VOLUME', value: 'B-Bk 手数差' }, { key: 'B_PROFIT', value: 'B-Bk 利润(美元)' }, { key: 'A_DEALS', value: 'A-Bk 交易量' }, { key: 'A_BUY_VOLUME', value: 'A-Bk 买手数' }, { key: 'A_BUY_PRICE', value: 'A-Bk 买价' }, { key: 'A_SELL_VOLUME', value: 'A-Bk 卖手数' }, { key: 'A_SELL_PRICE', value: 'A-Bk 卖价' }, { key: 'A_NET_VOLUME', value: 'A-Bk 手数差' }, { key: 'A_PROFIT', value: 'A-Bk 利润(美元)' }, { key: 'NET_BUY_VOLUME', value: 'Net 买手数' }, { key: 'NET_BUY_PRICE', value: 'Net 买价' }, { key: 'NET_SELL_VOLUME', value: 'Net 卖手数' }, { key: 'NET_SELL_PRICE', value: 'Net 卖价' }, { key: 'NET_PROFIT', value: 'Net 利润(美元)' }]
        }
    },
    hk: {
        bBookReport: {
            bGroup: 'B-Book 組別：',
            aAccount: 'A-Book 賬號：',
            tip: 'A-Book 賬號不能為空',
            downloadName: 'B-Book報表',
            sum: { TOTAL: '合計', part: 'part', index: 1 },
            tableHead: [{ key: 'SYMBOL', value: '產品' }, { key: 'B_DEALS', value: 'B-Bk 交易量' }, { key: 'B_BUY_VOLUME', value: 'B-Bk 買手數' }, { key: 'B_BUY_PRICE', value: 'B-Bk 買價' }, { key: 'B_SELL_VOLUME', value: 'B-Bk 賣手數' }, { key: 'B_SELL_PRICE', value: 'B-Bk 賣價' }, { key: 'B_NET_VOLUME', value: 'B-Bk 手數差' }, { key: 'B_PROFIT', value: 'B-Bk 利潤(美元)' }, { key: 'A_DEALS', value: 'A-Bk 交易量' }, { key: 'A_BUY_VOLUME', value: 'A-Bk 買手數' }, { key: 'A_BUY_PRICE', value: 'A-Bk 買價' }, { key: 'A_SELL_VOLUME', value: 'A-Bk 賣手數' }, { key: 'A_SELL_PRICE', value: 'A-Bk 賣價' }, { key: 'A_NET_VOLUME', value: 'A-Bk 手数差' }, { key: 'A_PROFIT', value: 'A-Bk 利潤(美元)' }, { key: 'NET_BUY_VOLUME', value: 'Net 買手數' }, { key: 'NET_BUY_PRICE', value: 'Net 買價' }, { key: 'NET_SELL_VOLUME', value: 'Net 賣手數' }, { key: 'NET_SELL_PRICE', value: 'Net 賣價' }, { key: 'NET_PROFIT', value: 'Net 利潤(美元)' }]
        }
    },
    en: {
        bBookReport: {
            bGroup: 'B-Book Group：',
            aAccount: 'A-Book Account：',
            tip: 'A-Book Account Can\'t be empty',
            downloadName: 'B-Book-Report',
            sum: { TOTAL: 'Summary', part: 'part', index: 1 },
            tableHead: [{ key: 'SYMBOL', value: 'Products' }, { key: 'B_DEALS', value: 'B-Bk Deals' }, { key: 'B_BUY_VOLUME', value: 'B-Bk Buy Volume' }, { key: 'B_BUY_PRICE', value: 'B-Bk Buy Price' }, { key: 'B_SELL_VOLUME', value: 'B-Bk Sell Volume' }, { key: 'B_SELL_PRICE', value: 'B-Bk Sell Price' }, { key: 'B_NET_VOLUME', value: 'B-Bk Net Volume' }, { key: 'B_PROFIT', value: 'B-Bk Profit (USD)' }, { key: 'A_DEALS', value: 'A-Bk Deals' }, { key: 'A_BUY_VOLUME', value: 'A-Bk Buy Volume' }, { key: 'A_BUY_PRICE', value: 'A-Bk Buy Price' }, { key: 'A_SELL_VOLUME', value: 'A-Bk Sell Volume' }, { key: 'A_SELL_PRICE', value: 'A-Bk Sell Price' }, { key: 'A_NET_VOLUME', value: 'A-Bk Net Volume' }, { key: 'A_PROFIT', value: 'A-Bk Profit (USD)' }, { key: 'NET_BUY_VOLUME', value: 'Net Buy Volume' }, { key: 'NET_BUY_PRICE', value: 'Net Buy Price' }, { key: 'NET_SELL_VOLUME', value: 'Net Sell Volume' }, { key: 'NET_SELL_PRICE', value: 'Net Sell Price' }, { key: 'NET_PROFIT', value: 'Net Profit (USD)' }]
        }
    }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        clientReport: {
            downloadName: '客户报表',
            enableMapper: { 0: '禁用', 1: '启用' },
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'GROUP', value: '组别' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'enable', value: '启用/禁用' }, { key: 'NAME', value: '名字' }, { key: 'EMAIL', value: '电邮' }, { key: 'PHONE', value: '电话' }, { key: 'ADDRESS', value: '地址' }, { key: 'REGDATE', value: '注册日期' }, { key: 'LEVERAGE', value: '杠杆' }]
        }
    },
    hk: {
        clientReport: {
            downloadName: '客戶報表',
            enableMapper: { 0: '禁用', 1: '啟用' },
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'LOGIN', value: '賬戶' }, { key: 'GROUP', value: '組別' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'enable', value: '啟用/禁用' }, { key: 'NAME', value: '名字' }, { key: 'EMAIL', value: '電郵' }, { key: 'PHONE', value: '電話' }, { key: 'ADDRESS', value: '地址' }, { key: 'REGDATE', value: '註冊日期' }, { key: 'LEVERAGE', value: '槓桿' }]
        }
    },
    en: {
        clientReport: {
            downloadName: 'Client Report',
            enableMapper: { 0: 'Disable', 1: 'Enable' },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'GROUP', value: 'Group' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'enable', value: 'Enable' }, { key: 'NAME', value: 'Name' }, { key: 'EMAIL', value: 'Email' }, { key: 'PHONE', value: 'Phone' }, { key: 'ADDRESS', value: 'Address' }, { key: 'REGDATE', value: 'Regdate' }, { key: 'LEVERAGE', value: 'Leverage' }]
        }
    }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        monitorAccounts: {
            accHead: [{ key: 'COMMENT_1', value: '描述', writable: true }, { key: 'LOGIN', value: '客户账号' }, { key: 'NAME', value: '客户姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'ACC_NAME', value: '办事处' }, { key: 'ZIPCODE', value: '邮编' }, { key: 'DEPOSIT_TODAY', value: '今日入金' }, { key: 'WITHDRAWAL_TODAY', value: '今日出金' }, { key: 'CLOSED_PL', value: '今日平仓盈亏' }, { key: 'TOTAL_FLOATING_PL', value: '至今未平仓盈亏' }, { key: 'TOTAL_CLOSE_PL', value: '至今平仓盈亏' }, { key: 'TOTAL_PL', value: '至今总盈亏' }],
            tableHead: [{ key: 'CREATE_DATE', value: '加入名单日期' }, { key: 'COMMENT_2', value: '描述2', writable: true }, { key: 'USED_IP', value: '曾经使用的IP', table: true }, { key: 'COMMENT_3', value: '描述3', writable: true }, { key: 'LOG_TIME_UNTIL_IP', value: 'IP日志时间' }, { key: 'COMMENT_4', value: '描述4', writable: true }, { key: 'LOG_TIME_UNTIL_IP_RELATED', value: '关联IP日志时间' }, { key: 'COMMENT_5', value: '描述5', writable: true }],
            ipTableHead: [{ key: 'IP', value: 'IP' }, { key: 'RELATED_LOGINS', value: '关联的账号' }],
            tradesHead: [{ key: 'TICKET', value: '交易单号' }, { key: 'LOGIN', value: '账号' }, { key: 'TIME', value: '时间' }, { key: 'PRICE', value: '价格' }, { key: 'TYPE', value: '开仓/平仓' }, { key: 'CMD', value: '买/卖' }, { key: 'VOLUME', value: '手数' }, { key: 'SYMBOL', value: '产品' }],
            rules: {
                login: [{ required: true, message: '请输入账号', trigger: 'blur' }, { type: 'number', message: '账号必须为数字值' }],
                comment: [{ required: true, message: '请填写描述', trigger: 'blur' }]
            },
            close: '平仓',
            open: '开仓',
            commentOpt: { 1: '短线交易', 2: '打平台', 3: '交易行为可疑', 4: '盈利能力高', 5: '团体交易', 6: '其他' },
            excelName: 'IP关联账号',
            addBtnTxt: '新增客户到监察名单',
            badgeBtnTxt: '监察客户近期交易单明细',
            showIPBtnTxt: '点击查看',
            lastTableColumnTxt: '操作',
            addDialogTitle: '请填写客户账号信息',
            formLoginLabel: '客户账号',
            formCommentLabel: '描述',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            ipTableDialogTitle: '曾经使用的IP及关联账号',
            ipTableKeywordTxt: '输入关键字搜索',
            addSuccess: '新增监察客户账号成功',
            addFailed: '新增监察客户账号失败',
            notifyTxt: '提示',
            updateMsg1Txt: '是否更新账号',
            updateMsg2Txt: '的描述',
            updateSuccess: '更新成功',
            updateFailed: '更新失败或记录与更新前一致',
            deleteMsgTxt: '是否从监察名单中移除账号',
            delSuccess: '移除成功',
            delFailed: '移除失败'
        }
    },
    hk: {
        monitorAccounts: {
            accHead: [{ key: 'COMMENT_1', value: '描述', writable: true }, { key: 'LOGIN', value: '客戶賬號' }, { key: 'NAME', value: '客戶姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'ACC_NAME', value: '辦事處' }, { key: 'ZIPCODE', value: '郵編' }, { key: 'DEPOSIT_TODAY', value: '今日入金' }, { key: 'WITHDRAWAL_TODAY', value: '今日出金' }, { key: 'CLOSED_PL', value: '今日平倉盈虧' }, { key: 'TOTAL_FLOATING_PL', value: '至今未平倉盈虧' }, { key: 'TOTAL_CLOSE_PL', value: '至今平倉盈虧' }, { key: 'TOTAL_PL', value: '至今縂盈虧' }],
            tableHead: [{ key: 'CREATE_DATE', value: '加入名單日期' }, { key: 'COMMENT_2', value: '描述2', writable: true }, { key: 'USED_IP', value: '曾經使用的IP', table: true }, { key: 'COMMENT_3', value: '描述3', writable: true }, { key: 'LOG_TIME_UNTIL_IP', value: 'IP日志時間' }, { key: 'COMMENT_4', value: '描述4', writable: true }, { key: 'LOG_TIME_UNTIL_IP_RELATED', value: '關聯IP日志時間' }, { key: 'COMMENT_5', value: '描述5', writable: true }],
            ipTableHead: [{ key: 'IP', value: 'IP' }, { key: 'RELATED_LOGINS', value: '關聯的賬號' }],
            tradesHead: [{ key: 'TICKET', value: '交易單號' }, { key: 'LOGIN', value: '賬號' }, { key: 'TIME', value: '時間' }, { key: 'PRICE', value: '價格' }, { key: 'TYPE', value: '開倉/平倉' }, { key: 'CMD', value: '買/賣' }, { key: 'VOLUME', value: '手數' }, { key: 'SYMBOL', value: '產品' }],
            rules: {
                login: [{ required: true, message: '請輸入賬號', trigger: 'blur' }, { type: 'number', message: '賬號必須為數字' }],
                comment: [{ required: true, message: '請填寫描述', trigger: 'blur' }]
            },
            close: '平倉',
            open: '開倉',
            commentOpt: { 1: '短綫交易', 2: '打平臺', 3: '交易行爲可疑', 4: '盈利能力高', 5: '團體交易', 6: '其他' },
            excelName: 'IP關聯賬號',
            addBtnTxt: '新增客戶到監察名單',
            badgeBtnTxt: '監察客戶近期交易單明細',
            showIPBtnTxt: '點擊查看',
            lastTableColumnTxt: '操作',
            addDialogTitle: '請填寫客戶賬號信息',
            formLoginLabel: '客戶賬號',
            formCommentLabel: '描述',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            ipTableDialogTitle: '曾經使用的IP及關聯賬號',
            ipTableKeywordTxt: '輸入關鍵字搜索',
            addSuccess: '新增監察客戶賬號成功',
            addFailed: '新增監察客戶賬號失敗',
            notifyTxt: '提示',
            updateMsg1Txt: '是否更新賬號',
            updateMsg2Txt: '的描述',
            updateSuccess: '更新成功',
            updateFailed: '更新失敗或記錄與更新前一致',
            deleteMsgTxt: '是否從監察名單中移除賬號',
            delSuccess: '移除成功',
            delFailed: '移除失敗'
        }
    },
    en: {
        monitorAccounts: {
            accHead: [{ key: 'COMMENT_1', value: 'Comment', writable: true }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'ACC_NAME', value: 'Office Name' }, { key: 'ZIPCODE', value: 'Zipcode' }, { key: 'DEPOSIT_TODAY', value: 'Today\'s Deposit' }, { key: 'WITHDRAWAL_TODAY', value: 'Today\'s Withdrawal' }, { key: 'CLOSED_PL', value: 'Today\'s Closed PL' }, { key: 'TOTAL_FLOATING_PL', value: 'Total Floating PL' }, { key: 'TOTAL_CLOSE_PL', value: 'Total Closed PL' }, { key: 'TOTAL_PL', value: 'Total PL' }],
            tableHead: [{ key: 'CREATE_DATE', value: 'Create Date' }, { key: 'COMMENT_2', value: 'Comment 2', writable: true }, { key: 'USED_IP', value: 'Used IP', table: true }, { key: 'COMMENT_3', value: 'Comment 3', writable: true }, { key: 'LOG_TIME_UNTIL_IP', value: 'Log Time Until IP' }, { key: 'COMMENT_4', value: 'Comment 4', writable: true }, { key: 'LOG_TIME_UNTIL_IP_RELATED', value: 'Log Time Until IP Related' }, { key: 'COMMENT_5', value: 'Comment 5', writable: true }],
            ipTableHead: [{ key: 'IP', value: 'IP' }, { key: 'RELATED_LOGINS', value: 'Related Logins' }],
            tradesHead: [{ key: 'TICKET', value: 'Ticket' }, { key: 'LOGIN', value: 'Login' }, { key: 'TIME', value: 'Time' }, { key: 'PRICE', value: 'Price' }, { key: 'TYPE', value: 'Open/Close' }, { key: 'CMD', value: 'Buy/Sell' }, { key: 'VOLUME', value: 'Volume' }, { key: 'SYMBOL', value: 'Symbol' }],
            rules: {
                login: [{ required: true, message: 'Please input login', trigger: 'blur' }, { type: 'number', message: 'The login must be number' }],
                comment: [{ required: true, message: 'Please input comment', trigger: 'blur' }]
            },
            close: 'Close',
            open: 'Open',
            commentOpt: { 1: '短綫交易', 2: '打平臺', 3: '交易行爲可疑', 4: '盈利能力高', 5: '團體交易', 6: '其他' },
            excelName: 'IP related login',
            addBtnTxt: 'Add account to monitor list',
            badgeBtnTxt: 'Details of recent orders of monitored accounts',
            showIPBtnTxt: 'Click to view',
            lastTableColumnTxt: 'Handle',
            addDialogTitle: 'Please fill in the login information',
            formLoginLabel: 'Login',
            formCommentLabel: 'Comment',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'Confirm',
            ipTableDialogTitle: 'Used IP and related accounts',
            ipTableKeywordTxt: 'Enter a keyword search',
            addSuccess: 'The monitor account was successfully added',
            addFailed: 'Failed to add monitor account',
            notifyTxt: 'Tips',
            updateMsg1Txt: 'Are you sure need to update the account',
            updateMsg2Txt: '\'s comment?',
            updateSuccess: 'Update successfully',
            updateFailed: 'Update failed or the record is same as before',
            deleteMsgTxt: 'Are you sure need to delete the account from monitor list?',
            delSuccess: 'Delete successfully',
            delFailed: 'Delete failed'
        }
    }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        autoPositionReport: {
            accHead: [{ key: 'id', value: '配置编号' },
            // { key: 'conf_key', value: '配置类型' },
            { key: 'conf_desc', value: '配置描述' }, { key: 'value', value: '配置关键值' }, { key: 'modify_time', value: '最后修改时间' }, { key: 'modify_by', value: '最后修改人' }],
            miutesRulesRequired: '请输入每小时报仓的分钟数',
            miutesRulesNumber: '每小时报仓分钟数必须为正整数',
            managerRulesRequired: '请输入MT4经理账号',
            managerRulesNumber: 'MT4经理账号必须为正整数',
            securityRulesRequired: '请填写产品大类名称',
            maxCountRulesRequired: '请填写最大显示数',
            maxCountRulesNumber: '最大显示数必须为正整数',
            typeRulesRequired: '请选择产品组',
            specialSymbolRulesRequired: '请选择特殊产品',
            specialSecurityRulesRequired: '请选择特殊产品组',
            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            confKeyOpt: {
                security: '产品大类',
                manager: 'MT4经理账号',
                specialSecurity: '特殊配置',
                showMaxCount: '最大显示数',
                minutes: '报仓时间'
            },
            confValLabelOpt: {
                confType: '配置描述',
                minutes: '每小时第几分钟报仓(0-59)(未设置默认5)',
                manager: 'MT4经理账号',
                security: '产品大类名称(例如主要外汇/贵金属等)',
                showMaxCount: '每个大类最大产品显示数(小于等于0或者未设置默认为7)',
                tittle: '标题',
                types: '产品组列表',
                abandonedRange: '不报仓净手数范围(开区间,没有设置则不限制手数)',
                specialSymbol: '特殊产品',
                specialSecurity: '特殊产品组'
            },
            descContent: {
                security: '产品大类 - 选择什么产品组会在同一个产品大类里面报仓。另外可控制在多少手数内的仓位可以略过不报',
                manager: 'MT4经理账号 - 按照什么经理账号的权限去报仓',
                specialSecurity: '特殊配置 - 把个别产品放入指定产品组来报仓',
                showMaxCount: '最大显示数 - 设置每个产品大类会展示最多多少产品的报仓',
                minutes: '报仓时间 - 每小时什么时间开始报仓'
            },
            formSelectDefaultTxt: '请选择',
            formConfValLabel: '配置参数',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作'
        }
    },
    hk: {
        autoPositionReport: {
            accHead: [{ key: 'id', value: '配置編號' },
            // { key: 'conf_key', value: '配置類型' },
            { key: 'conf_desc', value: '配置描述' }, { key: 'value', value: '配置關鍵值' }, { key: 'modify_time', value: '最後修改時間' }, { key: 'modify_by', value: '最後修改人' }],
            miutesRulesRequired: '請輸入每小時報倉的分鐘數',
            miutesRulesNumber: '每小時報倉分鐘數必須為正整數',
            managerRulesRequired: '請輸入MT4經理賬號',
            managerRulesNumber: 'MT4經理賬號必須為正整數',
            securityRulesRequired: '請填寫產品大類名稱',
            maxCountRulesRequired: '請填寫最大顯示數',
            maxCountRulesNumber: '最大顯示數必須爲正整數',
            typeRulesRequired: '請選擇產品組',
            specialSymbolRulesRequired: '請選擇特殊產品',
            specialSecurityRulesRequired: '請選擇特殊產品組',
            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            confKeyOpt: {
                security: '產品大類',
                manager: 'MT4經理賬號',
                specialSecurity: '特殊配置',
                showMaxCount: '最大顯示數',
                minutes: '報倉時間'
            },
            confValLabelOpt: {
                confType: '配置描述',
                minutes: '每小時第幾分鐘報倉(0-59)(未設置默認5)',
                manager: 'MT4經理賬號',
                security: '產品大類名稱(例如主要外匯/貴金屬等)',
                showMaxCount: '每個大類最大產品顯示數(小於等於0或者未設置默認為7)',
                tittle: '標題',
                types: '產品組列表',
                abandonedRange: '不報倉净手數範圍(開區間,未設置則不限制手數)',
                specialSymbol: '特殊產品',
                specialSecurity: '特殊產品組'
            },
            descContent: {
                security: '產品大類 - 選擇什麽產品組會在同一個產品大類裏面報倉。另外可控制在多少手數内的倉位可以略過不報',
                manager: 'MT4經理賬號 - 按照什麽經理賬號的權限去報倉',
                specialSecurity: '特殊配置 - 把個別產品放入指定產品組來報倉',
                showMaxCount: '最大顯示數 - 設置每個產品大類會展示最多多少產品的報倉',
                minutes: '報倉時間 - 每小時什麽時間開始報倉'
            },
            formSelectDefaultTxt: '請選擇',
            formConfValLabel: '配置參數',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作'
        }
    },
    en: {
        autoPositionReport: {
            accHead: [{ key: 'id', value: 'ID' },
            // { key: 'conf_key', value: 'Type' },
            { key: 'conf_desc', value: 'Description' }, { key: 'value', value: 'Value' }, { key: 'modify_time', value: 'Modify Time' }, { key: 'modify_by', value: 'Modify By' }],
            miutesRulesRequired: 'Please enter the minutes of the hourly position report',
            miutesRulesNumber: 'Hourly position reporting minutes must be a positive integer',
            managerRulesRequired: 'Please enter the MT4 manager account',
            managerRulesNumber: 'MT4 manager account number must be a positive integer',
            securityRulesRequired: 'Please fill in the product name',
            maxCountRulesRequired: 'Please fill in the maximum number of display',
            maxCountRulesNumber: 'The maximum display number must be a positive integer',
            typeRulesRequired: 'Please select securities',
            specialSymbolRulesRequired: 'Please select special symbols',
            specialSecurityRulesRequired: 'Please select a special security',
            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            confKeyOpt: {
                security: 'Product',
                manager: 'MT4 manager account',
                specialSecurity: 'Special configuration',
                showMaxCount: 'Maximum number of display',
                minutes: 'Report minutes'
            },
            confValLabelOpt: {
                confType: 'Configuration description',
                minutes: 'The minute of the hour to report the position(0-59)(default 5 if not set)',
                manager: 'MT4 manager account',
                security: 'Product name (such as 主要外匯/貴金屬 etc.)',
                showMaxCount: 'Max symbols displayed for each produce(less than or equal to 0 or not set to 7 by default)',
                tittle: 'Tittle',
                types: 'Secutity list',
                abandonedRange: 'Net lot size range without reporting positions(open range, no limit on lot size if not set)',
                specialSymbol: 'Special symbols',
                specialSecurity: 'Special security'
            },
            descContent: {
                security: 'Product - Choose which securities to be grouped into a product name for the purpose of reporting. A net lot size range is also available to omit reports that fall within the designated net positions',
                manager: 'MT manager account - Proceed with the reporting based on the privilege bounded by a particular MT manager account',
                specialSecurity: 'Special configuration - Force particular symbols into certain security group for the purpose of reporting',
                showMaxCount: 'Maximum number of display - Set the maximum number of symbols to be displayed within each Product',
                minutes: 'Report minutes - Denotes the minute in each hour reporting will be announced'
            },
            formSelectDefaultTxt: 'Please select',
            formConfValLabel: 'Configuration parameters',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle'
        }
    }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        autoUpdateLeverage: {
            accHead: [{ key: 'group', value: '组别' }, { key: 'equity_valve', value: '净值数值设定' }, { key: 'leverage_lte', value: '杠杆倍数(小于或等于)' }, { key: 'leverage_gt', value: '杠杆倍数(大于)' }, { key: 'enableDesc', value: '每天执行' }, { key: 'modify_by', value: '最后修改人' }],
            addGroupTxt: '组别',
            addEquityTxt: '净值数值设定(保留两位小数)',
            addLeveragelteTxt: '杠杆倍数(小于或等于)',
            addLeveragegtTxt: '杠杆倍数(大于)',
            addEnableTxt: '每天执行',
            yesTxt: '是',
            noTxt: '否',

            groupRulesRequired: '请选择组别',
            equityRulesRequired: '请输入净值数值设定',
            equityRulesNumber: '净值数值必须为正整数',
            leverageLteRulesRequired: '请输入杠杆倍数',
            leverageLteRulesNumber: '杠杆倍数必须为正整数',
            leverageGtRulesRequired: '请输入杠杆倍数',
            leverageGtRulesNumber: '杠杆倍数必须为正整数',
            descriptionTxt: '\u5982\u679C\u4ECA\u5929\u81EA\u52A8\u66F4\u65B0\u4EA4\u6613\u8D26\u53F7\u6760\u6746\u53D1\u751F\u95EE\u9898\u9700\u8981\u91CD\u65B0\u5904\u7406\uFF0C\u53EF\u4EE5\u5C06\u7EC4\u522B\u4E3ARerun_Program\u7684\u90A3\u884C\u6570\u636E\u7684"\u6BCF\u5929\u6267\u884C"\u66F4\u65B0\u4E3A"\u662F"\uFF0C\n                \u53D8\u66F4\u4E4B\u540E\u7684\u7B2C10\u5206\u949F\u751F\u6548(\u4F8B\u5982\u5728\u4E0A\u53488\u70B910\u520620\u79D2\u66F4\u65B0\u7684\uFF0C\u9700\u8981\u5728\u4E0A\u53488\u70B920\u5206\u7A0B\u5E8F\u624D\u4F1A\u91CD\u65B0\u5904\u7406)\u3002\u7A0B\u5E8F\u91CD\u65B0\u5904\u7406\u5F00\u59CB\u540E\uFF0C"\u6760\u6746\u500D\u6570(\u5927\u4E8E)"\u5C06\u4F1A\u53D8\u4E3A"2"\u3002\n                \u7A0B\u5E8F\u91CD\u65B0\u5904\u7406\u5B8C\u4E4B\u540E\uFF0C"\u6760\u6746\u500D\u6570(\u5927\u4E8E)"\u5C06\u4F1A\u53D8\u4E3A"1"\uFF0C"\u6BCF\u5929\u6267\u884C"\u5C06\u4F1A\u81EA\u52A8\u53D8\u4E3A"\u5426"\u3002',

            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作'
        }
    },
    hk: {
        autoUpdateLeverage: {
            accHead: [{ key: 'group', value: '組別' }, { key: 'equity_valve', value: '淨值數值設定' }, { key: 'leverage_lte', value: '槓桿倍數(小於或等於)' }, { key: 'leverage_gt', value: '槓桿倍數(大於)' }, { key: 'enableDesc', value: '每天執行' }, { key: 'modify_by', value: '最後修改人' }],
            addGroupTxt: '組別',
            addEquityTxt: '淨值數值(保留兩位小數)',
            addLeveragelteTxt: '槓桿倍數(小於或等於)',
            addLeveragegtTxt: '槓桿倍數(大於)',
            addEnableTxt: '每天執行',
            yesTxt: '是',
            noTxt: '否',

            groupRulesRequired: '請選擇組別',
            equityRulesRequired: '請輸入淨值數值設定',
            equityRulesNumber: '淨值數值必須為正整數',
            leverageLteRulesRequired: '請輸入槓桿倍數',
            leverageLteRulesNumber: '槓桿倍數必須為正整數',
            leverageGtRulesRequired: '請輸入槓桿倍數',
            leverageGtRulesNumber: '槓桿倍數必須為正整數',
            descriptionTxt: '\u5982\u679C\u4ECA\u5929\u81EA\u52D5\u66F4\u65B0\u4EA4\u6613\u8CEC\u865F\u69D3\u687F\u767C\u751F\u554F\u984C\u9700\u8981\u91CD\u65B0\u8655\u7406\uFF0C\u53EF\u4EE5\u5C07\u7D44\u5225\u70BARerun_Program\u7684\u90A3\u884C\u6578\u64DA\u7684"\u6BCF\u5929\u57F7\u884C"\u66F4\u65B0\u70BA"\u662F"\uFF0C\n                \u8B8A\u66F4\u4E4B\u5F8C\u7684\u7B2C10\u5206\u9418\u751F\u6548(\u4F8B\u5982\u5728\u4E0A\u53488\u9EDE10\u520620\u79D2\u66F4\u65B0\u7684\uFF0C\u9700\u8981\u5728\u4E0A\u53488\u9EDE20\u5206\u7A0B\u5E8F\u624D\u6703\u91CD\u65B0\u8655\u7406)\u3002\u7A0B\u5E8F\u91CD\u65B0\u8655\u7406\u958B\u59CB\u5F8C\uFF0C"\u69D3\u687F\u500D\u6578(\u5927\u65BC)"\u5C07\u6703\u8B8A\u70BA"2"\u3002\n                \u7A0B\u5E8F\u91CD\u65B0\u8655\u7406\u5B8C\u4E4B\u5F8C\uFF0C"\u69D3\u687F\u500D\u6578(\u5927\u65BC)"\u5C07\u6703\u8B8A\u70BA"1"\uFF0C"\u6BCF\u5929\u57F7\u884C"\u5C07\u6703\u81EA\u52D5\u8B8A\u70BA"\u5426"\u3002',

            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作'
        }
    },
    en: {
        autoUpdateLeverage: {
            accHead: [{ key: 'group', value: 'Group' }, { key: 'equity_valve', value: 'Equity Value Setting' }, { key: 'leverage_lte', value: 'Leverage Ratio(Less than or equal to)' }, { key: 'leverage_gt', value: 'Leverage Ratio(Greater than)' }, { key: 'enableDesc', value: 'Daily Execution' }, { key: 'modify_by', value: 'Modify By' }],
            addGroupTxt: 'Group',
            addEquityTxt: 'Equity Value Setting(Two decimal places)',
            addLeveragelteTxt: 'Leverage Ratio(Less than or equal to)',
            addLeveragegtTxt: 'Leverage Ratio(Greater than)',
            addEnableTxt: 'Daily Execution',
            yesTxt: 'Yes',
            noTxt: 'No',

            groupRulesRequired: 'Please select a group',
            equityRulesRequired: 'Please input the equity value setting',
            equityRulesNumber: 'Equity value must be a positive integer',
            leverageLteRulesRequired: 'Please input the Leverage Ratio',
            leverageLteRulesNumber: 'Leverage ratio must be a positive integer',
            leverageGtRulesRequired: 'Please input the Leverage Ratio',
            leverageGtRulesNumber: 'Leverage ratio must be a positive integer',
            descriptionTxt: 'If a problem occurs with the automatic update of trading account leverage, and it needs reprocessing, \n                operator can update the "Daily Execution" manually by the row which group called "Rerun_Program". Switch it to "Yes", \n                and activate leverage execution. The process takes effect in 10 minutes, example (at 08:10:20 A.M., the program execute \n                the rerun at 08:20:00 A.M.). When the program is reprocessing, "Leverage (greater than)" will be changed to "2". When the \n                processing is finished, "Leverage (greater than)" will change to "1". The "Daily Execution" will automatically change to "No".',

            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle'
        }
    }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        chargeDividends: {
            accHead: [{ key: 'symbol', value: '产品' }, { key: 'buy', value: '买利息' }, { key: 'sell', value: '卖利息' }, { key: 'group', value: '组别' }, { key: 'zipcode', value: 'ZIP' }, { key: 'comment', value: 'MT备注' }, { key: 'excute_time', value: '系统执行时间' }, { key: 'statusDesc', value: '执行状态' }, { key: 'modify_by', value: '最后修改人' }],
            addSymbolTxt: '产品',
            addBuyTxt: '买利息(格式为"数字 货币"或"数字 pt")',
            addSellTxt: '卖利息(格式为"数字 货币"或"数字 pt")',
            addGroupTxt: '组别(格式为MT4格式)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT备注(产品关键字为SYMBOL,手数关键字为VOLUME)',
            addExcuteTimeTxt: '执行时间(格式为YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: '请选择产品',
            buyRulesRequired: '请输买利息',
            sellRulesRequired: '请输入卖利息',
            buyOrSellRulesInvalid: '请输入正确的格式',
            timeRulesInvalid: '请输入正确的时间格式',
            groupRulesRequired: '请输入组别',
            zipcodeRulesRequired: '请输入ZIP',
            commentRulesRequired: '请输入MT备注',
            excuteTimeRulesRequired: '请输入执行时间',

            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败 - 无法更新已经处理或正在处理的配置',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作',
            statusMapping: { 0: '未派息', 1: '派息中', 2: '修复中', 3: '部分派息', 4: '已派息' }
        }
    },
    hk: {
        chargeDividends: {
            accHead: [{ key: 'symbol', value: '產品' }, { key: 'buy', value: '買利息' }, { key: 'sell', value: '賣利息' }, { key: 'group', value: '組別' }, { key: 'zipcode', value: 'ZIP' }, { key: 'comment', value: 'MT備註' }, { key: 'excute_time', value: '係統執行時間' }, { key: 'statusDesc', value: '執行狀態' }, { key: 'modify_by', value: '最後修改人' }],
            addSymbolTxt: '產品',
            addBuyTxt: '買利息(格式為"數字 貨幣"或"數字 pt")',
            addSellTxt: '賣利息(格式為"數字 貨幣"或"數字 pt")',
            addGroupTxt: '組別(格式為MT4格式)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT備註(產品關鍵字為SYMBOL,手數關鍵字為VOLUME)',
            addExcuteTimeTxt: '執行時間(格式為YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: '請選擇產品',
            buyRulesRequired: '請輸入買利息',
            sellRulesRequired: '請輸入賣利息',
            buyOrSellRulesInvalid: '請輸入正確的格式',
            timeRulesInvalid: '請輸入正確的時間格式',
            groupRulesRequired: '請輸入組別',
            zipcodeRulesRequired: '請輸入ZIP',
            commentRulesRequired: '請輸入MT備註',
            excuteTimeRulesRequired: '请输入执行时间',

            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗 - 無法更新已經處理或正在處理得配置',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作',
            statusMapping: { 0: '未派息', 1: '派息中', 2: '修復中', 3: '部分派息', 4: '已派息' }
        }
    },
    en: {
        chargeDividends: {
            accHead: [{ key: 'symbol', value: 'Symbol' }, { key: 'buy', value: 'Buy' }, { key: 'sell', value: 'Sell' }, { key: 'group', value: 'Group' }, { key: 'zipcode', value: 'ZIP' }, { key: 'comment', value: 'MT Comment' }, { key: 'excute_time', value: 'Excute Time' }, { key: 'statusDesc', value: 'Status' }, { key: 'modify_by', value: 'Modify By' }],
            addSymbolTxt: 'Symbol',
            addBuyTxt: 'Buy dividend(The format is "number currency" or "number pt")',
            addSellTxt: 'Sell dividend(The format is "number currency" or "number pt")',
            addGroupTxt: 'Group(The format is MT4 format)',
            addZipTxt: 'ZIP',
            addCommentTxt: 'MT Comment(The symbol keyword is SYMBOL and the lot keyword is VOLUME)',
            addExcuteTimeTxt: 'Excute Time(The format is YYYY-MM-DD HH:mm:ss)',

            symbolRulesRequired: 'Please select symbol',
            buyRulesRequired: 'Please enter buy dividend',
            sellRulesRequired: 'Please enter sell dividend',
            buyOrSellRulesInvalid: 'Please enter the correct format',
            timeRulesInvalid: 'Please enter the correct time format',
            groupRulesRequired: 'Please enter group',
            zipcodeRulesRequired: 'Please enter ZIP',
            commentRulesRequired: 'Please enter MT comment',
            excuteTimeRulesRequired: 'Please enter excute time',

            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration  - unable to update configuration that has been processed or is being processed',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle',
            statusMapping: { 0: 'Awaiting dividend', 1: 'Pending dividend', 2: 'Repair dividend', 3: 'Partial dividend', 4: 'Finish dividend' }
        }
    }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mt4ClosedTradesReport__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mt4DepositWithdrawlReport__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mt4CreditReport__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mt4AccountReport__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mt4SummaryReport__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mt4SeregatedReport__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mt4EquityReport__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mt4ProfitLossReport__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mt4EquityMultiReport__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analyze__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbolProfit__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__downloadReport__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__floatingPLReport__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__openTradesReport__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__profitTopList__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__closedTradesReport__ = __webpack_require__(934);

















var managerLanguages = [__WEBPACK_IMPORTED_MODULE_0__mt4ClosedTradesReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mt4DepositWithdrawlReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mt4CreditReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mt4AccountReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mt4SummaryReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mt4SeregatedReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mt4EquityReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mt4ProfitLossReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mt4EquityMultiReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__analyze__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__symbolProfit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__downloadReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__floatingPLReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__openTradesReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__profitTopList__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__closedTradesReport__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (managerLanguages);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4ClosedTradesReport: {
            timeText: '平仓时间：',
            securityText: '产品组：',
            downloadName: 'MT4已平仓报表',
            cmdMapping: { 0: '买入', 1: '卖出' },
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'TICKET', value: '单号' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '组别' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'OPEN_TIME', value: '开仓时间' }, { key: 'cmd', value: '交易类型' }, { key: 'SYMBOL', value: '产品' }, { key: 'SECURITY', value: '产品组' }, { key: 'VOLUME', value: '手数' }, { key: 'OPEN_PRICE', value: '开仓价' }, { key: 'CLOSE_TIME', value: '平仓时间' }, { key: 'CLOSE_PRICE', value: '平仓价' }, { key: 'COMMISSION', value: '佣金' }, { key: 'TAXES', value: '税费' }, { key: 'COMMISSION_AGENT', value: '代理佣金' }, { key: 'SWAPS', value: '利息' }, { key: 'PROFIT', value: '盈亏' }, { key: 'PIPES', value: '价位差' }, { key: 'COMMENT', value: '注释' }]
        }
    },
    hk: {
        mt4ClosedTradesReport: {
            timeText: '平倉時間：',
            securityText: '產品組：',
            downloadName: 'MT4已平倉報表',
            cmdMapping: { 0: '買入', 1: '賣出' },
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'TICKET', value: '單號' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '組別' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'OPEN_TIME', value: '開倉時間' }, { key: 'cmd', value: '交易類型' }, { key: 'SYMBOL', value: '產品' }, { key: 'SECURITY', value: '產品組' }, { key: 'VOLUME', value: '手數' }, { key: 'OPEN_PRICE', value: '開倉價' }, { key: 'CLOSE_TIME', value: '平倉時間' }, { key: 'CLOSE_PRICE', value: '平倉價' }, { key: 'COMMISSION', value: '佣金' }, { key: 'TAXES', value: '稅費' }, { key: 'COMMISSION_AGENT', value: '代理佣金' }, { key: 'SWAPS', value: '利息' }, { key: 'PROFIT', value: '盈虧' }, { key: 'PIPES', value: '價位差' }, { key: 'COMMENT', value: '注釋' }]
        }
    },
    en: {
        mt4ClosedTradesReport: {
            timeText: 'Close Time：',
            securityText: 'Securities：',
            downloadName: 'MT4 Closed Trades Report',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'TICKET', value: 'Deal' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'GROUP', value: 'Group' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'OPEN_TIME', value: 'Open Time' }, { key: 'cmd', value: 'Type' }, { key: 'SYMBOL', value: 'Symbol' }, { key: 'SECURITY', value: 'Securities' }, { key: 'VOLUME', value: 'Volume' }, { key: 'OPEN_PRICE', value: 'Open Price' }, { key: 'CLOSE_TIME', value: 'Close Time' }, { key: 'CLOSE_PRICE', value: 'Close Price' }, { key: 'COMMISSION', value: 'Commission' }, { key: 'TAXES', value: 'Taxes' }, { key: 'COMMISSION_AGENT', value: 'Agent' }, { key: 'SWAPS', value: 'Swaps' }, { key: 'PROFIT', value: 'Profit' }, { key: 'PIPES', value: 'Pipes' }, { key: 'COMMENT', value: 'Comment' }]
        }
    }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4DepositWithdrawlReport: {
            commentText: '注释：',
            timeText: '交易时间：',
            downloadName: 'MT4出入金报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'TICKET', value: '交易单号' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'CLOSE_TIME', value: '交易时间' }, { key: 'COMMENT', value: '注释' }, { key: 'PROFIT', value: '金额' }]
        }
    },
    hk: {
        mt4DepositWithdrawlReport: {
            commentText: '注釋：',
            timeText: '交易時間：',
            downloadName: 'MT4出入金報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'TICKET', value: '交易單號' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'CLOSE_TIME', value: '交易時間' }, { key: 'COMMENT', value: '注釋' }, { key: 'PROFIT', value: '金額' }]
        }
    },
    en: {
        mt4DepositWithdrawlReport: {
            commentText: 'Comment：',
            timeText: 'Trade Time：',
            downloadName: 'MT4 Deposit Withdrawl Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'TICKET', value: 'Deal' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'CLOSE_TIME', value: 'Deal Time' }, { key: 'COMMENT', value: 'Comment' }, { key: 'PROFIT', value: 'Amount' }]
        }
    }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4CreditReport: {
            timeText: '交易时间：',
            downloadName: 'MT4信用额报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'TICKET', value: '交易单号' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'CLOSE_TIME', value: '交易时间' }, { key: 'VALUE_TIME', value: '交易日期' }, { key: 'COMMENT', value: '注释' }, { key: 'PROFIT', value: '金额' }]
        }
    },
    hk: {
        mt4CreditReport: {
            timeText: '交易時間：',
            downloadName: 'MT4信用額報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'TICKET', value: '交易單號' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'CLOSE_TIME', value: '交易時間' }, { key: 'Value_TIME', value: '交易日期' }, { key: 'COMMENT', value: '注釋' }, { key: 'PROFIT', value: '金額' }]
        }
    },
    en: {
        mt4CreditReport: {
            timeText: 'Trade Time：',
            downloadName: 'MT4 Credit Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'TICKET', value: 'Deal' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'CLOSE_TIME', value: 'Date' }, { key: 'Value_TIME', value: 'Value Date' }, { key: 'COMMENT', value: 'Comment' }, { key: 'PROFIT', value: 'Amount' }]
        }
    }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4AccountReport: {
            downloadName: 'MT4账户报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '组别' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'IB_NAME', value: '代理姓名' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'ZIPCODE', value: '邮编' }, { key: 'ADDRESS', value: '地址' }, { key: 'EMAIL', value: '邮箱' }, { key: 'PHONE', value: '电话号码' }, { key: 'COMMENT', value: '注释' }, { key: 'REGDATE', value: '注册日期' }, { key: 'LEVERAGE', value: '杠杆' }, { key: 'BALANCE', value: '余额' }, { key: 'CREDIT', value: '信用额' }]
        }
    },
    hk: {
        mt4AccountReport: {
            downloadName: 'MT4賬戶報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '組別' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'IB_NAME', value: '代理姓名' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'ZIPCODE', value: '郵編' }, { key: 'ADDRESS', value: '地址' }, { key: 'EMAIL', value: '郵箱' }, { key: 'PHONE', value: '電話號碼' }, { key: 'COMMENT', value: '注釋' }, { key: 'REGDATE', value: '註冊日期' }, { key: 'LEVERAGE', value: '槓桿' }, { key: 'BALANCE', value: '餘額' }, { key: 'CREDIT', value: '信用額' }]
        }
    },
    en: {
        mt4AccountReport: {
            downloadName: 'MT4 Credit Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'GROUP', value: 'Group' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'Agent' }, { key: 'IB_NAME', value: 'Agent Name' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'ZIPCODE', value: 'Zip' }, { key: 'ADDRESS', value: 'Address' }, { key: 'EMAIL', value: 'Email' }, { key: 'PHONE', value: 'Phone' }, { key: 'COMMENT', value: 'Comment' }, { key: 'REGDATE', value: 'Reg.date' }, { key: 'LEVERAGE', value: 'Leverage' }, { key: 'BALANCE', value: 'Balance' }, { key: 'CREDIT', value: 'Credit' }]
        }
    }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4SummaryReport: {
            timeText: '交易时间：',
            downloadName: 'MT4总结报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'DEPOSIT', value: '总入金' }, { key: 'WITHDRAWL', value: '总出金' }, { key: 'INOUT', value: '总收入' }, { key: 'CREDIT', value: '总信贷' }, { key: 'VOLUME', value: '总手数' }, { key: 'COMMISSION', value: '总佣金' }, { key: 'TAXES', value: '总税费' }, { key: 'AGENT', value: '总代理佣金' }, { key: 'SWAPS', value: '总库存费' }, { key: 'PROFIT', value: '总盈亏' }, { key: 'BALANCE', value: '当前余额' }]
        }
    },
    hk: {
        mt4SummaryReport: {
            timeText: '交易時間：',
            downloadName: 'MT4總結報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'DEPOSIT', value: '總入金' }, { key: 'WITHDRAWL', value: '總出金' }, { key: 'INOUT', value: '總收入' }, { key: 'CREDIT', value: '總信貸' }, { key: 'VOLUME', value: '總手數' }, { key: 'COMMISSION', value: '總佣金' }, { key: 'TAXES', value: '總稅費' }, { key: 'AGENT', value: '總代理佣金' }, { key: 'SWAPS', value: '總庫存費' }, { key: 'PROFIT', value: '總盈虧' }, { key: 'BALANCE', value: '當前餘額' }]
        }
    },
    en: {
        mt4SummaryReport: {
            timeText: 'Trade Time：',
            downloadName: 'MT4 Summary Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'DEPOSIT', value: 'Deposit' }, { key: 'WITHDRAWL', value: 'Withdrawl' }, { key: 'INOUT', value: 'In/Out' }, { key: 'CREDIT', value: 'Credit' }, { key: 'VOLUME', value: 'Volume' }, { key: 'COMMISSION', value: 'Commission' }, { key: 'TAXES', value: 'Taxes' }, { key: 'AGENT', value: 'Agent' }, { key: 'SWAPS', value: 'Storage' }, { key: 'PROFIT', value: 'Profit' }, { key: 'BALANCE', value: 'Last Balance' }]
        }
    }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4SeregatedReport: {
            downloadName: 'MT4实时盈亏报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'BALANCE', value: '余额' }, { key: 'UNREALIZED', value: '实时浮动盈亏' }, { key: 'EQUITY', value: '净值' }]
        }
    },
    hk: {
        mt4SeregatedReport: {
            downloadName: 'MT4實時盈虧報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'BALANCE', value: '餘額' }, { key: 'UNREALIZED', value: '實時浮動盈虧' }, { key: 'EQUITY', value: '淨值' }]
        }
    },
    en: {
        mt4SeregatedReport: {
            downloadName: 'MT4 Seregated Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'BALANCE', value: 'Balance' }, { key: 'UNREALIZED', value: 'Unrealized P/L' }, { key: 'EQUITY', value: 'Equity' }]
        }
    }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4EquityReport: {
            timeText: '日期：',
            dateText: '请选择日期',
            downloadName: 'MT4净值报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'PL_BALANCE', value: '昨日余额' }, { key: 'PL_BALANCE_TMP', value: '昨日余额(MT4)', unneed: false }, { key: 'CLOSED_PL', value: '平仓盈亏' }, { key: 'DEPOSIT', value: '存取款金额' }, { key: 'BALANCE', value: '今日余额' }, { key: 'FLOATING_PL', value: '浮动盈亏' }, { key: 'CREDIT', value: '信用额' }, { key: 'EQUITY', value: '净值' }, { key: 'USED_MARGIN', value: '保证金' }, { key: 'MARGIN_FREE', value: '可用保证金' }, { key: 'BANK', value: '注释' }]
        }
    },
    hk: {
        mt4EquityReport: {
            timeText: '日期：',
            dateText: '請選擇日期',
            downloadName: 'MT4淨值報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'PL_BALANCE', value: '昨日餘額' }, { key: 'PL_BALANCE_TMP', value: '昨日餘額(MT4)', unneed: false }, { key: 'CLOSED_PL', value: '平倉盈虧' }, { key: 'DEPOSIT', value: '存取款金額' }, { key: 'BALANCE', value: '今日餘額' }, { key: 'FLOATING_PL', value: '浮動盈虧' }, { key: 'CREDIT', value: '信用額' }, { key: 'EQUITY', value: '淨值' }, { key: 'USED_MARGIN', value: '保證金' }, { key: 'MARGIN_FREE', value: '可用保證金' }, { key: 'BANK', value: '注釋' }]
        }
    },
    en: {
        mt4EquityReport: {
            timeText: 'Date：',
            dateText: 'Please Select Date',
            downloadName: 'MT4 Equity Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'PL_BALANCE', value: 'PL Balance' }, { key: 'PL_BALANCE_TMP', value: 'PL Balance(MT4)', unneed: false }, { key: 'CLOSED_PL', value: 'Closed PL' }, { key: 'DEPOSIT', value: 'Deposit' }, { key: 'BALANCE', value: 'Balance' }, { key: 'FLOATING_PL', value: 'Floating PL' }, { key: 'CREDIT', value: 'Credit' }, { key: 'EQUITY', value: 'Equity' }, { key: 'USED_MARGIN', value: 'Margin' }, { key: 'MARGIN_FREE', value: 'Free Margin' }, { key: 'BANK', value: 'Bank' }]
        }
    }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4ProfitLossReport: {
            timeText: '日期：',
            downloadName: 'MT4盈亏报表',
            loadText: '下载时间会比较长,请耐心等候...',
            sameDate: '日期不能是同一天',
            tableHead: [{ key: 'DATE', value: '日期' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'TOTAL_CLOSE_PL', value: '总平仓盈亏' }, { key: 'PREVIOUS_FLOATING', value: '之前浮动盈亏' }, { key: 'PRESENT_FLOATING', value: '当前浮动盈亏' }, { key: 'PREVIOUS_EQUITY', value: '之前净值' }, { key: 'PRESENT_EQUITY', value: '当前净值' }, { key: 'PROFITLOSS', value: '盈亏' }]
        }
    },
    hk: {
        mt4ProfitLossReport: {
            timeText: '日期：',
            downloadName: 'MT4盈虧報表',
            loadText: '下載時間會比較長,請耐心等候...',
            sameDate: '日期不能是同一天',
            tableHead: [{ key: 'DATE', value: '日期' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'TOTAL_CLOSE_PL', value: '總平倉盈虧' }, { key: 'PREVIOUS_FLOATING', value: '之前浮動盈虧' }, { key: 'PRESENT_FLOATING', value: '當前浮動盈虧' }, { key: 'PREVIOUS_EQUITY', value: '之前淨值' }, { key: 'PRESENT_EQUITY', value: '當前淨值' }, { key: 'PROFITLOSS', value: '盈虧' }]
        }
    },
    en: {
        mt4ProfitLossReport: {
            timeText: 'Date：',
            downloadName: 'MT4 Profit And Loss Report',
            loadText: 'The download time will be longer, please wait patiently...',
            sameDate: 'The dates cannot be the same',
            tableHead: [{ key: 'DATE', value: 'Date' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'TOTAL_CLOSE_PL', value: 'Total Closed PL' }, { key: 'PREVIOUS_FLOATING', value: 'Previous Floating PL' }, { key: 'PRESENT_FLOATING', value: 'Present Floating PL' }, { key: 'PREVIOUS_EQUITY', value: 'Previous Equity' }, { key: 'PRESENT_EQUITY', value: 'Present Equity' }, { key: 'PROFITLOSS', value: 'Profit/Loss' }]
        }
    }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        mt4EquityMultiReport: {
            timeText: '日期：',
            dateText: '请选择日期',
            downloadName: 'MT4净值报表',
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'TIME', value: '时间' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'OID', value: '办事处号码' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'RID', value: '地区编号' }, { key: 'GROUP', value: '组别' }, { key: 'CLOSED_PL', value: '平仓盈亏' }, { key: 'DEPOSIT', value: '存取款金额' }, { key: 'BALANCE', value: '今日余额' }, { key: 'FLOATING_PL', value: '浮动盈亏' }, { key: 'CREDIT', value: '信用额' }, { key: 'EQUITY', value: '净值' }, { key: 'USED_MARGIN', value: '保证金' }, { key: 'MARGIN_FREE', value: '可用保证金' }, { key: 'BANK', value: '注释' }]
        }
    },
    hk: {
        mt4EquityMultiReport: {
            timeText: '日期：',
            dateText: '請選擇日期',
            downloadName: 'MT4淨值報表',
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'TIME', value: '時間' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'OID', value: '辦事處號碼' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'RID', value: '地區編號' }, { key: 'GROUP', value: '組別' }, { key: 'CLOSED_PL', value: '平倉盈虧' }, { key: 'DEPOSIT', value: '存取款金額' }, { key: 'BALANCE', value: '今日餘額' }, { key: 'FLOATING_PL', value: '浮動盈虧' }, { key: 'CREDIT', value: '信用額' }, { key: 'EQUITY', value: '淨值' }, { key: 'USED_MARGIN', value: '保證金' }, { key: 'MARGIN_FREE', value: '可用保證金' }, { key: 'BANK', value: '注釋' }]
        }
    },
    en: {
        mt4EquityMultiReport: {
            timeText: 'Date：',
            dateText: 'Please Select Date',
            downloadName: 'MT4 Equity Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'TIME', value: 'Time' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'OID', value: 'Office ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'RID', value: 'Region ID' }, { key: 'GROUP', value: 'Group' }, { key: 'CLOSED_PL', value: 'Closed PL' }, { key: 'DEPOSIT', value: 'Deposit' }, { key: 'BALANCE', value: 'Balance' }, { key: 'FLOATING_PL', value: 'Floating PL' }, { key: 'CREDIT', value: 'Credit' }, { key: 'EQUITY', value: 'Equity' }, { key: 'USED_MARGIN', value: 'Margin' }, { key: 'MARGIN_FREE', value: 'Free Margin' }, { key: 'BANK', value: 'Bank' }]
        }
    }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        analyze: {
            dateText: '日期：',
            statusText: '状态：',
            status: { '-1': '所有', '0': '删除', '1': '禁用', '2': '启用', '3': '新建', '4': '未知' },
            excelName: '账户分析报表',
            desc: {
                '0': '账号在 start 有日结数据，在 end 无日结数据，并且当前在MT4无账号记录',
                '1': '账号在 start 有日结数据，在 end 无日结数据，并且当前在MT4有账号记录',
                '2': '账号在 start 无日结数据，在 end 有日结数据，并且账号的注册日期早于 start',
                '3': '账号在 start 无日结数据，在 end 有日结数据，并且账号的注册日期晚于 start',
                '4': '账号在 start 无日结数据，在 end 有日结数据，并且当前在MT4无账号记录'
            },
            description: '状态描述',
            badWeekday: '请不要选择周六，周六无日结数据.',
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'GROUP', value: '组别' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'BALANCE', value: '余额' }, { key: 'status', value: '状态' }]
        }
    },
    hk: {
        analyze: {
            dateText: '日期：',
            statusText: '狀態：',
            status: { '-1': '所有', '0': '刪除', '1': '禁用', '2': '啟用', '3': '新建', '4': '未知' },
            excelName: '賬戶分析報表',
            desc: {
                '0': '賬號在 start 有日結數據，在 end 無日結數據，并且當前在MT4無賬號記錄',
                '1': '賬號在 start 有日結數據，在 end 無日結數據，并且當前在MT4有賬號記錄',
                '2': '賬號在 start 無日結數據，在 end 有日結數據，并且賬號的注冊日期早於 start',
                '3': '賬號在 start 無日結數據，在 end 有日結數據，并且賬號的注冊日期晚於 start',
                '4': '賬號在 start 無日結數據，在 end 有日結數據，并且當前在MT4無賬號記錄'
            },
            description: '狀態描述',
            badWeekday: '請不要選擇週六，週六無日結數據.',
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'GROUP', value: '組別' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'BALANCE', value: '餘額' }, { key: 'status', value: '狀態' }]
        }
    },
    en: {
        analyze: {
            dateText: 'Date：',
            statusText: 'Status：',
            status: { '-1': 'All', '0': 'Delete', '1': 'Disable', '2': 'Enable', '3': 'Create', '4': 'Unknow' },
            excelName: 'Account Analyze Report',
            desc: {
                '0': 'The account has daily record on start and no record on end，and can\'t find account record in MT4 now',
                '1': 'The account has daily record on start and no record on end, and can find account record in MT4 now',
                '2': 'The account has daily record on end and no record on start, and the account is registered earlier than start',
                '3': 'The account has daily record on end and no record on start, and the account is registered later than start',
                '4': 'The account has daily record on end and no record on start, and can\'t find account record in MT4 now'
            },
            description: 'Status description',
            badWeekday: 'Please do not select saturday, saturday has no data.',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'GROUP', value: 'Group' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'BALANCE', value: 'Balance' }, { key: 'status', value: 'Status' }]
        }
    }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        symbolProfit: {
            excelName: '产品盈亏报表',
            endOfDayDownload: '下载日结Excel',
            nowDownload: '下载实时Excel',
            placeholder: '日结产品盈亏日期',
            warning: '请先选择一个日结产品盈亏日期',
            tableHead: [{ key: 'SYMBOL', value: '产品' }, { key: 'PREVIOUS_OPEN_VOLUME', value: '上日未平仓手数' }, { key: 'PREVIOUS_FLOATING_PL', value: '上日浮动盈亏' }, { key: 'PRESENT_FLOATING_PL', value: '今日浮动盈亏' }, { key: 'PRESENT_CLOSED_PL', value: '今日平仓盈亏' }, { key: 'PRESENT_CLOSED_SWAP', value: '今日平仓利息' }, { key: 'PRESENT_CLOSED_VOLUME', value: '今日平仓手数' }, { key: 'PRESENT_NO_COMMISSION_PL', value: '今日盈亏(未扣代理返佣)' }, { key: 'PRESENT_CLOSED_COMMISSION', value: '今日平仓佣金' }, { key: 'PRESENT_IB_COMMISSION', value: '今日代理返佣' }, { key: 'PRESENT_PL', value: '今日盈亏(客户角度)' }]
        }
    },
    hk: {
        symbolProfit: {
            excelName: '產品盈虧報表',
            endOfDayDownload: '下載日結Excel',
            nowDownload: '下載實時Excel',
            placeholder: '日結產品盈虧日期',
            warning: '請先選擇一個日結產品盈虧日期',
            tableHead: [{ key: 'SYMBOL', value: '產品' }, { key: 'PREVIOUS_OPEN_VOLUME', value: '上日未平倉手數' }, { key: 'PREVIOUS_FLOATING_PL', value: '上日浮動盈虧' }, { key: 'PRESENT_FLOATING_PL', value: '今日浮動盈虧' }, { key: 'PRESENT_CLOSED_PL', value: '今日平倉盈虧' }, { key: 'PRESENT_CLOSED_SWAP', value: '今日平倉利息' }, { key: 'PRESENT_CLOSED_VOLUME', value: '今日平倉手數' }, { key: 'PRESENT_NO_COMMISSION_PL', value: '今日盈虧(未扣代理返佣)' }, { key: 'PRESENT_CLOSED_COMMISSION', value: '今日平倉佣金' }, { key: 'PRESENT_IB_COMMISSION', value: '今日代理返佣' }, { key: 'PRESENT_PL', value: '今日盈虧(客戶角度)' }]
        }
    },
    en: {
        symbolProfit: {
            excelName: 'Symbol Profit Report',
            endOfDayDownload: 'Download Daily Excel',
            nowDownload: 'Download Realtime Excel',
            placeholder: 'Daily symbol profit date',
            warning: 'Please select a daily symbol profit date',
            tableHead: [{ key: 'SYMBOL', value: 'Symbol' }, { key: 'PREVIOUS_OPEN_VOLUME', value: 'Previous Open Volume' }, { key: 'PREVIOUS_FLOATING_PL', value: 'Previous Floating PL' }, { key: 'PRESENT_FLOATING_PL', value: 'Present Floating PL' }, { key: 'PRESENT_CLOSED_PL', value: 'Present Closed PL' }, { key: 'PRESENT_CLOSED_SWAP', value: 'Present Closed Swaps' }, { key: 'PRESENT_CLOSED_VOLUME', value: 'Present Closed Volume' }, { key: 'PRESENT_NO_COMMISSION_PL', value: 'Present PL(Without IB Commission)' }, { key: 'PRESENT_CLOSED_COMMISSION', value: 'Present Closed Commission' }, { key: 'PRESENT_IB_COMMISSION', value: 'Present IB Commission' }, { key: 'PRESENT_PL', value: 'Present PL(The customer perspective)' }]
        }
    }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        downloadReport: {
            previous: '上一级目录',
            tableHead: {
                file: '文件',
                handle: '操作'
            },
            download: '下载',
            open: '打开'
        }
    },
    hk: {
        downloadReport: {
            previous: '上一級目錄',
            tableHead: {
                file: '文件',
                handle: '操作'
            },
            download: '下載',
            open: '打開'
        }
    },
    en: {
        downloadReport: {
            previous: 'Privious Directory',
            tableHead: {
                file: 'File',
                handle: 'Handle'
            },
            download: 'Download',
            open: 'Open'
        }
    }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        floatingPL: {
            excelName: '客户浮动盈亏统计',
            endOfDayDownload: '下载日结Excel',
            nowDownload: '下载实时Excel',
            placeholder: '日结日期',
            warning: '请先选择一个日结日期',
            tableColumns: [{ key: 'LOGIN', value: '客户账号', fixed: true }, { key: 'NAME', value: '客户姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'REGDATE', value: '开户日期' }, { key: 'IB_ID', value: '代理账号' }, { key: 'ACC_NAME', value: '办事处' }, { key: 'DEPOSIT', value: '今日客户入金' }, { key: 'WITHDRAWAL', value: '今日客户出金' }, { key: 'EQUITY', value: '今日客户净值' }, { key: 'PREVIOUS_FLOATING_PL', value: '昨日未平仓盈亏' }, { key: 'FLOATING_PL', value: '今日未平仓盈亏' }, { key: 'CLOSED_PL', value: '今日平仓盈亏' }, { key: 'CLOSED_SWAPS', value: '今日平仓利息' }, { key: 'CLOSED_VOLUME', value: '今日平仓手数' }, { key: 'ADJUSTMENT', value: '客户调整' }, { key: 'CLOSED_COMMISSION', value: '今日客户佣金' }, { key: 'IB_COMMISSION', value: '今日代理自动返佣' }, { key: 'CL_F_PL', value: '客户浮动盈亏(已扣代理返佣)' }]
        }
    },
    hk: {
        floatingPL: {
            excelName: '客戶浮動盈虧統計',
            endOfDayDownload: '下載日結Excel',
            nowDownload: '下載實時Excel',
            placeholder: '日結日期',
            warning: '請先選擇一個日結日期',
            tableColumns: [{ key: 'LOGIN', value: '客戶賬號', fixed: true }, { key: 'NAME', value: '客戶姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'REGDATE', value: '開戶日期' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'ACC_NAME', value: '辦事處' }, { key: 'DEPOSIT', value: '今日客戶入金' }, { key: 'WITHDRAWAL', value: '今日客戶出金' }, { key: 'EQUITY', value: '今日客戶净值' }, { key: 'PREVIOUS_FLOATING_PL', value: '昨日未平倉盈虧' }, { key: 'FLOATING_PL', value: '今日未平倉盈虧' }, { key: 'CLOSED_PL', value: '今日平倉盈虧' }, { key: 'CLOSED_SWAPS', value: '今日平倉利息' }, { key: 'CLOSED_VOLUME', value: '今日平倉手數' }, { key: 'ADJUSTMENT', value: '客戶調整' }, { key: 'CLOSED_COMMISSION', value: '今日客戶佣金' }, { key: 'IB_COMMISSION', value: '今日代理自動返佣' }, { key: 'CL_F_PL', value: '客戶浮動盈虧(已扣代理返佣)' }]
        }
    },
    en: {
        floatingPL: {
            excelName: 'Client floating PL statistics',
            endOfDayDownload: 'Download Daily Excel',
            nowDownload: 'Download Realtime Excel',
            placeholder: 'Daily date',
            warning: 'Please select a daily date',
            tableColumns: [{ key: 'LOGIN', value: 'Login', fixed: true }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'REGDATE', value: 'Regdate' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'ACC_NAME', value: 'Office Name' }, { key: 'DEPOSIT', value: 'Deposit' }, { key: 'WITHDRAWAL', value: 'Withdrawal' }, { key: 'EQUITY', value: 'Equity' }, { key: 'PREVIOUS_FLOATING_PL', value: 'Previous Floating PL' }, { key: 'FLOATING_PL', value: 'Floating PL' }, { key: 'CLOSED_PL', value: 'Closed PL' }, { key: 'CLOSED_SWAPS', value: 'Closed Swaps' }, { key: 'CLOSED_VOLUME', value: 'Closed Volume' }, { key: 'ADJUSTMENT', value: 'Adjustment' }, { key: 'CLOSED_COMMISSION', value: 'Commission' }, { key: 'IB_COMMISSION', value: 'IB Commission' }, { key: 'CL_F_PL', value: 'Client Floating PL(Without IB Commission)' }]
        }
    }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        openTrades: {
            tableHead: [{ key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '客户姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'EQUITY', value: '客户净值' }, { key: 'CLOSED_PL', value: '今日平仓盈亏' }, { key: 'FLOATING_PL', value: '今日客户盈亏' }, { key: 'PL', value: '浮动盈亏' }, { key: 'MARGIN_LEVEL', value: '保证金水平' }],
            expandHead: {
                SYMBOL: '产品',
                BUY_VOLUME: '手数(买)',
                SELL_VOLUME: '手数(卖)',
                VOLUME: '净手数',
                PL: '浮动盈亏'
            },
            filterOptions: {
                LOGIN: '账号',
                NAME: '客户姓名',
                IB_ID: '代理账号'
            },
            excelName: '未平仓交易统计',
            symbolText: '请选择交易产品或产品组',
            filterText: '通过关键字对现有数据进行搜索'
        }
    },
    hk: {
        openTrades: {
            tableHead: [{ key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '客戶姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'EQUITY', value: '客戶净值' }, { key: 'CLOSED_PL', value: '今日平倉盈虧' }, { key: 'FLOATING_PL', value: '今日客戶盈虧' }, { key: 'PL', value: '浮動盈虧' }, { key: 'MARGIN_LEVEL', value: '保證金水平' }],
            expandHead: {
                SYMBOL: '產品',
                BUY_VOLUME: '手數(買)',
                SELL_VOLUME: '手數(賣)',
                VOLUME: '净手數',
                PL: '浮動盈虧'
            },
            filterOptions: {
                LOGIN: '賬號',
                NAME: '客戶姓名',
                IB_ID: '代理賬號'
            },
            excelName: '未平倉交易統計',
            symbolText: '請選擇交易產品或產品組',
            filterText: '通過關鍵字對現有數據進行搜索'
        }
    },
    en: {
        openTrades: {
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'EQUITY', value: 'Equity' }, { key: 'CLOSED_PL', value: 'Closed PL' }, { key: 'FLOATING_PL', value: 'Client Floating PL' }, { key: 'PL', value: 'Floating PL' }, { key: 'MARGIN_LEVEL', value: 'Margin Level' }],
            expandHead: {
                SYMBOL: 'Symbol',
                BUY_VOLUME: 'Volume(Buy)',
                SELL_VOLUME: 'Volume(Sell)',
                VOLUME: 'Volume',
                PL: 'Floating PL'
            },
            filterOptions: {
                LOGIN: 'Login',
                NAME: 'Name',
                IB_ID: 'IB Account'
            },
            excelName: 'Open Trades Statistics',
            symbolText: 'Please select symbols or securities',
            filterText: 'Search existing data by keyword'
        }
    }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        profitTopList: {
            excelName: '盈利Top榜',
            startTime: '开始日期',
            endTime: '结束日期',
            profitType: { 'weekly': '周结', 'monthly': '月结', 'daily': '日结' },
            topTxt: 'Top榜前',
            profitTypeTxt: '盈利类型：',
            downloadTxt: '下载Excel',
            searchTxt: '搜 索',
            tableHead: [{ key: 'LOGIN', value: '客户账号' }, { key: 'NAME', value: '客户姓名' }, { key: 'CURRENCY', value: '入金货币' }, { key: 'IB_ID', value: '代理账号' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'ACC_NAME', value: '地区' }],
            weekly: [{ key: 'FLOATING_THIS_WEEK', value: '今周相对浮动' }, { key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' }, { key: 'CLOSED_PL_THIS_WEEK', value: '今周平仓盈亏' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' }, { key: 'CLOSED_LOTS_THIS_WEEK', value: '今周平仓手数' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金净值' }],
            monthly: [{ key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金净值' }],
            daily: [{ key: 'FLOATING_TODAY', value: '今日相对浮动' }, { key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' }, { key: 'CLOSED_PL_TODAY', value: '今日平仓盈亏' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' }, { key: 'CLOSED_LOTS_TODAY', value: '今日平仓手数' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金净值' }]
        }
    },
    hk: {
        profitTopList: {
            excelName: '盈利Top榜',
            startTime: '開始日期',
            endTime: '結束日期',
            profitType: { 'weekly': '周結', 'monthly': '月結', 'daily': '日結' },
            topTxt: 'Top榜前',
            profitTypeTxt: '盈利類型：',
            downloadTxt: '下載Excel',
            searchTxt: '搜 索',
            tableHead: [{ key: 'LOGIN', value: '客戶賬號' }, { key: 'NAME', value: '客戶姓名' }, { key: 'CURRENCY', value: '入金貨幣' }, { key: 'IB_ID', value: '代理賬號' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'ACC_NAME', value: '地區' }],
            weekly: [{ key: 'FLOATING_THIS_WEEK', value: '今周相對浮動' }, { key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' }, { key: 'CLOSED_PL_THIS_WEEK', value: '今周平倉盈虧' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' }, { key: 'CLOSED_LOTS_THIS_WEEK', value: '今周平倉手數' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' }],
            monthly: [{ key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' }],
            daily: [{ key: 'FLOATING_TODAY', value: '今日相對浮動' }, { key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' }, { key: 'CLOSED_PL_TODAY', value: '今日平倉盈虧' }, { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' }, { key: 'CLOSED_LOTS_TODAY', value: '今日平倉手數' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' }, { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' }, { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' }, { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' }]
        }
    },
    en: {
        profitTopList: {
            excelName: 'Profit Top List',
            startTime: 'Start Date',
            endTime: 'End Date',
            profitType: { 'weekly': 'Weekly', 'monthly': 'Monthly', 'daily': 'Daily' },
            topTxt: 'Top',
            profitTypeTxt: 'Profit Type：',
            downloadTxt: 'Download Excel',
            searchTxt: 'Search',
            tableHead: [{ key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'ACC_NAME', value: 'Region Name' }],
            weekly: [{ key: 'FLOATING_THIS_WEEK', value: 'Floating This Week' }, { key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' }, { key: 'CLOSED_PL_THIS_WEEK', value: 'Closed PL This Week' }, { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' }, { key: 'CLOSED_LOTS_THIS_WEEK', value: 'Closed Lots This Week' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' }, { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' }, { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' }, { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' }],
            monthly: [{ key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' }, { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' }, { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' }, { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' }, { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' }],
            daily: [{ key: 'FLOATING_TODAY', value: 'Floating Today' }, { key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' }, { key: 'CLOSED_PL_TODAY', value: 'Closed PL Today' }, { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' }, { key: 'CLOSED_LOTS_TODAY', value: 'Closed Lots Today' }, { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' }, { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' }, { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' }, { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' }]
        }
    }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        closedTradesReport: {
            posText: '仓位类型：',
            timeText: '开仓时间：',
            ticketText: '交易单号：',
            groupText: '组别：',
            symbolText: '产品：',
            loginText: '账号：',
            ibNumText: '代理账号：',
            regionText: '地区编号：',
            securityText: '产品类型：',
            currencyText: '货币：',
            startTime: '开始时间',
            endTime: '结束时间',
            downloadName: '交易价值报表',
            openTime: '开仓时间',
            closedTime: '平仓时间',
            cmdMapping: { 0: '买入', 1: '卖出' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "未平仓", "1": "已平仓" },
            loadText: '正在下载,请稍候...',
            tableHead: [{ key: 'TICKET', value: '单号' }, { key: 'LOGIN', value: '账号' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '组别' }, { key: 'CURRENCY', value: '货币' }, { key: 'IB_ID', value: '代理账号' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '办事处号码' }, { key: 'OFFICE_NAME', value: '所属办事处' }, { key: 'RID', value: '地区编号' }, { key: 'ACC_NAME', value: '所属地区' }, { key: 'cmd', value: '交易类型' }, { key: 'VOLUME', value: '手数' }, { key: 'SYMBOL', value: '产品' }, { key: 'security', value: '产品类型' }, { key: 'SYMBOL_CONTRACT_SIZE', value: '合约大小' }, { key: 'OPEN_TIME', value: '开仓时间' }, { key: 'OPEN_PRICE', value: '开仓价' }, { key: 'CLOSE_TIME', value: '平仓时间' }, { key: 'CLOSE_PRICE', value: '平仓价' }, { key: 'OPEN_VALUE', value: '开仓价值' }, { key: 'CLOSE_VALUE', value: '平仓价值' }, { key: 'TOTAL_VALUE', value: '交易单总价值' }, { key: 'COMMISSION', value: '佣金' }, { key: 'TAXES', value: '税金' }, { key: 'COMMISSION_AGENT', value: '代理佣金' }, { key: 'SWAPS', value: '利息' }, { key: 'PROFIT', value: '盈亏' }, { key: 'PIPES', value: '价位差' }, { key: 'COMMENT', value: '注释' }]
        }
    },
    hk: {
        closedTradesReport: {
            posText: '倉位類型：',
            timeText: '開倉時間：',
            ticketText: '交易單號：',
            groupText: '組別：',
            symbolText: '產品：',
            loginText: '賬號：',
            ibNumText: '代理賬號：',
            regionText: '地區編號：',
            securityText: '產品類型：',
            currencyText: '貨幣：',
            startTime: '開始時間',
            endTime: '結束時間',
            downloadName: '交易價值報表',
            openTime: '開倉時間',
            closedTime: '平倉時間',
            cmdMapping: { 0: '買入', 1: '賣出' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "未平倉", "1": "已平倉" },
            loadText: '正在下載,請稍候...',
            tableHead: [{ key: 'TICKET', value: '單號' }, { key: 'LOGIN', value: '賬號' }, { key: 'NAME', value: '姓名' }, { key: 'GROUP', value: '組別' }, { key: 'CURRENCY', value: '貨幣' }, { key: 'IB_ID', value: '代理賬號' },
            // { key: 'IB_NAME', value: '代理姓名' },
            { key: 'OID', value: '辦事處號碼' }, { key: 'OFFICE_NAME', value: '所屬辦事處' }, { key: 'RID', value: '地區編號' }, { key: 'ACC_NAME', value: '所屬地區' }, { key: 'cmd', value: '交易類型' }, { key: 'VOLUME', value: '手數' }, { key: 'SYMBOL', value: '產品' }, { key: 'security', value: '產品類型' }, { key: 'SYMBOL_CONTRACT_SIZE', value: '合約大小' }, { key: 'OPEN_TIME', value: '開倉時間' }, { key: 'OPEN_PRICE', value: '開倉價' }, { key: 'CLOSE_TIME', value: '平倉時間' }, { key: 'CLOSE_PRICE', value: '平倉價' }, { key: 'OPEN_VALUE', value: '開倉價值' }, { key: 'CLOSE_VALUE', value: '平倉價值' }, { key: 'TOTAL_VALUE', value: '交易單總價值' }, { key: 'COMMISSION', value: '佣金' }, { key: 'TAXES', value: '稅金' }, { key: 'COMMISSION_AGENT', value: '代理佣金' }, { key: 'SWAPS', value: '利息' }, { key: 'PROFIT', value: '盈虧' }, { key: 'PIPES', value: '價位差' }, { key: 'COMMENT', value: '注釋' }]
        }
    },
    en: {
        closedTradesReport: {
            posText: 'Type：',
            timeText: 'Open Time：',
            ticketText: 'Ticket：',
            groupText: 'Group：',
            symbolText: 'Symbol：',
            loginText: 'Login：',
            ibNumText: 'IB Account：',
            regionText: 'Region ID：',
            securityText: 'Security：',
            currencyText: 'Currency：',
            startTime: 'Start Time',
            endTime: 'End Time',
            downloadName: 'Closed Trades Report',
            openTime: 'Open Time',
            closedTime: 'Closed Time',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "Open", "1": "Closed" },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [{ key: 'TICKET', value: 'Ticket' }, { key: 'LOGIN', value: 'Login' }, { key: 'NAME', value: 'Name' }, { key: 'GROUP', value: 'Group' }, { key: 'CURRENCY', value: 'Currency' }, { key: 'IB_ID', value: 'IB Account' },
            // { key: 'IB_NAME', value: 'IB Name' },
            { key: 'OID', value: 'Office ID' }, { key: 'OFFICE_NAME', value: 'Office Name' }, { key: 'RID', value: 'Region ID' }, { key: 'ACC_NAME', value: 'Region Name' }, { key: 'cmd', value: 'Cmd' }, { key: 'VOLUME', value: 'Volume' }, { key: 'SYMBOL', value: 'Symbol' }, { key: 'security', value: 'Security' }, { key: 'SYMBOL_CONTRACT_SIZE', value: 'Contract Size' }, { key: 'OPEN_TIME', value: 'Open Time' }, { key: 'OPEN_PRICE', value: 'Open Price' }, { key: 'CLOSE_TIME', value: 'Close Time' }, { key: 'CLOSE_PRICE', value: 'Close Price' }, { key: 'OPEN_VALUE', value: 'Open Value' }, { key: 'CLOSE_VALUE', value: 'Close Value' }, { key: 'TOTAL_VALUE', value: 'Total Value' }, { key: 'COMMISSION', value: 'Commission' }, { key: 'TAXES', value: 'Taxes' }, { key: 'COMMISSION_AGENT', value: 'Commission Agent' }, { key: 'SWAPS', value: 'Swaps' }, { key: 'PROFIT', value: 'Profit' }, { key: 'PIPES', value: 'Pipes' }, { key: 'COMMENT', value: 'Comment' }]
        }
    }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__managerOperateRecord__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loginRecord__ = __webpack_require__(937);



var recordLanguages = [__WEBPACK_IMPORTED_MODULE_0__managerOperateRecord__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__loginRecord__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (recordLanguages);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        managerOperateRecord: {
            typeText: '操作类型：',
            operateDay: '操作日期：',
            downloadName: 'MT4经理操作记录',
            sheetNames: ['操作日志', '操作统计'],
            noData: {
                noRecordYesterday: '从MT4日志没有找到对应的经理操作记录',
                noLogFindInDB: 'MT4日志没有上传到数据库',
                noRecordFromMT4: '从MT4服务器日志中未发现记录(实时查询)',
                errorOccurred: '从MT4获取日志时发生问题(实时查询)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "重开交易单",
                "2": "删除交易单",
                "3": "更改开仓价格",
                // 4: "更改平仓价格",
                "5": "更改平仓信息",
                "6": "修复余额",
                "7": "更改出入金金额",
                "8": "更改交易单类型",
                "9": "帮客户平仓",
                "10": "帮客户建仓",
                "999": "其他(更改账号/更新等)"
            },
            summaryHead: [{ key: 'operate_by', value: '操作人' }, { key: 'operate_name', value: '操作人名称' }, { key: '1', value: '重开交易单' }, { key: '2', value: '删除交易单' }, { key: '3', value: '更改开仓价格' }, { key: '5', value: '更改平仓信息' }, { key: '6', value: '修复余额' }, { key: '7', value: '更改出入金金额' }, { key: '8', value: '更改交易单类型' }, { key: '9', value: '帮客户平仓' }, { key: '10', value: '帮客户建仓' }, { key: '999', value: '其他(更改账号/更新等)' }],
            tableHead: [{ key: 'operate_date', value: '操作时间' }, { key: 'operate_by', value: '操作人' }, { key: 'operate_name', value: '操作人名称' }, { key: 'client', value: '客户账号' }, { key: 'client_name', value: '客户名称' }, { key: 'ticket', value: '交易单号' }, { key: 'TYPE', value: '动作' }, { key: 'old_cmd', value: '更改前指令' }, { key: 'new_cmd', value: '更改后指令' }, { key: 'old_volume', value: '更改前手数' }, { key: 'new_volume', value: '更改后手数' }, { key: 'old_symbol', value: '更改前产品' }, { key: 'new_symbol', value: '更改后产品' }, { key: 'old_op', value: '更改前开仓价' }, { key: 'new_op', value: '更改后开仓价' }, { key: 'old_cp', value: '更改前平仓价' }, { key: 'new_cp', value: '更改后平仓价' }, { key: 'old_profit', value: '更改前盈亏' }, { key: 'new_profit', value: '更改后盈亏' }]
        }
    },
    hk: {
        managerOperateRecord: {
            typeText: '操作類型：',
            operateDay: '操作日期：',
            downloadName: 'MT4經理操作記錄',
            sheetNames: ['操作日志', '操作統計'],
            noData: {
                noRecordYesterday: '從MT4日誌沒有找到對應的經理操作記錄',
                noLogFindInDB: 'MT4日誌沒有上傳到數據庫',
                noRecordFromMT4: '從MT4服務器日誌中未發現記錄(實時查詢)',
                errorOccurred: '從MT4獲取日誌時發生問題(實時查詢)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "重開交易單",
                "2": "刪除交易單",
                "3": "更改開倉價格",
                // 4: "更改平仓价格",
                "5": "更改平倉单信息",
                "6": "修復餘額",
                "7": "更改出入金金額",
                "8": "更改交易单类型",
                "9": "幫客戶平倉",
                "10": "幫客戶建倉",
                "999": "其他(更改帳號/更新等)"
            },
            summaryHead: [{ key: 'operate_by', value: '操作人' }, { key: 'operate_name', value: '操作人名稱' }, { key: '1', value: '重開交易單' }, { key: '2', value: '刪除交易單' }, { key: '3', value: '更改開倉價格' }, { key: '5', value: '更改平倉单信息' }, { key: '6', value: '修復餘額' }, { key: '7', value: '更改出入金金額' }, { key: '8', value: '更改交易单类型' }, { key: '9', value: '幫客戶平倉' }, { key: '10', value: '幫客戶建倉' }, { key: '999', value: '其他(更改帳號/更新等)' }],
            tableHead: [{ key: 'operate_date', value: '操作時間' }, { key: 'operate_by', value: '操作人' }, { key: 'operate_name', value: '操作人名稱' }, { key: 'client', value: '客戶賬號' }, { key: 'client_name', value: '客戶名稱' }, { key: 'ticket', value: '交易單號' }, { key: 'TYPE', value: '動作' }, { key: 'old_cmd', value: '更改前指令' }, { key: 'new_cmd', value: '更改后指令' }, { key: 'old_volume', value: '更改前手數' }, { key: 'new_volume', value: '更改后手數' }, { key: 'old_symbol', value: '更改前產品' }, { key: 'new_symbol', value: '更改后產品' }, { key: 'old_op', value: '更改前開倉價' }, { key: 'new_op', value: '更改后開倉價' }, { key: 'old_cp', value: '更改前平倉價' }, { key: 'new_cp', value: '更改后平倉價' }, { key: 'old_profit', value: '更改前盈虧' }, { key: 'new_profit', value: '更改后盈虧' }]
        }
    },
    en: {
        managerOperateRecord: {
            typeText: 'Operate Type：',
            operateDay: 'Operate Day：',
            downloadName: 'MT4 Manager Operate Record',
            sheetNames: ['Operate Log', 'Operate statistics'],
            noData: {
                noRecordYesterday: 'No corresponding manager operation record found from MT4 logs',
                noLogFindInDB: 'MT4 logs not upload to mysql database',
                noRecordFromMT4: 'No records found from MT4 server logs (real-time query)',
                errorOccurred: 'A problem occurred while getting logs from MT4 (real-time query)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "Reopen Order",
                "2": "Delete Order",
                "3": "Update Open Order Open Price",
                // 4: "更改平仓价格",
                "5": "Update Closed Order",
                "6": "Fix Balance",
                "7": "Update Balance Amount",
                "8": "Change Order Cmd",
                "9": "Close Order By Manager",
                "10": "Open Order By Manager",
                "999": "Other"
            },
            summaryHead: [{ key: 'operate_by', value: 'Manager Account' }, { key: 'operate_name', value: 'Manager Name' }, { key: '1', value: 'Reopen Order' }, { key: '2', value: 'Delete Order' }, { key: '3', value: 'Update Open Order Open Price' }, { key: '5', value: 'Update Closed Order' }, { key: '6', value: 'Fix Balance' }, { key: '7', value: 'Update Balance Amount' }, { key: '8', value: 'Change Order Cmd' }, { key: '9', value: 'Close Order By Manager' }, { key: '10', value: 'Open Order By Manager' }, { key: '999', value: 'Other' }],
            tableHead: [{ key: 'operate_date', value: 'Time' }, { key: 'operate_by', value: 'Manager Account' }, { key: 'operate_name', value: 'Manager Name' }, { key: 'client', value: 'Login' }, { key: 'client_name', value: 'Name' }, { key: 'ticket', value: 'Ticket' }, { key: 'TYPE', value: 'Action' }, { key: 'old_cmd', value: 'Old Cmd' }, { key: 'new_cmd', value: 'New Cmd' }, { key: 'old_volume', value: 'Old Volume' }, { key: 'new_volume', value: 'New Volume' }, { key: 'old_symbol', value: 'Old Symbol' }, { key: 'new_symbol', value: 'New Symbol' }, { key: 'old_op', value: 'Old Open Price' }, { key: 'new_op', value: 'New Open Price' }, { key: 'old_cp', value: 'Old Close Price' }, { key: 'new_cp', value: 'New Close Price' }, { key: 'old_profit', value: 'Old Profit' }, { key: 'new_profit', value: 'New Profit' }]
        }
    }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    cn: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4登录记录',
            tableHead: [{ key: 'ip', value: 'IP' }, { key: 'login', value: '交易账号' }, { key: 'last_login_day', value: '最后登入日期' }, { key: 'name', value: '客户名称' }, { key: 'currency', value: '入金货币' }, { key: 'country', value: '国家' }, { key: 'ib_id', value: '代理账号' }, { key: 'office_name', value: '所属办事处' }, { key: 'oid', value: '办事处号码' }, { key: 'acc_name', value: '所属地区' }, { key: 'rid', value: '地区编号' }],
            searchKeys: { ip: 'IP', login: '交易账号' },
            validWarning: '请输入正确的值'
        }
    },
    hk: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4登入記錄',
            tableHead: [{ key: 'ip', value: 'IP' }, { key: 'login', value: '交易賬號' }, { key: 'last_login_day', value: '最後登入日期' }, { key: 'name', value: '客戶名稱' }, { key: 'currency', value: '入金貨幣' }, { key: 'country', value: '國家' }, { key: 'ib_id', value: '代理賬號' }, { key: 'office_name', value: '所屬辦事處' }, { key: 'oid', value: '辦事處號碼' }, { key: 'acc_name', value: '所屬地區' }, { key: 'rid', value: '地區編號' }],
            searchKeys: { ip: 'IP', login: '交易賬號' },
            validWarning: '請輸入正確的值'
        }
    },
    en: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4 Login Records',
            tableHead: [{ key: 'ip', value: 'IP' }, { key: 'login', value: 'Login' }, { key: 'last_login_day', value: 'Last Login Day' }, { key: 'name', value: 'Name' }, { key: 'currency', value: 'Currency' }, { key: 'country', value: 'Country' }, { key: 'ib_id', value: 'IB Account' }, { key: 'office_name', value: 'Office Name' }, { key: 'oid', value: 'Office ID' }, { key: 'acc_name', value: 'Region Name' }, { key: 'rid', value: 'Region ID' }],
            searchKeys: { ip: 'IP', login: 'Login' },
            validWarning: 'Please enter the correct value'
        }
    }
});

/***/ })
],[426]);


// WEBPACK FOOTER //
// static/js/app.22578f33b3ac62c7dbf9.js